import React from "react";
import "./style.css";
import axios from "axios";

//import { isEmptyReturnDefault, isEmpty } from "../utils/commonUtil";
//import { log } from "util";

import { configuration } from "../appConfig";

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class Car extends React.Component {
  state = {
    deg: 0,
    flipView: true,
    vinfolderList: [],
  };
  userClick = () => {
    alert();
    this.props.userClick();
  };

  filterAction = (data) => {
    //const dentInfo = this.state.vinfolderList;
    const { result } = this.props;

    if (result && result.scanresult && result.scanresult.length > 0) {
      // array[array.findIndex(x => x.name == 'string 1')]
      let sample =
        result.scanresult[result.scanresult.findIndex((x) => x.part === data)];
      return sample;
    }
    return {};
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );
      const scanResult = response && response.data[0];
      if (!scanResult) {
        return;
      }

      scanResult.resultTXT && scanResult.resultTXT.scanresult &&
        scanResult.resultTXT.scanresult.filter((row) => {
          if (row.size) {
            let size = row.size - (row.size % 10);
            return (row.size = row.size % 10 >= 5 ? size + 10 : size);
          } else {
            return row;
          }
        });

      this.setState({ vinfolderList: scanResult });
    } else {
      this.props.history.push("/login");
    }
  };

  componentDidMount() {
    //  Swal.fire('Hello world!');
    //  Swal.fire('Oops...', 'Something went wrong!', 'error');
    //  const selectedFile = localStorage.getItem("selectedFile");
    //   this.setState({vinNumber:selectedFile})
    //   this.getData(selectedFile);
    this.vinFolderList();
  }
  dentTable = (part) => {
    return (
      <React.Fragment>
        {this.filterAction(part).Amount}/&#216;
        {this.filterAction(part).size}
      </React.Fragment>
    );
  };
  render() {
    const { userClick } = this.props;
    const { deg } = this.state;

    return (
      // <div  style={{ display: "block", margin: "auto",height:'100%',width:'100%' }}>
      <div
        className="two-d-img row"
        style={{
          display: "block",
          margin: "auto",
          width: 600,
          // height: 750,
          // padding: 18,
          // width: "100%",
          //     position: "relative"
        }}
      >
        <button
          className="btn btn-outline-danger text-danger"
          style={{
            float: "right",
            cursor: "pointer",
            display: this.props.display ? "block" : "none",
            position: "absolute",
            right: "5px",
            top: "5px",
          }}
          onClick={() => {
            this.setState({
              deg: this.state.deg + 180,
              flipView: !this.state.flipView,
            });
          }}
        >
          <i className="fa fa-refresh"></i> Rotate 180
          {/* <img src="shapes/r.png" width="30" /> */}
        </button>

        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className={this.state.flipView ? "frame left" : "frame right"}
            onClick={() => userClick("LeftRoofFrame")}
            style={{
              cursor: "pointer",

              backgroundColor: `${
                this.filterAction("LeftRoofFrame").Amount ? "" : "#fff"
              }`,
            }}
          >
            <div className="RF left">LRF</div>
            <span className="RF-text">
              {/* A:{this.filterAction("LeftRoofFrame").Amount} */}
              {this.dentTable("LeftRoofFrame")}
              {/* |B:{this.filterAction("LeftRoofFrame").size}
              |C:{this.filterAction("LeftRoofFrame").size} */}
            </span>
          </div>

          <div
            className={this.state.flipView ? "frame right" : "frame left"}
            onClick={() => userClick("RightRoofFrame")}
            style={{
              cursor: "pointer",
              backgroundColor: `${
                this.filterAction("RightRoofFrame").Amount ? "" : "#fff"
              }`,
            }}
          >
            <div className="RF right">RRF</div>
            <span className="RF-text">
              {this.dentTable("RightRoofFrame")}
              {/* |B:{this.filterAction("RightRoofFrame").Amount}
              |C:{this.filterAction("RightRoofFrame").size} */}
            </span>
          </div>
        </div>

        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1030 1600"
          enableBackground="new 0.0 0.0 1300 1600"
          width="100%"
          height="100%"
          space="preserve"
          style={{ transform: `rotate(${deg}deg)` }}
        >
          <g id="layer101">
            {/* <path
              className="st0"
              d="M512.4,1596.9c-1.3-2.5-1.3-3.6-0.4-6c0.7-1.5,1.8-3.4,2.6-4c1.1-0.9,1.4-4.7,1.4-17.5V1553h-92.4
		c-105.1,0-99.4,0.4-106.8-7.9c-4.8-5.4-6.8-9.6-10.1-21c-1.7-5.9-3-8.7-4.3-9.2c-1.1-0.4-3.2-2.1-4.9-3.8c-2.7-2.9-2.9-3.7-3-10.9
		c0-10,0.7-12.4,5.5-17.3l4-4.1l-2-2.8c-1.1-1.6-2-3-2-3.3c0-0.3-1.8-3.5-4-7.1c-4.5-7.4-4.6-8.1-2.4-13.3c0.9-2.1,2.7-6.4,4-9.5
		c5.5-13.3,7.7-18.6,10-23.6c1.3-2.9,2.4-5.9,2.4-6.7c0-1.3,24.5-1.5,202.4-1.5h202.3l2.6,3.8c1.4,2,4.1,6.6,6,10.2
		c5.7,10.7,14.8,26.4,15.8,27.5c1.6,1.6,1,5.4-1.4,9.3c-1.2,2-2.8,4.6-3.5,5.7s-2.4,4.3-3.9,7.2l-2.7,5.2l3.2,3.1
		c5.6,5.3,7.9,13.6,6.1,22.1c-1.3,6.2-5.4,10.9-9.3,10.9c-2.4,0-2.6,0.3-2.6,4.8c0,8.9-4.7,21.8-9.6,26.4
		c-6.5,5.9-3.9,5.8-102.4,5.8h-90v16.8c0.1,13.1,0.4,17.1,1.5,18.6c1.7,2.3,1.9,6.9,0.5,9.7c-0.8,1.5-2.1,1.9-6,1.9
		C514.5,1600,513.9,1599.7,512.4,1596.9z M710.9,1541.4c3.5-4,5.8-10.3,7.7-21.6l0.6-3.8H515.6c-112,0-203.6,0.3-203.6,0.8
		c0,2.3,4.2,14.8,6.2,18.4c2.7,5,7.1,9,10.7,9.9c1.4,0.4,87.1,0.6,190.5,0.5l187.8-0.1L710.9,1541.4z M728.5,1508
		c1.4-1.6,1.9-3.6,1.8-8.6c0-6.2-0.3-6.8-3.9-10.5l-3.8-3.9l-208.1,0.2l-208,0.3l-3.2,4.9c-4.4,6.5-4.5,11.2-0.2,16.1l3.1,3.5h210.2
		C726.6,1510,726.7,1510,728.5,1508z M314.5,1476.2c2.6-2.1,16.1-14.1,20.9-18.7c1.8-1.6,4.9-4.5,6.9-6.3c2-1.8,3.7-3.6,3.7-4.1
		c0-0.4-3.9-4.3-8.7-8.7c-4.8-4.3-11.4-10.5-14.7-13.6c-3.4-3.2-6.4-5.8-6.7-5.8c-0.5,0-3.8,6.9-8.5,18.3c-1.4,3.4-3.7,8.6-5,11.5
		c-1.3,2.9-2.4,6.3-2.4,7.6c0,1.4,2.2,6,4.8,10.3c2.6,4.3,5.1,8.6,5.5,9.6C311.1,1478.4,311.6,1478.4,314.5,1476.2z M376.3,1474.3
		c-2.2-2.1-8.9-8.3-14.8-13.8c-6-5.5-11.2-10-11.6-10c-0.8,0-11.5,9.4-20.8,18.4c-2.5,2.4-5.6,5-6.8,5.8c-1.3,0.9-2.3,1.9-2.3,2.4
		s13.4,0.9,30.2,0.9h30.2L376.3,1474.3z M637,1473.5v-4.5H513.5H390v4.5v4.5h123.5H637V1473.5z M706,1477.6c0-0.6-7.1-7.5-15.6-15.1
		c-4.3-3.8-9-8.2-10.3-9.7c-2.5-2.8-4.6-3.6-5.3-1.9c-0.1,0.4-2.8,3-5.9,5.7c-3,2.7-9.7,8.6-14.7,13.2l-9.2,8.2h30.5
		C692.3,1478,706,1477.8,706,1477.6z M721.8,1475.3c1-1.6,2.6-4.1,3.4-5.8c0.9-1.6,2.9-5.5,4.6-8.5c2.2-3.9,2.8-5.8,2.1-6.7
		c-0.6-0.7-1.9-2.7-2.8-4.5c-1-1.8-3-5.5-4.6-8.3c-5.5-9.7-7.4-13.1-10-17.7c-1.4-2.7-2.9-4.8-3.4-4.8s-2.6,1.6-4.7,3.5
		c-2.2,2-7.2,6.6-11.3,10.3c-4.1,3.7-8.7,7.9-10.3,9.5c-1.6,1.5-3.3,2.7-3.8,2.7c-2.1,0-0.8,2.5,3.4,6.4
		c25.5,24,28.7,26.6,32.2,26.6C719,1478,720.4,1477.3,721.8,1475.3z M384,1447.5c0-15.1-0.3-27.5-0.8-27.5c-0.4,0-3.2,2.4-6.3,5.3
		c-3.1,2.8-9.7,9-14.8,13.6l-9.1,8.4l4.7,4.4c2.7,2.4,8.2,7.4,12.3,11.1c4.1,3.7,8.6,7.9,9.9,9.5c1.4,1.5,2.9,2.7,3.3,2.7
		C383.7,1475,384,1462.6,384,1447.5z M650.6,1467.5c3.4-3.3,17.7-16.2,20.4-18.4l2.5-2.1l-5-4.6c-2.7-2.6-9.4-8.7-14.7-13.6l-9.8-9
		v26.7v26.8l2.2-1.9C647.5,1470.4,649.4,1468.6,650.6,1467.5z M637,1452v-13h-23.5H590v3v3h-75h-75v-3v-3h-25h-25v13v13h123.5H637
		V1452z M359.8,1435.3c14.7-13.3,15.5-14,18.2-16.2l2.5-2l-30-0.1h-30l5,4.8c8.1,7.7,24,22.2,24.3,22.2
		C350,1444,354.5,1440.1,359.8,1435.3z M679.4,1441.4c3.8-3.3,16.3-14.4,22.4-20.1l4.5-4.3h-29.4h-29.4l10,9.4
		c5.5,5.2,11.8,11.2,14,13.4c2.2,2.2,4.2,4,4.4,4.1S677.6,1442.8,679.4,1441.4z M587,1436.5v-5.5h-71h-71v5.5v5.5h71h71V1436.5z
		 M440,1431.5v-3.5h75h75v3.5v3.5h23.5H637v-9v-9H513.5H390v9v9h25h25V1431.5z"
            />
            <path
              className="st0"
              d="M333.4,1543c-4.9-2-6.9-9.5-4.3-15.4c1.7-3.6,5.7-4.6,18.6-4.6c14,0,16.8,1.1,17.8,7c0.9,5.1-0.1,9.3-2.7,11.6
		c-1.7,1.6-3.9,1.9-14.7,2.1C341.2,1543.9,334.5,1543.5,333.4,1543z M361.3,1536.8c0.9-1.8,1.5-3.5,1.3-3.8
		c-0.1-0.3-0.8-1.7-1.6-3.2l-1.3-2.8h-12.3c-12,0-12.3,0-14.3,2.6c-1.2,1.5-2.1,3.2-2.1,3.9c0,0.7,0.9,2.4,2.1,3.9
		c2,2.6,2.2,2.6,14.3,2.6h12.4L361.3,1536.8z"
            />
            <path
              className="st0"
              d="M665.2,1541.5c-5.5-4.6-4.7-15.2,1.3-17.5c3.6-1.4,25.8-1.3,28.8,0.1c3,1.4,4.7,4.8,4.7,9.5
		c0,8.4-3.8,10.4-19.9,10.4C668.8,1544,668,1543.9,665.2,1541.5z M694.4,1537.8c2-2.9,2-7.2,0-9.2c-2.3-2.4-25-2.3-27.6,0.1
		c-2.2,2-2.3,6.1-0.2,9.1c1.4,2.1,2.2,2.2,13.9,2.2S693,1539.9,694.4,1537.8z"
            /> */}
            {/* <path
              className="st0"
              d="M332,1503c-1.1-1.1-2-3.3-2-5c0-2.5,0.6-3.3,3.2-4.4c3.5-1.5,5.6-1.1,7.5,1.3c1.8,2.4,1.5,5.5-0.7,7.9
		C337.4,1505.5,334.6,1505.6,332,1503z"
            />
            <path
              className="st0"
              d="M451.9,1504c-2-1.2-3.2-5.4-2.4-8.1c1.4-4.4,10.3-4,10.7,0.4C460.7,1503.5,457,1507,451.9,1504z"
            />
            <path
              className="st0"
              d="M570.1,1503.1c-2.4-2.4-2.8-7.3-0.6-9.1c3.6-3,10.5-0.1,10.5,4.5C580,1503.7,573.7,1506.7,570.1,1503.1z"
            />
            <path
              className="st0"
              d="M688.5,1502.5c-3-2.9-3.1-4.6-0.7-7.3c2.9-3.4,5.8-3.7,8.7-0.8c1.4,1.4,2.5,3.2,2.5,4.1c0,2.1-4.4,6.5-6.5,6.5
		C691.6,1505,689.8,1503.9,688.5,1502.5z"
            /> */}
            <path
              className="st0"
              d="M418.5,1362.4c-6-0.7-15.5-1.8-21-2.4c-5.5-0.5-14.3-1.7-19.5-2.5c-5.2-0.8-13.2-2-17.8-2.5
		c-4.6-0.6-12.9-1.9-18.5-3s-11.4-2-12.9-2H326v-55.2c0-50.6,0.2-56.1,1.9-64.8c1.1-5.2,3.1-16,4.6-24c1.4-8,3.6-20.1,4.9-27
		c1.3-6.9,3.6-18.9,5-26.7c5.4-29.4,7.9-43.1,10.1-54.8c1.3-6.6,3.5-18.7,5-27c1.5-8.2,3.6-19.3,4.8-24.5c1.3-6.4,2.2-15.8,2.8-29
		c0.4-10.7,1.5-37,2.4-58.5c1.2-25.5,1.8-60.1,1.9-100c0.1-52.4-0.2-66.3-2.1-98.5c-4.3-71.1-4-68-9.9-90.5
		c-1.3-4.9-2.4-9.8-2.4-10.7c0-0.9-1.1-5.7-2.4-10.5c-1.3-4.8-3.5-14-5-20.3c-2.6-11.3-5.6-23.5-9.1-37.5c-1-3.8-2.2-9-2.7-11.5
		s-2.1-8.6-3.4-13.5c-1.3-5-2.4-10.3-2.4-11.8s-0.4-2.7-1-2.7c-0.7,0-1-48.8-1-144.4V262.3l5.7-1.2c3.1-0.6,6.9-1.1,8.5-1.1
		s9.3-1.1,17.1-2.4c13.2-2.2,32.5-5.2,59.2-9.2c8.4-1.2,12.6-2.4,17.8-5l6.7-3.4h72.4h72.4l5.5,3.3c5.9,3.6,4.1,3.2,48.7,9.3
		c10.2,1.4,25.9,3.6,35,5c9.1,1.3,18.4,2.4,20.8,2.4h4.2l0.1,144.3c0.1,79.3,0,145.6-0.1,147.2c-0.1,1.7-0.5,3.5-1,4
		c-0.4,0.6-1,2.4-1.2,4c-0.3,1.7-1.5,6.6-2.8,11c-1.2,4.4-3.3,12.1-4.7,17c-1.3,5-3.5,12.8-4.8,17.5s-3.5,13-5,18.5
		c-1.4,5.5-3.3,12.5-4.2,15.5c-0.9,3-2.4,8.7-3.4,12.5c-2.4,9.9-4.6,17.7-7.4,27c-10.5,34.4-10.6,323.2-0.1,374
		c1.3,6.6,3.6,18.5,5.1,26.5c3.6,19.9,7.2,39.2,10,54c1.3,6.9,3.5,19,5,27c2.6,14.4,5.3,28.9,10,54.3c1.3,7.2,2.9,15.9,3.5,19.1
		c0.6,3.7,1,27.1,1,61.3v55.3h-2.2c-1.2,0-8.1,1.1-15.3,2.5c-16.2,3.1-40.5,6.9-59.5,9.2c-12.9,1.6-24.8,1.8-105,1.9
		C449.3,1363.7,427.1,1363.5,418.5,1362.4z"
            />
            <path
              className="st0"
              d="M106.3,1355.6c-5.8-1.4-12.3-5.5-14.8-9.2c-0.8-1.3-1.5-4.1-1.5-6.2c0-3.2-0.5-4.3-2.6-5.7
		c-2.9-1.9-10.9-4.5-13.9-4.5c-3.5,0-12.4-5.2-15.3-8.9l-2.7-3.6l-0.3-57.7l-0.3-57.7l3.8-1c2.1-0.6,4.7-1.1,5.8-1.1
		c5.1,0,31.5-9.2,41.1-14.3c11.3-6,14.1-7.7,15.3-9.1c0.8-0.9,1.7-1.6,2.2-1.6c2.4,0,16.4-13.4,21.6-20.7c6.4-9,9-14.6,11.8-25.2
		c5.4-20.2,1.8-43.1-9.5-61.6c-3-5.1-12.8-16.7-14.9-17.9c-0.9-0.5-1.9-1.5-2.3-2.1c-1.4-2.3-16.2-11.8-25.8-16.6
		c-11.6-5.7-21.9-9.3-37-12.9l-11.5-2.7l-0.3-250l-0.2-250l6.1-0.7c7.6-0.8,25.7-5,32.9-7.8c6.6-2.5,20.5-9.2,24.1-11.6
		c8.7-5.8,10.9-7.5,15.9-12.4c5.9-5.9,9.6-10.5,11.9-14.6c0.8-1.5,2-3.2,2.7-4c0.8-0.7,1.4-1.8,1.4-2.3c0-0.6,0.9-2.9,2-5.2
		c4.3-8.8,6.5-21.2,6.5-36.2c0-16.6-1.7-24.8-7.9-37.4c-6-12.4-6.1-12.4-13.9-20.3c-6.5-6.6-9.8-9.4-14.6-12.3c-0.9-0.5-3-1.9-4.6-3
		c-5.8-3.9-21.4-11-28.5-13c-12.9-3.5-17.2-4.5-25.2-5.6l-8.8-1.2v-35.3v-35.3l10.8-5.1c5.9-2.9,14.3-7,18.8-9.1l8-3.9l1.3-6.4
		c1.5-7.6,4-11.9,8.3-14.7c3.5-2.1,3.6-2.1,20.8-0.1c5.2,0.7,13,1.5,17.3,1.8c6.3,0.5,8.3,1,10.8,3.1c5.7,4.9,6.1,7.2,5.7,34.2
		l-0.3,24.5l8,2.8c4.4,1.6,11.8,4.2,16.5,5.9c13.8,5,12.6,5.5,13.3-5.2c0.4-5,0.7-12.2,0.7-15.9c0-10.6,1.1-19,2.5-19
		c1.4,0,3.1,2.9,11.1,19c12.5,25.1,23.7,71.1,26.4,107.9c0.5,6.9,1.6,18.5,2.5,25.6c0.8,7.2,1.9,20,2.4,28.5
		c2.2,36,8.4,84.8,12.7,99.6c1.3,4.5,2.4,8.8,2.4,9.6c0,3,8.7,21.8,12.8,27.5c1.2,1.7,2.2,3.5,2.2,3.9c0,0.4,0.6,1.5,1.4,2.3
		c1.4,1.6,3.4,4.9,7.2,12.1c1.1,1.9,2.2,3.7,2.5,4c0.7,0.5,4.2,6.5,8.9,15c1.7,3,3.9,6.9,4.9,8.5c1,1.7,3.3,5.7,5.1,9
		c1.8,3.3,4.1,7.4,5.1,9c1,1.7,3.2,5.5,4.9,8.5c1.7,3,4.4,7.8,6,10.5c1.7,2.8,3.3,5.7,3.6,6.5s0.9,2.2,1.4,3
		c2.9,4.8,18,32.1,20.7,37.3c3.7,7.3,6.9,18.6,8.4,29.4c0.5,4.3,1.7,13,2.5,19.3c2.9,22.2,4.5,147.3,2.5,192.6
		c-2.6,56.3-16.3,134.6-27.9,159c-1,2.2-3,6.4-4.4,9.4c-1.4,3-14,28.7-28.1,57c-27.1,54.8-34,69-35.2,73c-0.4,1.4-1.1,3-1.4,3.5
		c-1.1,1.5-2.6,7.4-5.6,21c-6.5,30.1-7.7,35.5-10,43c-1.4,4.4-2.8,9.4-3.1,11c-1.9,8.4-9.2,22.5-14.2,27.3c-6.6,6.3-9.4,7.5-16.9,7
		c-9.3-0.6-9.7-1.2-8.4-13.9c0.6-5.7,1.4-12,1.7-14l0.6-3.6l-7.8-1.2c-4.4-0.6-13.7-1.6-20.9-2.2c-7.1-0.5-13.7-1.2-14.6-1.5
		c-1.9-0.5-2.4,1-3.4,10.1c-0.7,6.3-3.1,15.4-4.6,16.9c-0.5,0.6-0.9,1.7-0.9,2.5c0,2.2-4.8,7.9-8,9.6c-3.9,2-18,4.5-25,4.4
		C114,1356.9,109.1,1356.3,106.3,1355.6z"
            />
            <path
              className="st0"
              d="M898.5,1355.3c-4.4-0.8-9-2.1-10.2-2.8c-7.1-4.7-12.4-17.3-13.8-32.8c-0.6-6.4-0.8-6.8-2.8-6.3
		c-1.2,0.3-8,1-15.2,1.6c-7.1,0.6-15.9,1.5-19.5,2c-3.6,0.5-7.1,1-7.8,1c-0.8,0-1.1,0.7-0.8,1.8c0.3,0.9,1,6,1.6,11.2
		c0.5,5.2,1.2,10.9,1.6,12.7c0.6,2.8,0.3,3.3-2.6,4.8c-4.8,2.5-14.4,1.7-19.1-1.6s-8.8-8.2-12-14.4c-4.6-8.8-10.7-28.8-15.2-49.5
		c-1.4-6.3-3.7-16.5-5.1-22.5c-1.4-6.1-2.6-11.8-2.6-12.7c0-2.6-10.4-26.5-16.8-38.3c-0.8-1.6-1.9-3.7-2.2-4.5
		c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.5-5c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.5-5c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.5-5
		c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.5-5c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.5-5c-0.4-0.8-1.5-3.1-2.5-5s-2.2-4.2-2.6-5
		c-1.3-2.5-15.9-33.1-18.6-39c-5.4-11.7-6.3-13.7-8.4-19.5c-1.2-3.3-2.7-8.5-3.4-11.5s-2.2-8.9-3.3-13c-3.8-14.5-10.9-56.4-12.3-73
		c-0.5-5.8-1.5-15.9-2.4-22.5c-2.8-22.7-3.6-60.4-2.6-133.5c0.8-51.7,1.4-72.8,2.6-82.5c0.8-7.1,1.9-16.4,2.4-20.5
		c1.7-14.6,7.8-33.5,13.1-40.5c0.4-0.5,2.8-4.9,5.3-9.7c2.6-4.7,5.6-10.3,6.8-12.5c5.3-9.1,6.7-11.6,12.4-21.8
		c3.3-5.9,6.9-12.4,8.1-14.4c1.1-2,3.2-5.6,4.6-8.1c1.3-2.5,3.5-6.3,4.8-8.5s3.7-6.2,5.2-9c1.6-2.7,4.2-7.2,5.9-10
		c1.6-2.7,3.4-5.9,4-7c0.5-1.1,2.4-4.4,4.2-7.2c15.4-25.1,18.1-30.7,22.6-46.3c4.9-16.9,11.2-64,13.1-97.5c0.5-8.2,1.6-21.3,2.5-29
		c0.9-7.7,2-19.8,2.5-27c1.8-27.6,10-69.3,17.6-89.3c1.3-3.4,2.4-6.9,2.4-7.7c0-0.8,2.7-7,6-13.7c12.5-25.7,13.3-26,14.1-5.8
		c0.3,8,0.9,17.9,1.4,22.1l0.7,7.6l6.7-2.4c3.6-1.4,9.5-3.5,13.1-4.8c3.6-1.3,8.5-3,11-3.9s5-2,5.6-2.4c0.9-0.5,1-6.7,0.4-23.1
		c-0.7-24.2-0.1-30.5,3.3-33.4c5.2-4.3,6.4-4.7,19.7-5.7c7.4-0.5,15.8-1.5,18.6-2.1c12.5-2.8,19.1,3,22,19.4c0.3,2,1,3.7,1.6,3.7
		c0.5,0,7.3,3.1,15.1,6.9c7.8,3.8,15.9,7.6,18,8.4l3.7,1.6v35.4v35.3l-9.2,1.3c-5.1,0.6-12.4,2.1-16.3,3.2c-3.8,1.2-8.7,2.5-10.8,3
		c-2.2,0.5-5.6,1.8-7.7,2.9c-2.2,1.1-4.4,2-5,2c-0.6,0-2.8,1.1-5,2.5s-4.4,2.5-4.9,2.5c-3.3,0-27.1,19.3-27.1,21.9
		c0,0.5-0.7,1.5-1.6,2.2c-1.7,1.4-8.4,11.5-8.4,12.7c0,0.4-1.1,3-2.5,5.7c-1.3,2.8-2.5,5.8-2.5,6.7s-0.8,4.5-1.7,8
		c-3.6,13.4-1.3,40.2,4.6,53c1.1,2.6,2.1,5,2.1,5.4s2.5,4.5,5.6,9c10.8,16.1,27.1,28,51.4,37.4c6.9,2.6,30.5,8,35.4,8h3.6
		l-0.2,250.2l-0.3,250.2l-5.5,1.2c-21.6,4.7-31.4,8-45.5,15.3c-1.6,0.8-4.4,2.2-6,3.1c-6,3-19.1,13.3-25.4,19.9
		c-22.1,23.4-27.8,58.6-14.3,88.2c1.7,3.6,3.8,7.1,4.6,7.8c0.9,0.8,1.6,1.9,1.6,2.6c0,2.5,13.8,15.6,25.3,23.8
		c12.3,8.9,43.2,21.2,58.1,23.2c2.7,0.4,5.4,0.9,6,1.1c0.8,0.3,1.1,16.2,0.9,58l-0.1,57.6l-3,3.7c-3.7,4.6-9.2,7.7-16.2,9.2
		c-3,0.6-7.6,2-10.1,3.1c-4.4,1.8-4.7,2.2-5.3,6.8C938.8,1353.8,922.7,1359.7,898.5,1355.3z"
            />
            <path
              className="st0"
              d="M62.4,1185c-6.8-0.9-13.6-3.4-22.9-8.2c-13.8-7.2-24.9-18.6-31.7-32.8c-7.1-14.6-7.2-15.4-7.6-32.8
		c-0.4-16-0.3-16.4,2.6-25c2.7-7.7,7.6-17.9,10.7-22.2c2.6-3.7,17.8-18,20.7-19.6c13-6.9,17.9-8.7,28.3-10.6
		c35.4-6.3,69,11.3,83.9,43.8c6,13.1,8.3,34.4,5.1,46.7c-0.8,3.2-1.5,6.4-1.5,7.2c0,1.3-5.8,13.7-9.5,20.6
		c-2.2,4-13.5,15.8-17.8,18.8c-7.8,5.1-13.6,8.1-21.6,11.1c-7,2.5-10,3-20.4,3.4C74,1185.7,65.7,1185.5,62.4,1185z"
            />
            <path
              className="st0"
              d="M940.5,1185c-14.5-1.8-32.2-11.4-43.3-23.6c-3.5-3.7-6.9-7.9-7.7-9.3c-3.7-6.9-9.5-19.3-9.5-20.6
		c0-0.8-0.7-4-1.5-7.2c-3.2-12.3-0.9-33.6,5.1-46.7c19.5-42.6,71.3-58.1,111.6-33.4c5.6,3.5,14,10.8,17.3,15
		c1.7,2.1,3.5,4.4,4.1,5.1c2.5,2.9,7.8,13.9,10.6,21.9c2.9,8.6,3,9,2.6,25c-0.4,17.4-0.5,18.2-7.6,32.8c-5,10.5-13.3,20.4-22.9,27.6
		c-3.6,2.7-13.3,7.7-20,10.4C970.2,1185.6,954.8,1186.8,940.5,1185z"
            />
            <path
              className="st0"
              d="M70,499.3c-11.6-1.3-28.2-7.1-36.6-12.8c-9.8-6.7-19.4-17-24.1-26.2c-1.2-2.3-2.6-5-3.2-6s-2.2-5.3-3.6-9.5
		C0.3,438,0,435.6,0,422.2c0-14,0.2-15.4,3-23.7c3.7-10.4,6.1-15.1,11.7-22.5c10.2-13.6,22.9-22.2,40.4-27.6
		c19.1-5.8,37.2-3.9,56.7,5.9c4.5,2.3,8.2,4.5,8.2,4.9c0,0.5,0.6,0.8,1.3,0.8c1.1,0,12.2,10.4,16.1,15c2.1,2.5,7.6,12,7.6,13.1
		c0,0.5,0.7,2.1,1.6,3.5c5.2,7.9,8,33.5,5,45.2c-0.9,3.5-1.6,7.1-1.6,8c0,0.9-1.2,4-2.5,6.7c-1.4,2.8-2.5,5.3-2.5,5.7
		c0,2.1-7.9,12.7-14.3,19.1c-7,7.1-11.9,10.6-22.2,15.9C99.4,496.8,79.8,500.5,70,499.3z"
            />
            <path
              className="st0"
              d="M945.5,499c-18.7-2.6-33.6-9.9-46.2-22.7c-6.4-6.4-14.3-17-14.3-19.1c0-0.4-1.1-2.9-2.5-5.7
		c-1.3-2.7-2.5-5.8-2.5-6.7c0-0.9-0.7-4.5-1.6-8c-3-11.7-0.2-37.3,5-45.2c0.9-1.4,1.6-3,1.6-3.5c0-1.1,5.5-10.6,7.6-13.1
		c3.9-4.6,15-15,16.1-15c0.7,0,1.3-0.3,1.3-0.8c0-0.4,3.7-2.6,8.3-4.9c19.4-9.8,37.5-11.7,56.6-5.9c17.5,5.4,30.2,14,40.4,27.6
		c5.6,7.4,8,12.1,11.7,22.5c2.8,8.3,3,9.7,3,23.7c0,13.4-0.3,15.8-2.5,22.6c-1.4,4.2-3,8.5-3.6,9.5c-0.6,1-2,3.7-3.2,6
		c-4.7,9.2-14.3,19.5-24.1,26.2C983.2,495.5,960.5,501.1,945.5,499z"
            />
            {/* <path
              className="st0"
              d="M326,179v-17h188.5H703v17v17H514.5H326V179z M700,179.5V166H515H330v13.5V193h185h185V179.5z"
            /> */}
            {/* <path
              className="st0"
              d="M322.4,125c-3.6-0.4-6-1.3-8.5-3.4c-6.7-5.6-8.8-14.3-8.9-35.8c0-11.9-0.1-12.8-2.2-14.5
		c-1.3-1-3.4-3.4-4.8-5.3c-2.3-3.2-2.5-4.4-2.5-13.2c0-8.9,0.2-9.8,2.5-12.3c1.4-1.5,3.7-3.3,5.3-4.1c1.5-0.8,2.7-2.3,2.7-3.3
		c0-3,4.6-16.2,7.4-21.1c2.6-4.7,4.9-7.1,9.8-10.2C325.8,0.1,336.8,0,517.7,0c180.2,0,192,0.1,194.3,1.7c5.2,3.7,6.3,5,9.2,11.3
		c2.3,4.8,3.2,8.5,3.6,14.3c0.3,5.7,0.8,7.7,1.9,7.7c3.3,0,7.5,3.3,9.4,7.3c4.3,9.5,1.5,21.9-6.3,27.8l-4.3,3.3v17l-0.1,17.1
		l-3.4,6.3c-1.9,3.4-4.3,6.5-5.2,6.8c-1,0.3-1.8,0.9-1.8,1.3c0,2.7-6.4,3.1-48.3,3.1c-23.8,0-47.6-0.3-52.9-0.7
		c-9.2-0.6-9.8-0.7-9.8-2.8c0-1.2-1-3.1-2.3-4.3l-2.3-2.2h-83.5c-63.6,0-83.8,0.3-84.7,1.2c-0.7,0.7-1.2,2.7-1.2,4.5
		c0,1.9-0.6,3.6-1.2,3.8C427,125.2,328.6,125.6,322.4,125z M328.8,97.2L329,75h-8.6h-8.6l0.4,15.8c0.6,17.2,1.7,21.7,6.1,25.2
		c2.8,2.2,7.4,4,9.2,3.6C328.1,119.4,328.6,110.9,328.8,97.2z M424.3,115c3.1-7.3-1.1-7,90.3-7c61.4,0,82.5,0.3,86,1.2
		c3.1,0.9,5.6,2.4,7.7,4.8l3.1,3.5l14.3,0.3l14.3,0.3v-7.5V103H513.5H387v8v8h17.8h17.7L424.3,115z M710,116.8c6.8-4,9.9-13,10-28.8
		c0-14.4,0.3-14-9.1-14H703v22.5C703,121.7,702.7,120.9,710,116.8z M640,96v-4H513.5H387v4v4h126.5H640V96z M640,86v-3H513.5H387v3
		v3h126.5H640V86z M640,77c0-2-0.7-2-126.5-2S387,75,387,77s0.7,2,126.5,2S640,79,640,77z M541.3,68.1L722,67.2l3.4-2.6
		c1.9-1.4,4-4.2,4.6-6.2c1.4-4.2,0.9-12.7-1-14.9c-1.1-1.3-23.8-1.5-211.6-1.5H307.1l-2.6,2.3c-5.6,4.8-4,15.9,3.3,22.2
		C311,69.4,286,69.2,541.3,68.1z M719,31.3c-0.1-5.2-4.1-16.8-7-20.3c-4.8-5.9,8.1-5.5-191.5-5.8C391.2,5,335.2,5.3,332.1,6
		c-6,1.5-10.8,5.4-13.8,11.4c-2.1,4.2-5.1,13.8-5.3,16.9c0,0.4,91.3,0.7,203,0.7h203V31.3z"
            /> */}
            {/* <path
              className="st0"
              d="M332.4,57.5c-3.1-3.1-2.8-6.1,0.9-8.9c2.6-1.9,3-1.9,5.5-0.5c3.7,2,4.3,8,1,10.3
		C336.7,60.6,335.3,60.4,332.4,57.5z"
            />
            <path
              className="st0"
              d="M452.3,58.8c-1.9-0.9-2.3-1.9-2.3-5.3c0-3.5,0.4-4.4,2.6-5.4c6.2-2.8,11.3,5,6.5,9.8
		C456.8,60.2,455.6,60.4,452.3,58.8z"
            />
            <path
              className="st0"
              d="M571.9,59.3c-2.7-0.7-4.2-5.2-2.9-8.4c2.4-5.7,10.3-4.1,10.8,2.2C580.2,57.7,576.6,60.5,571.9,59.3z"
            />
            <path
              className="st0"
              d="M689.2,57.7c-3.2-3.3-2.9-6.9,0.8-9c2.7-1.6,3.2-1.7,6-0.2c2.2,1.2,3,2.2,3,4.3
		C699,58.8,693.1,61.8,689.2,57.7z"
            /> */}
            {/* <path
              className="st0"
              d="M331,28.4c-0.8-0.8-1.6-4.1-1.8-7.2c-0.3-4.6,0-6.2,1.6-8.2c2-2.4,2.5-2.5,16.1-2.8
		c13.8-0.3,14.1-0.3,16.5,2.1c3.5,3.5,4.3,8.7,2,13.4l-1.9,3.8l-15.6,0.3C334.5,30,332.1,29.8,331,28.4z M361.2,25.3
		c2.4-2.1,2.3-6.8-0.2-9.3c-1.8-1.8-3.3-2-13.5-2c-10.2,0-11.7,0.2-13.5,2c-2.4,2.4-2.6,5.7-0.4,8.8c1.4,2.1,2.2,2.2,13.6,2.2
		C357.1,27,359.7,26.7,361.2,25.3z"
            />
            <path
              className="st0"
              d="M664,26.8c-1.1-1.8-2-4.6-2-6.1c0-3.5,2.4-8.3,4.9-9.7c1.1-0.5,7.4-1,14.1-1c12.6,0,17.1,1.1,18.4,4.5
		c1.2,3.1,0.6,11.1-1,13.3c-1.5,2.1-2.1,2.2-17,2.2H666L664,26.8z M695.8,23.7c1.7-3.6,0.1-8.2-3.1-9.1c-2.9-0.8-20.6-0.7-23.5,0
		c-3.7,1-4.6,7.2-1.4,10.7c1.4,1.5,3.1,1.7,14.1,1.5l12.6-0.3L695.8,23.7z"
            /> */}
          </g>
          <g id="layer102">
            <path
              className="st1"
              d="M518,1593.5c0-0.9,0.5-1.5,1.1-1.3c0.6,0.2,1.1,0.8,1.1,1.3s-0.5,1.1-1.1,1.3
		C518.5,1595,518,1594.4,518,1593.5z"
            />
            {/* <path
              className="st1"
              d="M334.2,1500.8c-1.6-1.6-1.5-3.3,0.4-4.8c2.2-1.9,5.4,1.2,3.8,3.7C337,1501.9,335.7,1502.3,334.2,1500.8z"
            />
            <path
              className="st1"
              d="M453.2,1500.8c-2.8-2.8,0.2-6.7,3.4-4.3c1.5,1.1,1.7,1.8,0.8,3.1C456,1501.9,454.7,1502.3,453.2,1500.8z"
            />
            <path
              className="st1"
              d="M572.2,1500.8c-1.6-1.6-1.5-4.5,0.1-5.1c1.7-0.6,4.7,1.1,4.7,2.8C577,1500.6,573.6,1502.2,572.2,1500.8z"
            />
            <path
              className="st1"
              d="M690.6,1500.4c-1.7-1.6-1.2-4,0.9-4.8c1.9-0.7,4.6,2,3.9,3.9C694.6,1501.6,692.2,1502.1,690.6,1500.4z"
            /> */}
            <path
              className="st1"
              d="M426.5,1358c-5.5-0.5-13.1-1.3-17-1.9c-3.8-0.6-11.3-1.5-16.5-2.1c-13.2-1.4-51.7-7.1-58.7-8.7l-2.3-0.5v-51.3
		v-51.3l7.9,3.9c4.3,2.1,9.8,4.6,12.2,5.5c9.6,3.6,18.2,6.4,18.6,6c0.2-0.2-1.3-1-3.4-1.6c-7.6-2.5-21.8-8.2-28.5-11.6
		c-7.9-4-7.8-3.6-4.9-17.6c1-5.1,3.1-15.8,4.6-23.8c1.4-8,3.7-20.6,5.1-28c6-32.4,11.6-62.7,14.9-80.7c1.4-7.6,3.7-19.6,5-26.8
		c1.3-7.1,3-16.1,3.6-20c1.6-9.3,2.1-10.2,7.1-11c2.4-0.3,9.3-1.7,15.3-3c34.3-7.4,27.2-7,126.5-7c99.6,0,89.8-0.5,124.5,7
		c6.1,1.3,12.4,2.7,14.2,3c1.7,0.3,3.6,1.2,4.1,1.8c0.5,0.7,1.9,6.6,3.1,13.2c1.3,6.6,3.3,17.6,4.6,24.5s3.5,19,5,27s3.7,20.1,5,27
		s3.5,19,5,27s3.7,20.1,5,27s3.5,19,5,27c1.4,8,3.3,17.7,4,21.5l1.3,7l-2.6,2.2c-4,3.4-20.4,11.2-33.7,16c-6.6,2.4-10.4,4.1-8.5,3.7
		c1.9-0.3,6.2-1.7,9.4-3c3.3-1.3,6.3-2.4,6.8-2.4c1.4,0,22.1-10.2,24.7-12.2c1.3-1,2.8-1.8,3.2-1.8c0.5,0,0.9,23.1,0.9,51.4v51.4
		l-5.2,1.2c-2.9,0.6-9.3,1.7-14.3,2.5c-4.9,0.8-14.6,2.3-21.5,3.4c-40.3,6.5-38.9,6.5-133,6.7C475.4,1358.7,432,1358.4,426.5,1358z
		 M616,1269.4c2.7-0.5-37.4-0.9-98.9-0.9c-56.9,0-102.8,0.1-102,0.3c8.3,1.6,30.4,1.9,106.9,1.7
		C571.2,1270.4,613.5,1269.9,616,1269.4z M401,1265.4c-3.6-0.8-11.4-2.8-17.4-4.4c-6-1.7-11.1-2.8-11.3-2.6
		c-0.7,0.7,22.6,7.2,28.2,7.9C407,1267.1,407.2,1266.7,401,1265.4z M641.5,1264.4l4-1.3l-4.5,0.6c-2.5,0.4-6.7,1.2-9.5,1.9l-5,1.2
		l5.5-0.5C635,1266,639.3,1265.1,641.5,1264.4z M671,1182.6c0-28.6-0.1-29.8-3-44.3c-4-20-7.3-33.8-17.1-69.8
		c-5.4-20-5.8-21.5-6.3-22.4c-0.4-0.5-3-1.2-5.9-1.6c-2.8-0.4-9.4-1.6-14.6-2.6c-22.2-4.5-30.6-4.9-109.6-4.9
		c-79.8,0-90.1,0.5-116.5,5.2c-6.9,1.2-12.6,2.3-12.8,2.3c-0.1,0.1-0.9,2.9-1.8,6.1c-0.8,3.2-2.9,10.9-4.5,16.9
		c-7,26.8-13.7,55.1-17,72.5c-2.8,15-3.8,28.1-3.8,52.3L358,1212h156.5H671V1182.6z"
            />
            <path
              className="st1"
              d="M361.3,1207.4c-0.3-0.8-0.3-12.7,0-26.2c0.5-20.8,1-26.8,3.2-38.2c4.3-22.5,9.4-44.8,17-73.5
		c2-7.7,4.2-15.9,4.8-18.2c0.9-3.7,1.5-4.3,4.1-4.8c37.4-6.2,42.3-6.4,124.6-6.4c72.2-0.1,84.4,0.4,103.9,3.9
		c25.4,4.6,23.4,3.9,24.8,9c0.6,2.5,2.8,10.6,4.8,18c8.7,31.8,11.9,45,16.5,68.4c2.9,14.3,3,15.9,3,42.2v27.4H515
		C376.6,1209,361.9,1208.8,361.3,1207.4z"
            />
            <path
              className="st1"
              d="M107.5,1350.3c-2.7-0.8-6.5-2.6-8.2-3.9c-2.9-2.2-3.3-3.1-3.4-7.2c0-4.2-0.4-5-3.9-7.8
		c-2.5-2-6.7-3.8-12.2-5.3c-10.4-2.8-14.6-4.8-17.2-8.4c-2.1-2.8-2.1-3.8-2.2-57.3l-0.2-54.4h2.2c2.6,0,17.6-4.2,25.9-7.2
		c5-1.8,6-1.9,6.8-0.7c0.7,1.1,0.9,1.1,0.9-0.4c0-1,1.1-2.2,2.4-2.7c13.3-5,30.9-16.4,41.1-26.7c17.2-17.2,24.5-34.5,24.5-58
		c0-19.3-6.1-38.5-16.2-51.6c-9.8-12.8-25.1-24.7-42.5-33.3c-5.1-2.5-9.3-4.9-9.3-5.4s-0.6-0.7-1.4-0.4c-0.8,0.3-4.7-0.6-8.7-2
		c-4.1-1.4-10.5-3.2-14.4-4c-3.8-0.9-8-1.8-9.2-2.1c-2.2-0.5-2.3-1-2.3-9.6c0-8.2,0.2-9.1,1.8-8.6c0.9,0.2,5.1,1.4,9.2,2.5
		c4.1,1.2,10.8,3.3,14.9,4.7c4.1,1.4,8.7,2.5,10.2,2.5s3.1,0.4,3.4,1c0.3,0.5,7.9,4.6,16.8,8.9c18.2,9,30.2,17.4,38.9,27.3
		c10.6,12.2,16,21.2,20.9,35.3c1.5,4.4,2.8,7.2,2.8,6.3c0.1-2.9,1.5-2.1,5.9,3.1c13,15.3,31.8,11.9,66.1-12.1
		c32.9-23,66.2-51.6,85.2-73.1c3.8-4.2,7.2-7.7,7.6-7.7c2.6,0.1-6.6,54.4-13.6,80.8c-4.5,16.5-11.1,30.9-53.4,116
		c-22.8,45.8-25.6,52.6-30.1,74.7c-6.2,30.1-12.2,52-17.6,64c-4,8.9-10.4,15.5-15.9,16.5c-2.5,0.4-5.4,0.4-6.6,0l-2.1-0.8l1.7-13.4
		c1-7.3,1.8-14,1.9-14.8c0-1.2-3.7-1.9-19.2-3.8c-10.6-1.2-22.8-2.5-27-2.8l-7.8-0.7l-0.1-3.1c-0.1-2.9-0.2-2.8-0.9,0.9
		c-0.4,2.2-1.6,8.9-2.5,14.9c-1.9,12.6-4.6,20.6-8.4,24.8c-2.2,2.5-4.2,3.3-11.6,4.9C119.8,1352.3,114.2,1352.4,107.5,1350.3z
		 M258.8,1197c7.7-12.9,17.5-29.6,21.7-37c4.3-7.4,9.5-16.5,11.6-20.2c2.1-3.7,7-13.1,10.8-21c11.7-24.3,30.3-82.5,32.6-102.3l0.8-6
		l-2.9,2.5c-6.3,5.6-53.4,51.1-73,70.6c-13.1,13-15.2,15.5-15.7,19c-0.7,4-1,119.1-0.3,118.3C244.6,1220.7,251.1,1209.9,258.8,1197z
		"
            />
            <path
              className="st1"
              d="M247.4,1204.6c-0.8-2.2,0.2-98.2,1.2-101.9c0.4-1.9,9.7-11.8,28.3-30.1c28-27.6,46.6-45.5,51-49.1l2.4-2
		l-0.7,4.9c-1.3,9.9-16.4,58.5-24.5,78.8c-3.4,8.5-12.3,26-21.4,41.8c-3.3,5.8-7.8,13.7-10,17.5c-7.3,12.9-23,39-24.3,40.4
		C248.3,1206.2,248,1206.1,247.4,1204.6z"
            />
            <path
              className="st1"
              d="M900.5,1350.2c-4.4-0.9-9-2.3-10.2-3c-1.2-0.6-3.6-4-5.2-7.5c-2.9-5.9-3.4-7.9-6.8-31.7
		c-0.4-2.6-0.7-3.1-1.4-1.9c-0.6,1.2-3,1.8-8.1,2.3c-6.7,0.6-46.1,4.8-46.5,5c-0.1,0.1,1.2,10.3,3.2,25.4c0.8,5.7,0.9,5.7-7,5.2
		c-13.1-0.8-22.9-23.1-34-77.4c-5.9-28.6-5.2-26.9-38.2-93.1c-36-72.1-41.7-84.8-47.1-105.5c-6.4-24.6-15-76-12.6-76
		c0.3,0,2.9,2.6,5.8,5.8c21.1,22.7,44.7,43.7,71.6,63.7c33.9,25.1,49,32.9,62.8,32.6c9.2-0.2,18.6-6,19.9-12.2
		c0.6-3.1,0.6-3.1-4,1.8c-8.9,9.5-20.7,9.8-38.3,1.1c-22.1-11-69.6-47.8-96.4-74.9c-7-7.1-17-17.9-20.4-22.2
		c-3.7-4.5-3.9-5.2-5.1-16.5c-3-26.3-4-52.1-3.7-91.2c0.2-26.1,0.7-39.7,1.4-40.1c1.3-0.8,11.8-1.6,40.3-2.9
		c33.9-1.5,54.7-3,66.5-4.5c23.5-3.1,76.5-6,91-5c27.1,1.9,73.3,7.6,87.5,10.8l6,1.4l0.3,74c0.2,59.4,0,74.3-1.1,75.1
		c-0.7,0.6-5.3,2.2-10.2,3.7c-11,3.2-24,7.3-28,9c-10.6,4.4-27.2,12.2-31,14.6c-2.5,1.6-4.8,2.9-5.1,2.9s-4.4,2.9-9,6.5
		c-4.6,3.6-8.9,6.5-9.4,6.5c-0.6,0-1,0.5-1,1.1c0,0.6-2.3,3.6-5.1,6.7c-4.4,4.9-10.1,12.7-13.5,18.7c-9.2,16.4-9.5,17.2-6.9,16.7
		c2-0.3,3.3-2.1,6.4-8.7c2.1-4.5,5.8-11.1,8.1-14.6c6.1-9.1,20.1-22.6,30.2-29.2c8.8-5.7,26-14.4,33.3-16.7c2.2-0.7,5.4-1.9,7-2.6
		c6-2.5,31.7-10.4,33.9-10.4c0.4,0,0.6,4,0.6,8.9v9l-7.7,1.6c-4.3,0.9-11.9,3-16.8,4.6c-5,1.6-9.8,2.9-10.7,2.9
		c-0.9,0-1.8,0.3-2,0.8c-0.1,0.4-4.6,2.8-9.8,5.3c-31.8,15.4-51.5,39.3-56.4,68.8c-2,11.9-2,18.3,0,30.2c5.4,31.9,30,56.8,71.9,72.7
		c7.1,2.7,23.8,7.5,28.8,8.4c1.7,0.3,1.8,3,1.8,53.3c0,32.7-0.3,54-0.9,55.6c-1.4,3.7-6.6,7.7-11.5,8.9c-10.5,2.7-17.8,5.4-19.3,7.1
		c-2.2,2.5-3.2,2.4-3.7-0.3c-0.2-1.3-0.5,1.1-0.6,5.3c-0.1,6.4-0.4,7.9-2.3,9.6C925.7,1351.3,913.6,1353,900.5,1350.2z
		 M786.8,1157.9l-0.4-55.7l-2.9-4.3c-2.6-3.7-38.5-39.3-76-75.2l-12-11.5l-0.3,4.1c-0.6,8.1,10.6,47.6,23.8,83.7
		c6.6,18.4,20.3,43.8,52.3,97.2c13.8,23,14.2,23.6,15.1,20.5C786.8,1214.9,787,1188.5,786.8,1157.9z M785,948.9V844.7l-11.7,0.6
		c-6.5,0.3-28.1,1.4-48.1,2.4l-36.3,1.7l0.3,58.1l0.3,58l2.7,7.3c5.5,15.2,22.7,32.9,52.4,54.4c8.2,5.9,12.2,8.6,25.9,17.3
		c4.4,2.8,13.5,8.2,14.3,8.4C784.9,1053,785,1006.1,785,948.9z"
            />
            <path
              className="st1"
              d="M781.4,1204.9c-1.1-1.3-11.9-19.3-19.9-32.9c-30.8-52.7-35.4-62.6-47.9-101.5c-10.6-33-14.8-48.5-13-48.5
		c1.5,0,77.2,74.4,80.3,79c1.4,2.1,1.6,7.8,1.9,49.5C783.2,1202.7,783.1,1207.1,781.4,1204.9z"
            />
            <path
              className="st1"
              d="M766,1038.4c-16-10.2-28.6-19.3-31.9-22.8l-2.4-2.6h24.6H781v17c0,9.4-0.4,17-0.9,17
		C779.7,1047,773.3,1043.1,766,1038.4z"
            />
            <path
              className="st1"
              d="M719.2,1003.7c-14.5-12.9-22-23-24.7-33.2c-2.8-10.8-3.5-31.2-2.9-75.7l0.7-42.6l9.1-0.6
		c5-0.3,21.9-1,37.6-1.6c15.7-0.6,31.5-1.4,35.3-1.7l6.7-0.6v82.2v82.1h-26.2h-26.3L719.2,1003.7z"
            />
            <path
              className="st1"
              d="M62.5,1182.6c-32.3-7.5-52.4-27.9-60-61.1c-0.3-1.6-0.6-7.4-0.6-13c0.1-31.8,20.2-59.2,51.6-70.1
		c7.4-2.6,9.2-2.8,23-2.8c13.7,0,15.6,0.2,22.3,2.6c28.3,10.2,46.3,31.5,50.9,60.2c3.7,23.6-3.9,46.1-21.6,63.6
		c-9.5,9.4-17.6,14.3-30.8,18.6C87.5,1183.7,71.5,1184.7,62.5,1182.6z M67,1151.4c-16.6-4.4-26.7-13.8-32.2-29.9
		c-1.4-4-1.6-4.3-1.2-1.5c0.9,5.5,6.4,15.7,11.4,20.6c6.3,6.3,18.1,12.1,25,12.2C71.4,1152.9,70,1152.2,67,1151.4z M88.5,1151.6
		c15.5-4.3,26.7-16.3,31.1-33.8c3.2-12.4-1.2-28-10.8-38.4c-17-18.4-46.2-19.1-63.9-1.4c-8.2,8.2-13,20.1-12.7,32l0.1,6.5l0.7-8.5
		c1.2-13.5,5.5-22.6,14.3-30.6c5.8-5.2,9.9-7.5,17.6-9.8c18.6-5.5,41,4.2,49.3,21.5c4.2,8.6,5,12.9,4.7,22.5
		c-0.4,7.4-0.9,10-3.5,15.4c-6,12.5-15.5,20.4-29.4,24.1c-3.6,1-5.6,1.8-4.5,1.8C82.6,1153,85.8,1152.4,88.5,1151.6z"
            />
            <path
              className="st1"
              d="M942,1183c-15.9-3-28.8-9.8-40.1-21c-26.2-25.9-29.9-64.3-9.3-95.1c8.5-12.6,22.2-22.8,38.6-28.7
		c6.7-2.4,8.6-2.6,22.3-2.6c13.8,0,15.6,0.2,23,2.8c31.4,10.9,51.5,38.3,51.6,70.1c0,5.6-0.3,11.4-0.6,13
		c-6.9,30.1-24.2,49.8-51.5,58.6C965.7,1183.5,950.8,1184.7,942,1183z M944,1151.1c-13.9-3.7-23.4-11.6-29.4-24.1
		c-2.6-5.4-3.1-8-3.5-15.4c-0.3-9.6,0.5-13.9,4.7-22.5c8.3-17.3,30.7-27,49.3-21.5c7.7,2.3,11.8,4.6,17.6,9.8
		c8.8,8,13.1,17.1,14.3,30.6c0.7,8.5,0.7,8.5,0.9,2.1c0.8-35.2-38.4-57.1-68.1-38c-15.1,9.7-23.6,29.5-19.4,45.7
		c3.4,13.5,10.7,23.7,21.1,29.6c5.4,3.1,12.5,5.4,16.5,5.5C949.4,1152.9,947.6,1152.1,944,1151.1z M966.1,1151.6
		c7.5-2.3,14.1-6.1,18.9-11c5-4.9,10.5-15.1,11.4-20.6c0.4-2.8,0.2-2.5-1.2,1.5c-5.5,16.1-15.6,25.5-32.2,29.9
		c-3,0.8-4.6,1.5-3.5,1.5C960.6,1153,963.6,1152.4,966.1,1151.6z"
            />
            <path
              className="st1"
              d="M195.4,1088.6c-3.7-1.6-11.6-10.5-14.4-16.1c-1.1-2.2-2.7-5.3-3.7-7c-7.7-13.1-11.5-18.7-17-25.3
		c-3.4-4.2-6.3-8-6.3-8.4s-0.5-0.8-1.1-0.8c-0.6,0-3.2-1.7-5.8-3.8c-10.4-8.7-25.6-17.1-45.3-25.2c-3.2-1.3-5.8-2.8-5.8-3.2
		c0-0.5-0.4-0.6-1-0.3c-0.5,0.3-4.9-0.7-9.7-2.3c-4.9-1.6-12.5-4-17-5.3l-8.3-2.4v-74.1v-74.1l11.3-2.1c6.1-1.2,13.3-2.4,15.9-2.7
		c2.6-0.3,5-1,5.3-1.6c0.4-0.5,2.9-0.8,5.8-0.8c2.9,0.1,9-0.4,13.7-1c4.7-0.5,14.4-1.5,21.5-2.1c8-0.7,14.2-1.8,16.2-2.8
		c2.6-1.3,3.9-1.4,6.5-0.5c1.8,0.6,10.1,1.4,18.3,1.8c28.6,1.2,61,3.5,70.2,4.9c5.1,0.8,19.2,2,31.5,2.6c32.2,1.5,72.1,4,73.6,4.5
		c0.9,0.3,1.2,9,1.2,38.7c0,54.3-3,100.3-6.9,105.1c-30.9,38.5-104.3,97.3-130.6,104.6C208.1,1090.4,199.2,1090.2,195.4,1088.6z
		 M253.2,1049.9c21.5-12.2,49.8-33.1,65.4-48.4c12-11.8,18.6-20.8,20.9-29c2.6-8.9,3.5-34.8,2.8-80.1c-0.6-43-0.6-43.4-2.7-43.8
		c-1.8-0.4-90-4.7-93.3-4.6c-1,0-1.3,21.7-1.3,105c0,57.8,0.2,105,0.4,105C245.6,1054,249.1,1052.1,253.2,1049.9z"
            />
            <path
              className="st1"
              d="M249,947.3v-99.6l13.3,0.6c7.2,0.4,26,1.1,41.7,1.7c15.7,0.6,30,1.4,31.8,1.6l3.2,0.5v50.8
		c0,63.3-0.5,68.2-8.5,80.6c-4.7,7.5-27,29.5-29.8,29.5c-0.5,0-3,1.9-5.7,4.3c-2.6,2.3-12.5,9.5-22.1,15.9
		c-18,11.9-21,13.8-22.8,13.8C249.3,1047,249,1017.2,249,947.3z"
            />
            <path
              className="st1"
              d="M370,1031.6c0-1.1,0.7-18.7,1.5-39.1C376.3,868.7,376,811,370,718c-0.6-9.1-1.3-18.8-1.7-21.5l-0.5-5.1
		l13.8-2.2c13.9-2.2,22.3-3.2,46.9-5.2c18.2-1.6,173.6-0.8,186,0.8c5,0.7,17,2.4,26.8,3.9l17.7,2.7v3.5c0,2-0.5,10.8-1,19.6
		c-5.4,89-5.4,195.4,0,298.4c0.6,10.7,0.8,19.7,0.5,19.9c-0.3,0.3-2.9,0-5.8-0.7c-2.8-0.7-11.7-2.6-19.7-4.2
		c-28.8-5.9-29.4-5.9-116.4-5.9c-49.8,0-83.5,0.4-89.1,1.1c-10.8,1.2-39.2,6.3-49.8,8.8l-7.7,1.8V1031.6z M542.8,841.3
		c-15.8-0.2-41.9-0.2-58,0c-16.1,0.1-3.2,0.2,28.7,0.2S558.6,841.4,542.8,841.3z M450,839.6c-7.9-1.7-13.1-4.8-18.3-10.6
		c-4.2-4.6-5.3-6.9-7-14.5c-0.3-1.3-0.5-0.9-0.6,1.1c-0.1,3.3,3.7,11.4,7.2,15.2c2.4,2.6,12.3,8.7,15.3,9.5c1.1,0.3,3.5,0.5,5.4,0.5
		C454.9,840.8,454.5,840.6,450,839.6z M584.7,838c7.8-3.6,14.6-10.4,16.7-16.7c2.4-6.9,1.9-7.6-0.8-1.1c-1.3,3.1-3.4,7-4.7,8.6
		c-3.5,4.3-12.3,9.4-18.8,10.8c-4.8,1.1-5.1,1.2-2.1,1.3C577,841,581.3,839.7,584.7,838z M603.7,775.7c-0.1-6.7-0.3-0.9-0.3,12.8
		c0,13.8,0.2,19.2,0.3,12.2C603.9,793.6,603.9,782.4,603.7,775.7z M423.7,776.8c-0.1-6.8-0.3-1.5-0.3,11.7s0.2,18.7,0.3,12.3
		C423.9,794.4,423.9,783.6,423.7,776.8z M426.1,756.8c1.4-5.4,9.3-13.6,16.4-16.9c3.3-1.6,6.6-2.9,7.4-2.9c0.8,0,1.1-0.3,0.8-0.6
		c-1.3-1.4-12.6,3.9-17,7.9c-5.4,4.9-9.7,12.7-9.6,17.1c0.1,2,0.3,2.4,0.6,1.1C424.9,761.4,425.6,758.9,426.1,756.8z M600.6,753.6
		c-2.4-5.8-10.5-12.9-17.5-15.6c-3.4-1.2-6.5-2-6.8-1.6c-0.3,0.3,0,0.6,0.8,0.6c3,0,13.6,5.9,17.1,9.5c2,2,4.4,5.5,5.4,7.6
		C601.8,759,602.7,758.5,600.6,753.6z M544.8,735.3c-16.9-0.2-44.8-0.2-62,0c-17.2,0.1-3.4,0.2,30.7,0.2S561.7,735.4,544.8,735.3z"
            />
            <path
              className="st1"
              d="M60,698.2v-138l3.1-2.7c1.8-1.4,4.8-3.4,6.8-4.4c5.1-2.6,20.9-7.3,23.4-6.9c1.2,0.1,2.7-0.1,3.3-0.5
		c4.7-2.9,41.1-6.6,65.4-6.7c31.7-0.1,63.9,5.4,86.8,14.8c5.8,2.3,6.5,3,9.5,8.6c1.9,3.4,6.9,12,11.3,19.1
		c4.4,7.2,10.2,16.8,12.8,21.5c2.7,4.7,5.8,10.1,6.9,12c1.1,1.9,3,5.3,4.3,7.5c1.2,2.2,4.8,8.5,7.9,14c9.4,16.3,12.6,22.1,17.8,31.7
		c3.8,7,7.9,14.2,8.7,15.3c0.4,0.6,2.6,4.5,4.9,8.9c2.3,4.3,4.6,8.6,5.1,9.5c2,3.6,5.1,16.1,6.9,28c2.9,18.8,4,32.1,4.6,57.6
		c0.3,12.7,0.8,28.8,1.1,35.9l0.5,12.9l-6.3-0.7c-3.5-0.3-17.3-1-30.8-1.6c-30.7-1.3-47-2.4-78-5.5c-26.7-2.7-55.7-4.5-71.7-4.5
		c-8.8,0-10.2-0.2-10.6-1.7c-0.4-1.5-0.5-1.6-0.6-0.2c-0.1,1.3-1.6,1.8-6.8,2.3c-3.8,0.4-14.7,1.6-24.3,2.6
		c-9.6,1.1-19.7,2.2-22.5,2.5c-2.7,0.2-8.8,1.1-13.5,2c-4.7,0.8-11.6,2-15.5,2.5c-3.8,0.6-7.8,1.3-8.7,1.6
		C60.1,836.1,60,829.1,60,698.2z M343.6,803.3c-1.5-51.1-4.6-77.8-10.6-91.8c-19-43.9-65.3-120.8-83.4-138.5l-4.6-4.4v125.6v125.6
		l7.3,0.6c3.9,0.3,22.5,1.7,41.2,3.1c31.8,2.4,38.8,2.9,47.4,3.3l3.4,0.2L343.6,803.3z"
            />
            <path
              className="st1"
              d="M310.5,821c-11.5-1-29.3-2.3-39.5-3c-10.2-0.6-19.3-1.4-20.2-1.6c-1.7-0.5-1.8-7-1.8-118.9
		c0-107,0.2-118.4,1.6-117.8c3.4,1.3,28.4,38.9,45.1,67.8c2.2,3.9,5.9,10.2,8.1,14.1c6.3,11,21.4,40.9,25.5,50.6
		c3.5,8.5,5.4,17.4,7.7,35.8c1,7.5,2.9,51.9,3,68.8v6.2l-4.2-0.1C333.4,822.8,322.1,822,310.5,821z"
            />
            <path
              className="st1"
              d="M680.4,802.4c0.7-33.6,2-53.3,5.1-73.3c2.9-19.4,4.8-23.9,24.2-58.6c30.9-55.1,38.1-67.6,52.6-91.5
		c3.9-6.3,8.4-14.1,10.1-17.2c2.8-5.3,3.5-5.8,9.6-8.2c9.6-3.7,21.3-7.2,32.1-9.5c21-4.5,60-7.1,61.9-4.1c0.8,1.2,1,1.3,1,0.1
		c0-1.1,1.8-1.3,9.8-0.8c19.8,1.3,32,2.7,44.4,5.2c20.1,4,32.1,8.6,38.1,14.6c1.6,1.7,1.7,9.7,1.7,139.4v137.7l-2.7-0.6
		c-1.6-0.3-8.6-1.5-15.8-2.6c-17.1-2.7-17.3-2.7-17.8-4.8c-0.4-1.6-0.5-1.6-0.6,0.1c-0.1,1.6-0.7,1.7-4.3,1.2
		c-3.8-0.5-31.8-3.5-47-5.1c-4.1-0.4-5.8-1-6.1-2.2c-0.4-1.5-0.5-1.5-0.6-0.1c-0.1,1.4-2.9,1.7-20.8,2.3
		c-24.6,0.8-40.2,1.9-65.3,4.6c-23.1,2.4-40.8,3.7-71.5,5c-13.2,0.5-27.3,1.3-31.4,1.7l-7.4,0.6L680.4,802.4z M735,823.5
		c18.4-1.4,37.2-2.8,41.8-3.1l8.2-0.6V694.2l-0.1-125.7l-4.6,5c-9.6,10.4-24.1,31.4-41.2,59.8c-5.5,9.3-10.1,17-10.1,17.2
		s-1.9,3.6-4.3,7.7c-6.9,11.8-19.1,35.4-24.5,47.8c-4.7,10.6-6.8,17.7-9.3,32c-1.5,8.8-3.8,50.8-3.9,70.7V827l7.3-0.5
		C698.2,826.2,716.6,824.9,735,823.5z"
            />
            <path
              className="st1"
              d="M691,801.9c0-36,3.5-70.9,8.6-84.9c7.1-20,52.2-101.8,57-103.7c0.8-0.3,1.2-0.8,1-1.2
		c-0.7-1.1,17.5-28.1,21.3-31.5l2.1-1.9v118.5v118.6l-3.2,0.5c-1.8,0.4-10.5,1.1-19.3,1.7c-24.8,1.7-55.4,4-61.7,4.7l-5.8,0.6V801.9
		z"
            />
            <path
              className="st1"
              d="M366.4,685.3c-0.3-1.6-1.5-6.2-2.5-10.3c-1-4.1-3.2-13.3-4.9-20.5c-3.4-14.5-3-12.9-19.9-82.5
		c-1.7-6.9-3.3-14.3-3.7-16.6l-0.6-4l8.4-2.2c47.4-12.1,67.8-14.8,104.8-13.9c12.9,0.3,50.3,0.8,83,1.1
		c105.3,0.9,103.7,0.8,140.4,9.1c23.6,5.2,24.6,5.6,24.6,7.4c0,0.9-1.4,6.8-3.1,13.1s-3.7,13.8-4.4,16.5c-0.7,2.8-2.9,11.1-5,18.5
		c-2.1,7.4-4.3,15.8-5,18.5c-0.7,2.8-3.9,14.5-7,26c-3.1,11.6-6.9,25.6-8.4,31.2c-1.5,5.7-3,10.5-3.2,10.8c-0.3,0.2-4.1-0.2-8.6-0.9
		c-4.4-0.8-17.4-2.7-28.9-4.3l-20.9-2.8H515c-76,0-88.1,0.2-99.5,1.7c-7.1,1-17.5,2.2-23,2.8c-5.5,0.7-13.4,1.8-17.5,2.6
		c-4.1,0.8-7.6,1.4-7.7,1.4C367.1,688,366.8,686.8,366.4,685.3z"
            />
            <path
              className="st1"
              d="M58,536.7v-18.2l10.3-1.8c18-3.2,25.3-5.5,40.2-12.9c35.3-17.4,53.5-45.8,53.5-83.4
		c0-36.5-18.1-63.8-53.9-81.4c-4.2-2-8.7-4.1-10.1-4.5s-2.7-1.1-3-1.5c-0.8-1.2-29.2-8-33.2-8H58v-32.9v-32.9l9.8-4.7
		c5.3-2.6,12.8-6.2,16.5-8.1c3.8-1.9,7.7-3.4,8.8-3.4c1.1,0,2-0.9,2.3-2.2c2.1-11.1,3-14.1,5-17c2.2-3.3,2.3-3.3,9.6-3.3
		c13.2,0.1,33.4,2.2,37.3,3.8c6.7,2.8,7.1,5.2,6.1,34c-0.6,15.6-0.5,25.2,0.1,25.8c0.5,0.5,1.6,0.9,2.5,0.9c0.8,0,10.2,3.1,20.8,6.9
		c10.5,3.7,19.2,6.8,19.2,6.7c0.1-0.1,0.7-7.2,1.4-15.9c0.8-8.7,1.6-16.1,1.9-16.4c1.3-1.3,5.5,0.9,6.7,3.4
		c7.8,16.6,15.5,42.6,20.3,68.3c2.7,13.9,7.1,51.7,8.2,69.5c0.3,5.5,1.3,16.5,2,24.5c0.8,8,2.2,22.8,3,33c0.9,10.2,2.2,22.3,3,27
		c0.7,4.7,1.6,11.2,2,14.5c0.8,7.5,6.2,31.5,8.1,36c0.8,1.9,1.4,4.8,1.4,6.5c0,3.9-1.4,3.9-14.3-0.4
		c-32.7-10.8-70.9-14.3-111.2-10.2c-14.8,1.5-22.5,2.8-41,6.6c-5.7,1.2-17.4,5.8-20.6,8.1c-1.5,1-4.1,1.9-5.8,1.9H58V536.7z"
            />
            <path
              className="st1"
              d="M960.5,550.6c-13.6-7-40.2-12-77.7-14.7c-28.3-2-67.8,3.2-94.7,12.5c-11.6,4-12.4,3.6-9.7-4.2
		c2.9-8.2,6.6-25.2,9-41.7c2.5-16.3,6.9-59.7,8.1-79.5c0.3-5.2,1.3-16,2.1-24c0.8-8,1.9-19.7,2.5-26c2.1-24.8,8.5-55.6,16.3-79
		c6-18.2,10.1-27,12.5-27c2,0,2.4,2.2,3.7,22.8c0.6,8.9,0.9,10.3,2.3,9.8c2.4-0.7,26.2-9.1,38.1-13.5l5.5-2l-0.4-25.8
		c-0.3-22.3-0.1-26.3,1.2-29c2.6-5,4.3-5.3,38.5-7.9c7-0.6,8.5-0.4,10.2,1.1c2.3,2.1,4.7,8.3,5.5,14.8c0.6,4.6,0.8,4.9,5.8,7.1
		c2.9,1.3,11.4,5.4,19,9l13.7,6.7V292v31.9l-4.7,0.6c-11,1.3-31.1,6.9-40.1,11.1c-5.1,2.4-9.5,4.4-9.8,4.4c-0.2,0-4.1,2.4-8.7,5.3
		c-24.5,15.9-37.7,37.2-40.9,65.5c-1.1,10-1,12.8,0.5,23.3c3.1,21.1,10.7,36.8,24.5,50.5c16.6,16.5,38.5,27.1,67.2,32.6l12,2.3
		l-0.2,17.5c-0.3,14.7-0.5,17.5-1.8,17.6C969.2,554.7,964.9,552.9,960.5,550.6z"
            />
            <path
              className="st1"
              d="M336,544.6c0-0.8,0.5-2.7,1-4.3c0.9-2.6,0.9-2.7-0.5-0.9c-0.8,1.1-1.5,2.3-1.5,2.8c0,0.4-0.4,0.8-1,0.8
		c-0.7,0-1-46.7-1-138V267l2.3-0.4c1.2-0.2,9.9-1.5,19.2-3c24.5-3.7,46.9-7.1,63.4-9.7c9.8-1.5,15.8-3,18.8-4.6
		c2.4-1.3,5.3-2.3,6.3-2.3s2.2-0.4,2.5-1c1-1.6,62.5-1.3,62.5,0.3c0,0.6-1.1,4.4-2.5,8.2c-1.3,3.9-2.5,7.7-2.5,8.5
		c0,1.4,13.8,12.2,17.2,13.5c0.7,0.3,4.7-2,8.8-5.1c4.1-3,8.1-5.9,8.8-6.3c1.1-0.6,0.9-2.3-1.1-8.7c-1.4-4.3-2.8-8.7-3.2-9.6
		c-0.7-1.7,0.9-1.8,25.8-1.8c22.8,0,26.8,0.2,28.1,1.6c0.9,0.8,1.6,1.9,1.6,2.4s0.6,0.7,1.4,0.4c0.8-0.3,2.5,0.1,3.8,0.9
		s9.5,2.5,18.3,3.7s23.4,3.2,32.5,4.5c9.1,1.3,24,3.4,33.3,4.6c9.2,1.3,17.1,2.6,17.7,2.9c0.7,0.5,1.4,163.7,1,273.3
		c0,6.8-1.3,8.7-2.9,4.5c-0.5-1.3-1.4-3.6-2-5.2c-0.7-1.6-1.4-2.7-1.6-2.4c-0.3,0.2,0.3,2.3,1.2,4.6c0.9,2.3,1.4,4.5,1.1,4.7
		c-0.3,0.3-2.6-0.4-5.2-1.5c-5.3-2.2-7.3-2.5-7.8-1c-0.2,0.5-4.3-0.1-9.8-1.4c-19-4.7-34-6.8-55-7.6c-21.5-0.9-164.8-2.6-188-2.3
		c-20.2,0.2-41.6,3.4-67.5,10c-6.7,1.7-10.1,2.1-10.3,1.4c-0.5-1.6-2.8-1.3-7.4,0.9C336.8,546.4,336,546.5,336,544.6z"
            />
            <path
              className="st1"
              d="M61.5,495.3C17.8,486-8.1,441.8,5.4,399.5c9.8-30.6,38.8-51.5,71.3-51.5c25.2,0,49.5,13.6,62.8,35
		c4.8,7.6,8.5,18.1,10.2,28.4c5.3,33.5-14.1,67.3-45.7,79.9C90,496.8,75.1,498.2,61.5,495.3z M83,465.9
		c18.4-2.9,31.6-15.4,36.5-34.4c2.1-8.2,1.9-12.1-1-21.2c-4.4-14-11.1-21.9-23.9-27.9c-29.4-14-63.2,8.1-62.4,40.7l0.1,6.4l0.7-8
		c0.9-9.7,2.3-14.4,6-21c8.6-15.1,27.7-23.9,44.7-20.6c16,3.2,26.7,12.1,32.8,27.5c2.4,6.1,2.6,7.9,2.3,16.5
		c-0.3,8.3-0.7,10.5-3.5,16.3c-7.5,16-22,25.1-39.7,25c-18.8-0.1-34.4-11.6-40.6-30c-1.4-4-1.8-4.7-1.5-2.2
		c0.8,5.3,6.5,15.6,11.3,20.6c6.8,6.8,19.7,12.5,30.2,13.3C75.8,466.9,79.4,466.5,83,465.9z"
            />
            <path
              className="st1"
              d="M939.5,495.3c-32.2-6.8-55.5-32-59.5-64.4c-3.2-25.6,7.9-52,28.3-67.5c21.8-16.5,50.2-20,75.2-9.2
		c9.7,4.3,16.9,9.4,24.5,17.5c40.1,42.7,17.6,111.9-40.2,123.7C958.4,497.4,948.8,497.3,939.5,495.3z M968.8,463.8
		c6.9-2.6,15.3-8.4,19.1-13.2c4-5,7.9-13.2,8.6-17.6c0.3-2.5-0.1-1.8-1.5,2.2c-6.2,18.4-21.8,29.9-40.6,30c-17.7,0.1-32.2-9-39.7-25
		c-2.8-5.8-3.2-8-3.5-16.3c-0.3-8.6-0.1-10.4,2.3-16.5c6.1-15.4,16.8-24.3,32.8-27.5c17-3.3,36.1,5.5,44.7,20.6
		c3.7,6.6,5.1,11.3,6,21l0.7,8l0.1-6.4c0.8-32.6-33-54.7-62.5-40.7c-13.1,6.3-20.9,16.1-24.8,31.1c-1.9,7.4-1.9,10.6,0,18
		C917.5,458.6,943.7,473.1,968.8,463.8z"
            />
            <path
              className="st1"
              d="M514.1,267.6c-3.5-2.5-6.5-4.6-6.7-4.8c-0.2-0.2,0.9-4,2.4-8.4l2.8-7.9l8.1-0.3l8-0.3l2.7,7.1
		c1.4,3.9,2.6,7.7,2.6,8.5c0,1.1-11.7,10.5-13.2,10.5C520.6,272,517.6,270,514.1,267.6z"
            />
            {/* <path
              className="st1"
              d="M332,96.5V74h26h26v22.5V119h-26h-26V96.5z"
            />
            <path
              className="st1"
              d="M644,96.5V74l27.8,0.2l27.7,0.3v22v22l-27.7,0.3L644,119V96.5z"
            /> */}
            {/* <path
              className="st1"
              d="M453.5,55.4c-1.9-1.9-1.9-2.8-0.1-4.3c2-1.6,4.6-0.3,4.6,2.4C458,56.4,455.5,57.4,453.5,55.4z"
            />
            <path
              className="st1"
              d="M333.6,54.5c-0.7-1.9,2-4.6,3.9-3.9c0.8,0.4,1.5,1.7,1.5,3c0,1.9-0.5,2.4-2.4,2.4
		C335.3,56,334,55.3,333.6,54.5z"
            />
            <path
              className="st1"
              d="M571.4,54.5c-0.4-0.9,0-2.3,0.8-3.1c2-2,5-0.7,4.6,2C576.4,56,572.3,56.9,571.4,54.5z"
            />
            <path
              className="st1"
              d="M690.3,54.4c-0.3-0.8,0.2-2.3,1.1-3.2c1.5-1.5,1.7-1.5,3.2,0c2.1,2.1,1.1,4.8-1.6,4.8
		C691.9,56,690.7,55.3,690.3,54.4z"
            /> */}
          </g>
          <g id="layer103">
            <path
              className="st2"
              d="M422,1357.3c-12.5-1.4-52.8-6.5-54-6.8c-0.8-0.2-6.4-1.1-12.5-2c-6-0.9-13.8-2.1-17.2-2.6l-6.3-1.1v-50.9
		c0-28,0.3-50.9,0.6-50.9c0.4,0,2.3,0.8,4.3,1.9c3.3,1.7,12.1,5.6,21.6,9.4c12.7,5.2,37.4,11.6,55,14.4c11,1.6,19.5,1.8,103.5,1.8
		c101.1,0,101.3,0,127-6.6c18.1-4.7,40.1-13.6,48.8-19.8c1.6-1.1,3.2-1.8,3.6-1.4c0.3,0.3,0.6,23.3,0.6,51v50.3l-2.2,0.9
		c-1.3,0.5-5.7,1.4-9.8,2.1c-4.1,0.6-12.2,2-18,3c-5.8,1.1-19.3,3.1-30,4.7l-19.5,2.7l-96,0.2C468.7,1357.7,423.9,1357.5,422,1357.3
		z"
            />
            <path
              className="st2"
              d="M111.5,1351.1c-10.5-2-14.5-5.3-14.5-12.2c0-3.3-0.4-4.9-1.3-4.9c-0.7,0-2.4-1.3-3.7-2.8
		c-1.9-2.2-4.8-3.5-12.5-5.6c-10.8-2.9-15.7-5.6-17.6-9.6c-0.9-1.8-1.3-16.3-1.4-55.8l-0.1-53.2l3.6-1c1.9-0.5,6.4-1.6,10-2.5
		s9.6-2.8,13.4-4.1c5.3-1.8,7.2-2.1,7.7-1.2c0.6,0.9,1,0.8,1.5-0.5c0.3-0.9,5.6-4.2,11.8-7.2c28.7-14.2,48.7-36.9,54.2-61.5
		c2.1-9.5,2.1-26.9,0.1-37.2c-4.2-20.8-16.6-39.4-35.5-53.5c-7.4-5.6-26.5-16.3-28.9-16.3c-0.7,0-1.3-0.7-1.3-1.6
		c0-1.1-0.5-1.4-1.6-1c-0.9,0.4-5.5-0.7-10.3-2.3c-6.7-2.3-22.3-6.1-24.7-6.1c-0.2,0-0.4-4.1-0.4-9.1c0-8.1,0.2-9,1.7-8.5
		c0.9,0.4,5.5,1.8,10.2,3.1s11.3,3.3,14.5,4.5c3.3,1.1,7.4,2,9.1,2c1.8,0,3.8,0.7,4.5,1.5c0.7,0.8,4.2,2.9,7.9,4.5
		c20.9,9.6,32,16.7,43.7,28.4c12.4,12.4,19.2,23,24,37.6c1.5,4.7,3,7.7,3.2,6.8c0.2-1,0.6-1.8,0.9-1.8c0.3,0,2.5,2.3,5,5
		c7.9,8.8,16.2,11.4,27.3,8.6c6.6-1.7,16.7-5.8,21-8.6c36.1-23.4,63.5-45.3,91.9-73.7l19.4-19.4l-0.7,7.3c-1,10.8-6.2,41.3-9.7,57.2
		c-6.2,27.7-9.9,36.4-46.8,110.4c-13.3,26.5-24.1,48.5-24.1,48.7c0,0.2-2.2,4.8-4.8,10.2c-5.7,11.6-8,19.1-12.7,41.5
		c-12,57.5-20.8,76.8-35.3,76.8c-2.2,0-4.4-0.5-4.7-1.1c-0.4-0.6,0.1-7.3,1.1-15c1-7.6,1.6-14.1,1.3-14.3
		c-0.2-0.3-11.5-1.7-24.9-3.1c-30.9-3.4-28.8-2.9-29.2-6.3c-0.2-1.7-0.8,0.1-1.6,4.8c-4,25-7,34.5-11.8,37.7
		C135.6,1349.8,118.6,1352.4,111.5,1351.1z M257.5,1199.5c26.6-44.1,44.4-76.5,51.3-93c13-31.1,31-95.5,26.7-95.5
		c-1,0-42.5,39.9-68.6,65.9c-15.1,15-21.8,22.5-22.4,24.6c-1.2,5.1-1.9,119.8-0.6,119.4C244.4,1220.7,250.6,1211.1,257.5,1199.5z"
            />
            <path
              className="st2"
              d="M247.6,1180.7c-0.4-13.3-0.3-36.4,0.1-51.2c0.8-25.3,1-27.2,3-30c1.8-2.6,43.6-43.7,70.7-69.5l8.9-8.5
		l-0.7,4.5c-1,6.8-6,24.2-13.3,46.5c-11.2,34.2-16.3,45.6-35.8,79.5c-14.9,26-30.4,51.8-31.5,52.5
		C248.6,1204.8,247.9,1194.1,247.6,1180.7z"
            />
            <path
              className="st2"
              d="M907,1351.4c-10.4-1.9-16-3.8-18.4-6.3c-3.5-3.7-7.1-14.4-8.6-25.6c-2.2-17-1.9-16.1-3.6-13.6
		c-1.1,1.5-2.6,2.1-5.2,2.1c-3.9,0-48.4,5-49,5.6c-0.2,0.1,0.5,6.7,1.7,14.5c1.1,7.8,1.8,14.6,1.4,15.2c-0.3,0.5-3,0.7-6,0.5
		c-4.6-0.4-6-1-9.3-4.3c-4.5-4.4-10.5-15.8-13.2-25.3c-5.4-18.5-8.1-29.3-11.8-46.7c-2.2-10.4-5.2-22.6-6.6-27
		c-1.4-4.4-13-28.9-25.6-54.5c-50.5-101.9-50.1-100.9-57.2-134c-4.2-19.6-10.2-58.7-9.2-59.7c0.3-0.3,2,1.2,3.8,3.3
		c25,29.4,85.5,78.5,113.3,92.2c9.8,4.8,20.5,7.6,25.8,6.8c9-1.5,17.7-8,17.7-13.3c0-2.4-0.2-2.3-4,2c-9.3,10.5-23.4,10.1-43.6-1.4
		c-8.6-5-31.3-20.6-40.4-27.9c-2.5-2-8.1-6.5-12.5-10c-28.8-23.1-61.6-56.8-63-64.6c-2.2-12.6-3.8-45.9-4.2-90l-0.5-49.2l2.8-0.5
		c4.1-0.8,16.3-1.5,44.4-2.7c23.8-1,59.6-3.6,62.2-4.5c2.5-0.8,40.5-3.6,61.3-4.4c29.4-1.1,59.4,1.2,101.8,8l19.7,3.2v74.8
		c0,41.1-0.4,75-0.8,75.3c-0.5,0.3-5.1,1.6-10.3,3c-8.5,2.2-16,4.6-21.4,6.7c-1.1,0.4-5.1,2-9,3.4c-18.2,7-34,15.9-45.7,25.6
		c-2.6,2.1-5,3.9-5.5,4c-1,0-12.8,14.7-16.3,20.3c-5.2,8.2-13.1,22.8-12.6,23.3c1.3,1.4,6-2.5,7.2-6c2.2-6.5,12-21.8,18.3-28.8
		c5.8-6.4,16.8-15.4,24.1-19.8c5.8-3.5,30.3-15.3,33.5-16.2c1.7-0.4,7.5-2.3,13-4.2s12.7-4.3,16-5.2c3.3-1,6.6-2,7.3-2.2
		c0.9-0.4,1.2,1.7,1.2,8.5v9.1l-5.7,1.1c-3.2,0.6-10.9,2.7-17.1,4.6c-6.2,1.9-11.7,3.2-12.2,2.9c-0.6-0.3-1-0.2-1,0.3
		c0,0.6-4.2,3-9.2,5.5c-24.3,11.9-41.1,27.7-50.4,47.2c-5.4,11.4-7.3,19.1-8.1,33c-1.3,25.8,6.6,45.9,25.1,63.9
		c10.4,10,26.3,19.9,43.1,26.7c9.2,3.8,26.9,9.2,33,10.1c2,0.3,2,1.2,2.3,51.8c0.1,28.3,0,52.9-0.3,54.7c-0.3,1.8-1.7,4.6-3.1,6.2
		c-2.5,3.1-3.1,3.3-17.2,7.2c-4.7,1.3-9.4,3.3-10.8,4.6c-3.1,2.9-3.2,2.9-3.7-0.4c-0.2-1.6-0.5,0.9-0.6,5.4c-0.1,8-0.2,8.3-3.3,10.6
		c-1.8,1.3-4.8,2.9-6.6,3.5C920.4,1351.1,910.5,1352,907,1351.4z M786.8,1154.5c-0.3-47.8-0.5-53.3-2-55.5
		c-3.3-4.9-55.1-56-84.9-83.8l-5.6-5.2l0.4,5.2c0.8,9.8,5.1,26.7,14.4,55.8c10.1,31.5,19.2,52.6,31.5,73.1c1.9,3.1,3.4,6,3.4,6.5
		c0,0.4,0.6,1.5,1.4,2.3c0.8,0.9,2.8,4.3,4.6,7.6c1.7,3.3,4,7.4,5,9c1.1,1.7,2.7,4.5,3.7,6.2c1,1.8,7.7,13,14.8,24.9l13,21.7
		l0.3-7.4C787,1210.8,787,1183.6,786.8,1154.5z M785,948.9V844.7l-12.7,0.6c-7.1,0.3-26.3,1-42.8,1.7c-16.5,0.6-32.5,1.4-35.5,1.8
		l-5.5,0.7V902c0,63.5,0.7,69.7,8.6,81.6c7.4,10.9,25.4,27.8,45,42.2c6.6,4.8,27.8,19.2,28.3,19.2c0.2,0,3.5,1.8,7.2,4
		c3.8,2.2,7,4,7.1,4C784.9,1053,785,1006.1,785,948.9z"
            />
            <path
              className="st2"
              d="M775.6,1195.3c-23.2-38.5-48.6-84.6-48.6-88.2c0-0.6-0.6-2.2-1.4-3.4c-2.1-3.2-16.9-47.9-21-63.2
		c-5.6-21.1-5.7-19.9,1.6-13c36.2,34.1,72.5,70.5,74.5,74.5c1.5,3.1,1.7,8.9,2.1,53.3c0.3,28.1,0.1,49.7-0.4,49.7
		S778.8,1200.6,775.6,1195.3z"
            />
            <path
              className="st2"
              d="M766.5,1038.5c-15.8-10.1-33.5-23.1-33.5-24.5c0-0.6,8.3-1,24-1h24v17c0,9.4-0.3,17-0.7,17
		C779.8,1046.9,773.7,1043.2,766.5,1038.5z"
            />
            <path
              className="st2"
              d="M723.3,1006.9c-9.5-8.3-20.6-20.4-24-26.1c-6.7-11-6.8-12.2-6.8-73.3v-55l14-0.7c7.7-0.3,25-1.1,38.5-1.8
		c13.5-0.6,27.1-1.3,30.3-1.6l5.7-0.6v82.1v82.1h-26h-26L723.3,1006.9z"
            />
            <path
              className="st2"
              d="M418.8,1267.9c-9.4-1-30.3-5.3-38.3-7.9c-8.8-2.8-15.4-5-21-7c-6.4-2.2-25.7-10.9-26.9-12
		c-0.5-0.6,0.2-6.7,1.8-15.2c1.5-7.9,3.8-20.4,5.2-27.8s3.6-19.6,5-27s3.6-19.3,4.9-26.5c1.3-7.1,3.5-19.1,4.9-26.5
		c1.4-7.4,3.9-21.1,5.6-30.5c1.7-9.3,4.2-22.6,5.5-29.5c1.2-6.9,2.6-14.2,2.9-16.2c0.5-2.8,1.3-3.9,2.9-4.3c9.2-2.1,23.7-5,38.6-7.7
		l17.6-3.3H516h88.5l16.5,3.2c22.6,4.4,37.1,7.9,38,9.2c0.3,0.6,1.4,5.5,2.4,10.9c1,5.3,2.8,15.3,4.1,22.2s3.5,19,5,27
		s3.7,20.1,5,27s3.5,19,5,27s3.7,20.1,5,27s3.5,19,5,27s3.5,18.7,4.5,23.8l1.7,9.2l-5.6,3.4c-20.5,12.3-51.3,22.1-77.6,24.6
		C601.5,1269.1,429.8,1269.1,418.8,1267.9z M671.7,1182.3c-0.4-28.4-0.5-30.5-3.5-44.8c-2.8-14-11.3-48.8-14.5-60
		c-0.8-2.7-3.1-11.1-5.2-18.6l-3.7-13.6l-7.1-1.2c-4-0.7-13.5-2.5-21.2-3.9l-14-2.7H513l-89.5,0.1l-18.9,3.1
		c-10.3,1.8-19,3.4-19.3,3.7c-1.1,1.1-13.7,49.5-18.7,72.4c-7.4,33-8.6,42.7-8.6,70.3v24.9h157.1h157.1L671.7,1182.3z"
            />
            <path
              className="st2"
              d="M362,1184.2c0-21.9,0.3-26.4,2.5-38.9c3.2-18.5,7.3-36.9,14.2-63.3c3-11.8,6.2-24.2,7-27.5
		c0.9-3.3,1.9-6.3,2.2-6.7c0.4-0.4,8.1-2,17.1-3.5l16.5-2.8h91h91l19,3.4c10.5,1.8,19.1,3.4,19.2,3.6c0.3,0.1,3.1,10.2,8.8,30.5
		c3.8,13.9,11.5,45.6,14.2,59c2.4,11.4,2.7,15.2,3,41.8l0.5,29.2H515.1H362V1184.2z"
            />
            <path
              className="st2"
              d="M59.5,1181.5c-26.7-6.9-45.3-24.2-54.1-50.5c-2.6-7.6-2.9-9.8-2.9-21.5c0-10.8,0.4-14.2,2.3-20.5
		c6.7-21.1,19.2-36.2,37.7-45.5c12.5-6.3,19.6-7.9,33.5-8c22.2,0,39.1,7.3,54.3,23.5c38.4,40.8,18.6,108.1-35.7,122
		C85.4,1183.3,67.6,1183.6,59.5,1181.5z M86.5,1152.5c12.7-3.4,23.5-11.6,28.8-22.1c3.5-6.9,5.7-14.9,5.7-20.8
		c0-11.5-7.1-27.3-15.3-34c-23.6-19.1-57.3-11.8-70,15.2c-2.6,5.6-3.2,8.2-3.5,15.8c-0.5,10.2,1,16.9,5.5,25
		C47,1148.3,68,1157.3,86.5,1152.5z"
            />
            <path
              className="st2"
              d="M60.7,1148.9c-13.2-5.2-21.8-14.8-25.8-28.7c-3.3-11.5-2.1-20.4,4.5-32.6c7.8-14.6,26.9-23.7,43.5-20.7
		c30.2,5.5,45.4,38,30,64.4c-3.9,6.5-7.1,10-13,13.7C87.9,1152.8,74.1,1154.1,60.7,1148.9z"
            />
            <path
              className="st2"
              d="M935,1181c-33.1-8.9-55.3-38-55.1-72.5c0.1-29.4,18.6-56.8,45.8-67.8c10-4,16.2-5.2,28.3-5.2
		c13.9,0.1,21,1.7,33.5,8c18.5,9.3,31,24.4,37.7,45.5c1.9,6.3,2.3,9.7,2.3,20.5c0,11.7-0.3,13.9-2.9,21.5
		c-8.2,24.4-23.9,40.3-48.6,49C966.6,1183.4,945.7,1183.9,935,1181z M963.8,1152.5c16.4-3.9,28.1-15,32.8-31.3
		c1.2-3.9,1.5-8.2,1.2-14.6c-0.3-7.6-0.9-10.2-3.5-15.8c-12.7-27-46.4-34.3-70-15.2c-8.2,6.7-15.3,22.5-15.3,34
		c0,14.9,9.8,31.3,22.9,38.3C943,1153.8,952.5,1155.2,963.8,1152.5z"
            />
            <path
              className="st2"
              d="M939.5,1149.7c-10.6-4-17-9.2-22.4-18.4c-15.4-26.4-0.2-58.9,30-64.4c16.6-3,35.7,6.1,43.5,20.7
		c6.6,12.2,7.8,21.1,4.5,32.6c-2.5,8.8-6.1,14.7-12.7,20.7C971.1,1151.2,953.4,1154.8,939.5,1149.7z"
            />
            <path
              className="st2"
              d="M195.3,1088.1c-5.4-2.5-10.3-8.8-19.3-25c-4-7.2-10.3-16.7-13.9-21.2c-3.6-4.4-7.1-8.9-7.7-10
		c-0.6-1-1.3-1.7-1.6-1.4c-0.3,0.3-2.5-1.1-4.9-3.1c-9.7-8.2-31.9-20.6-44.8-25c-3.2-1.1-5.6-2.6-5.9-3.6c-0.5-2-1.8-2.4-2.4-0.8
		c-0.2,0.7-1.9,0.5-4.8-0.6c-2.5-0.9-10.1-3.3-17-5.3l-12.5-3.7l-0.3-74L60,840.3l6.7-1.2c3.8-0.7,10.8-1.9,15.6-2.6
		c4.9-0.8,9.5-1.9,10.3-2.6c0.8-0.7,2.8-0.9,4.9-0.6c1.9,0.3,6.3,0.2,9.7-0.3c3.5-0.5,14-1.6,23.3-2.5c10.5-1,18.1-2.2,19.8-3.2
		c2.2-1.1,3.4-1.2,5.5-0.4c1.5,0.6,13.3,1.5,26.2,2.1c28.1,1.2,46.8,2.6,61,4.5c10.7,1.5,24.1,2.4,75.8,5.1
		c16.1,0.8,30,1.8,30.9,2.1c1.4,0.5,1.5,5.6,1,47.7c-0.5,43.7-0.9,54.4-3.8,82.6l-1,10.5l-5.7,7c-15.8,19.7-43.9,45.3-76.4,69.7
		C226.6,1086.3,208.6,1094.1,195.3,1088.1z M273,1037.7c35.2-23.3,58.4-45.1,65.3-61.2c3.8-8.9,4.1-13.6,4.2-71.4
		c0.1-38.4-0.2-56.4-1-56.6c-1.1-0.4-88-4.6-93.2-4.5H245v105.5V1055l8.8-5.2C258.6,1047,267.2,1041.5,273,1037.7z"
            />
            <path
              className="st2"
              d="M249,947.3v-99.6l9.8,0.6c5.3,0.4,21.4,1.1,35.7,1.7c14.3,0.6,30.1,1.4,35,1.8l9,0.7l0.3,46.5
		c0.4,66.1-0.5,73.8-10.8,87.3c-4.6,6-21.9,22.9-25.8,25.2c-1,0.5-5,3.6-8.9,6.7c-11,8.9-41.4,28.8-44,28.8
		C249.2,1047,249,1002.2,249,947.3z"
            />
            <path
              className="st2"
              d="M370.4,1023.3c0.4-5.4,1.1-21.3,1.6-35.3c4.3-116.2,3.9-181.8-1.6-265.5c-1-13.7-1.7-26.3-1.8-28l-0.1-3
		l13.5-2.1c36-5.6,41.9-5.9,134-5.9c83.2,0,86,0.1,103.6,2.3c9.9,1.3,22.8,3.1,28.5,4l10.4,1.8l-0.3,9.4c-0.2,5.2-1,22.1-1.8,37.5
		c-3.8,74.6-3.9,151.6-0.4,234c1.9,42.9,2.3,60.5,1.6,60.5c-0.4,0-4.2-0.9-8.4-1.9c-4.3-1.1-15.3-3.4-24.7-5.3l-17-3.3H516h-91.5
		l-18,3.3c-9.9,1.9-21.6,4.2-26,5.3C368.8,1033.9,369.6,1034.5,370.4,1023.3z M584.8,838.7c7.5-4,12.7-9,15.9-15.5l2.8-5.7v-29v-29
		l-2.8-5.7c-3.3-6.7-9-12.1-16.6-15.7l-5.6-2.6h-65h-65l-5.6,2.6c-7.3,3.5-13.4,9-16.7,15.3l-2.7,5.1l-0.3,27.9
		c-0.4,32.3,0.2,35.5,7.4,43.5c4.3,4.8,12.4,9.8,17.8,11.2c1.7,0.4,31.9,0.7,67.1,0.6l64-0.2L584.8,838.7z"
            />
            <path
              className="st2"
              d="M450.2,839.5c-11.7-2.6-20.4-9.8-23.9-19.9c-1.6-4.4-1.8-8.7-1.8-31.1c0-18.2,0.4-27.3,1.3-30.2
		c2.5-8.3,11.8-17.4,21-20.5c4.9-1.6,115.2-2.4,126.4-0.9c4.3,0.6,9.6,2,11.9,3.1c6.3,3.2,12.4,9.5,15,15.3
		c2.3,5.1,2.4,5.9,2.4,33.3v28l-3,5.9c-3.6,7.1-11.2,13.7-18.7,16.2c-4.8,1.6-10.9,1.8-64.8,2C468.1,840.8,455.3,840.6,450.2,839.5z
		"
            />
            <path
              className="st2"
              d="M60,698.1v-138l3.3-2.5c7.2-5.5,30.6-13.5,31.5-10.8c0.5,1.7,2.2,1.5,2.2-0.2c0-1.8,12.6-4.1,34-6
		c45-4.1,84.8,0.5,118.6,13.6c5.3,2.1,4.7,1.3,17.5,23.9c0.9,1.6,2.1,3.4,2.7,4.1c5.5,6.8,67.9,118.6,70.4,126.2
		c2.7,8.5,6.4,31.5,7.8,48.1c0.6,7.7,1.4,28.8,1.7,46.9l0.6,32.8l-5.9-0.5c-10.6-1.1-20.5-1.7-45.9-2.8c-23.5-1-31.1-1.6-69.5-5.3
		c-20.3-2-48.3-3.6-63-3.6c-11.5,0-11.9-0.1-12.3-2.2c-0.4-2.1-0.4-2.1-0.6-0.3c-0.1,2-1.6,2.2-27.3,4.9c-15,1.6-27.5,3-27.7,3.2
		c-0.2,0.2-1-0.1-1.8-0.7c-0.9-0.8-1.3-0.8-1.3-0.1c0,0.6-1.5,1.4-3.2,1.7c-1.8,0.3-8.9,1.4-15.8,2.5c-6.9,1.1-13.3,2.3-14.2,2.6
		C60.1,836.1,60,829.1,60,698.1z M344,813.8c0-16.5-1.7-53.1-3-65.8c-1.6-14.4-4.6-28.7-7.8-36.5c-6.6-15.7-30.8-61.6-40.7-77
		c-1.7-2.7-4-6.5-5.1-8.4c-7.5-13.4-28.5-43.6-36.4-52.1l-5.9-6.5L245,693.7v126.1l4.8,0.6c2.6,0.3,9,0.8,14.2,1.1
		c9.9,0.6,58,4.2,64,4.8c1.9,0.2,6.3,0.5,9.8,0.5l6.2,0.2V813.8z"
            />
            <path
              className="st2"
              d="M313,820.9c-11.3-0.9-28.4-2.2-38-2.8c-9.6-0.6-19.4-1.4-21.7-1.7l-4.3-0.6V697.9c0-78,0.3-117.9,1-117.9
		c2.1,0,17.8,22,30.6,43c2.5,4.1,5.9,9.8,7.6,12.5c17.5,28.5,38.3,69,43.2,83.6c4.5,13.7,6.5,34.4,8.2,83.2l0.7,20.7l-3.4-0.1
		C335,822.8,324.3,821.9,313,820.9z"
            />
            <path
              className="st2"
              d="M680,822.9c0-17.6,1.7-58.4,3.1-72.9c1.4-15.2,4.5-33,7.1-41c1.6-4.9,20.9-41.3,30.8-58
		c0.5-0.8,7.5-13.2,15.6-27.5c8.1-14.3,18.6-32.3,23.3-40c4.6-7.7,10-16.8,11.9-20.3c3.8-7,5.2-8,18.2-12.4
		c19.6-6.6,43.4-10.6,68.9-11.5c13.3-0.5,16.5-0.3,17.2,0.8c0.8,1.2,1,1.2,1.8,0c2.3-3.5,59.8,4.4,75.6,10.4
		c6.8,2.5,10.6,4.6,14.3,7.9l2.2,1.9v137.9c0,130.9-0.1,137.9-1.7,137.4c-1-0.3-7.4-1.5-14.3-2.6c-6.9-1.1-14-2.2-15.7-2.5
		c-2.2-0.4-3.3-1.2-3.3-2.2c0-1.5-0.1-1.5-1.2-0.1c-1.1,1.4-2.3,1.5-7.3,0.8c-5.2-0.8-13.9-1.7-42.7-4.7c-4.8-0.5-5.8-0.9-5.8-2.4
		c0-1.1-0.4-1.9-1-1.9c-0.5,0-1,0.9-1,2c0,1.9-0.7,2-10.8,2c-19.7,0-58.7,2.7-86.2,5.9c-7.7,0.9-29,2.3-66.5,4.1
		c-11.5,0.6-23.6,1.3-26.7,1.7l-5.8,0.6V822.9z M718,825c13.5-1.1,31.5-2.4,40-3c8.5-0.5,18.3-1.3,21.8-1.6l6.2-0.6V693.7V567.6
		l-5.1,4.9c-7.2,7-16.3,19.7-31.1,43c-20.6,32.5-42.4,72.4-52.4,95.8c-5.6,13.2-8.8,36.3-9.9,71.7c-0.3,10.2-0.8,24.2-1.1,31.3
		l-0.5,12.7h3.8C691.8,827,704.5,826.1,718,825z"
            />
            <path
              className="st2"
              d="M691,808.3c0-36.4,3.7-77,8.1-89.1c3.1-8.5,10.6-24.2,22-46.2c8.8-16.8,30.9-54.1,34.2-57.7
		c1.9-2.1,2.9-2.3,13.9-2.3H781v101.4v101.4l-5.2,0.6c-2.9,0.3-12.5,1.1-21.3,1.6c-18.6,1.2-51.8,3.8-58.7,4.5l-4.8,0.6V808.3z"
            />
            <path
              className="st2"
              d="M758,611.4c0-1.7,21.4-32.4,22.6-32.4c0.2,0,0.4,7.4,0.4,16.5V612h-11.5C763.2,612,758,611.7,758,611.4z"
            />
            <path
              className="st2"
              d="M366.5,684.8c-0.3-1.3-2.6-10.8-5-21.3c-2.5-10.4-5.5-22.8-6.6-27.5c-1.1-4.7-4.6-19.3-7.9-32.5
		c-9.9-41.1-12.3-51.5-11.9-51.9c0.8-0.7,39.4-9.6,52.6-12.1c7.3-1.3,18.6-2.9,25-3.4c14-1.1,58.2-0.3,60.1,1.2
		c0.8,0.6,1.2,0.6,1.2-0.2c0-0.8,14-0.9,52.3-0.5c103.2,1.1,100.2,1,114.5,3.3c12.6,2,54.2,10.8,55.1,11.7c0.2,0.2-1.1,5.9-2.9,12.6
		c-8.6,32.1-11.2,41.7-15.9,59.3c-10.5,39.4-17,62.7-17.5,63.3c-0.4,0.3-5.5-0.2-11.4-1.1c-41.6-6.4-36.7-6.2-133.2-6.2
		c-95.3,0-90-0.2-131.3,5.6C366.6,687.5,367.1,687.5,366.5,684.8z"
            />
            <path
              className="st2"
              d="M58.2,536.8l0.3-18.2l10.2-1.7c18.7-3.2,39-10.9,53.1-20.3c10.6-7.1,22.8-19.6,28.3-29.1
		c20.1-34.5,15.3-80.6-11.3-107.4c-4.7-4.8-17.6-14.6-22.3-17.1c-1.6-0.9-3.9-2.1-5-2.8c-1.7-1-9.2-4.4-16-7.2
		c-4.5-1.9-11.7-3.8-24.2-6.5L58,323.6v-32.1v-32.1l9.3-4.3c5-2.3,10.1-4.8,11.2-5.4c6.4-3.4,13.6-6.7,14.8-6.7c1.8,0,2-0.6,3.8-9.4
		c1-5.4,2.1-7.7,4.6-10.4c3.3-3.4,3.4-3.5,9.5-2.8c3.5,0.3,12.2,1.1,19.5,1.6c14,0.9,19.4,2.5,21.5,6.4c1.2,2.2,1.3,42.7,0.2,51.3
		c-0.5,3.1-0.3,4.4,0.7,4.7c4.9,1.3,12.7,3.9,21.4,7c15.4,5.6,21.5,7.5,21.9,6.7c0.2-0.3,0.7-6.4,1.1-13.5c0.9-14.8,1.5-18,3.8-18.4
		c1.8-0.4,6.2,5.9,7.3,10.5c0.4,1.5,1.3,3.7,1.9,4.8c2.4,4,13.5,41.8,13.5,45.9c0,1,0.7,4.4,1.5,7.5c1.6,6.5,5.9,39,7.4,56.6
		c0.6,6.6,2.2,25.5,3.6,42c5.1,60.3,9.4,90.3,15.5,107.9c2.8,8.2,2.7,10.6-0.6,10.6c-1.4,0-3.8-0.6-5.2-1.4
		c-7.3-3.8-33.6-9.9-52.7-12.3c-41.2-5.2-105.3,2-126.1,14.2c-2.3,1.4-5.4,2.5-6.9,2.5H58L58.2,536.8z"
            />
            <path
              className="st2"
              d="M965.4,552.5c-3.6-2.8-17.4-7.5-29.2-10.1c-21.3-4.6-59.1-8-77.2-7c-25.8,1.5-48.7,5.6-69.7,12.4
		c-6.2,2-11.5,3.3-11.9,3c-0.3-0.4,0.3-3.5,1.4-7c4.9-15.7,6.5-23.2,9.6-45.8c2.5-18.4,5.9-53.3,7.7-79c1.6-24.1,5.8-61.7,8.6-77
		c5.9-33.2,19.5-75,24.3-75c1.6,0,1.9,1.4,2.5,10.8c0.4,5.9,1,13.5,1.4,16.9l0.6,6.1l6-2.3c10.9-4.2,29.9-10.8,34.5-12l4.5-1.2
		l-0.4-26.6c-0.3-23.9-0.2-26.9,1.3-29.2c2.7-4.1,7.9-5.8,20.6-6.6c6.3-0.5,14.5-1.1,18.3-1.5c5.8-0.6,7-0.4,8.8,1.2
		c3.2,2.9,5.2,7.4,5.8,13.4l0.6,5.5l19,9.5l19,9.5v31.4v31.5l-7.9,1.3c-8.5,1.4-25.8,5.7-29.1,7.3c-16.2,7.3-20.7,9.7-27.7,14.3
		c-21.5,14.1-35.4,35.6-38.7,60c-3.7,26.5,2.7,52.3,17.4,70.7c8.9,11.1,24.5,23.4,36.5,28.6c5.8,2.5,10.4,4.5,12.5,5.3
		c5,2.1,14.9,4.6,25.5,6.5l11.5,2.1l0.3,17.3L972,554h-2.3C968.4,554,966.5,553.3,965.4,552.5z"
            />
            <path
              className="st2"
              d="M336,545.1c0-0.5,0.5-2.2,1-3.7c1.4-3.5,0.4-4.4-1.1-1c-0.7,1.4-1.6,2.6-2.1,2.6c-0.4,0-0.8-62-0.8-137.8
		V267.3l17.3-2.7c9.4-1.5,24.2-3.8,32.7-5.1c52.9-8.2,50.7-7.7,62.2-13.6c2.2-1.1,62.8-1.2,62.8-0.1c0,0.5-1.1,4.2-2.5,8.2
		s-2.5,8.1-2.5,9.1c0,2.2,16.7,14.2,18.7,13.5c2.8-1.1,17.3-12.1,17.3-13.2c0-0.6-1.1-4.4-2.5-8.4c-1.4-4-2.5-7.9-2.5-8.7
		c0-1,5.1-1.3,26-1.3h26l1.6,2.6c1.1,1.5,2.3,2.3,3.2,1.9c0.8-0.3,2.2,0.1,3.1,0.8c1.6,1.4,14.5,3.5,57.1,9.2
		c27.2,3.7,45.2,6.3,45.6,6.8c0.3,0.2,0.6,194,0.4,272.5c0,3.9-0.4,7.2-1,7.2c-0.5,0-1.7-2.2-2.7-5c-1-2.7-2.1-5-2.5-5
		c-1.1,0-1,0.4,0.8,5c0.9,2.3,1.4,4.3,1.1,4.6c-0.3,0.3-2.4-0.4-4.7-1.6c-3.1-1.6-5.2-2-7.6-1.5c-1.9,0.3-6-0.1-9.6-1.1
		c-3.5-0.9-13.7-2.9-22.8-4.6l-16.5-2.9L528,532.4c-76.7-1-106.7-1.1-116-0.3c-13,1.1-35.3,5.1-52.5,9.2c-5.5,1.4-10.1,2.1-10.3,1.6
		c-0.6-1.5-4.1-1-8.2,1.1C336.6,546.3,336,546.4,336,545.1z"
            />
            <path
              className="st2"
              d="M66.8,496c-29.6-4.6-52.7-24.1-61.5-51.8c-3.2-10.2-4.1-25.9-2-35.9c3.3-15.4,9.8-27.4,20.7-38.3
		c11.5-11.3,22.7-17.3,38.9-20.6c15.9-3.2,32.1-0.5,48.6,7.9c6.2,3.1,10.1,6.2,17,13.1c7.7,7.7,9.8,10.6,13.7,18.6
		c5.4,11.1,7.9,21.3,7.9,32.5c0.2,40.3-29.7,72.2-70.1,74.9C75.9,496.6,69.9,496.5,66.8,496z M87.1,465.4
		c16.7-4.9,27.3-15.5,32.3-32.3c2.1-7.2,2-14.1-0.3-22.3C113.3,390.7,96.7,378,76,378c-11.9,0-21.1,3.6-30.2,11.9
		c-9.1,8.3-13.8,19.2-13.8,32.2c0,9,1.9,15.9,6.6,23.9C48,462,69.3,470.6,87.1,465.4z"
            />
            <path
              className="st2"
              d="M63.5,463.3c-2.7-0.8-5.7-2.1-6.5-2.8c-0.8-0.7-2.4-1.5-3.5-1.9c-1.1-0.3-4.2-2.7-6.8-5.3
		c-11.4-11.2-16.2-27.5-12.1-41.4c5.3-17.9,17.6-28.9,36-32c6.2-1.1,8-1,14.5,0.5c20.6,5.1,33.8,21.5,33.9,42.2
		c0,10.1-4.8,22.3-11.8,29.7c-3.9,4.1-13.5,9.7-19.5,11.3C81.1,465.4,69.9,465.2,63.5,463.3z"
            />
            <path
              className="st2"
              d="M948,496.4c-11.4-1.9-15.5-2.9-21.9-5.5c-28.5-11.4-46.3-38.1-46.2-69.4c0-11.2,2.5-21.4,7.9-32.5
		c3.9-8,6-10.9,13.7-18.6c6.9-6.9,10.8-10,17-13.1c16.5-8.4,32.7-11.1,48.6-7.9c16.2,3.3,27.4,9.3,38.9,20.6
		c15.5,15.4,22.8,34.2,21.7,56c-2,38.1-31.3,67.6-69.7,70.3C953.9,496.6,949.4,496.6,948,496.4z M965.1,465.4
		c16-4.8,26.8-15.3,31.4-30.6c1.9-6.5,1.9-18.8,0-25.1c-3.2-10.7-12-21.8-20.8-26.3c-17.9-9.3-39.7-6.3-53,7.2
		c-6,6.1-9.4,11.9-11.8,20.2c-3.2,11.3-2.1,20.9,3.8,32.6C923.5,460.9,946.5,470.9,965.1,465.4z"
            />
            <path
              className="st2"
              d="M941.8,463.5c-17.5-4.8-30.8-22.5-30.8-40.9c0.1-20.7,13.3-37.1,33.9-42.2c6.5-1.5,8.3-1.6,14.5-0.5
		c18.4,3.1,30.7,14.1,36,32c4.1,13.9-0.7,30.2-12.1,41.4c-2.6,2.6-5.7,5-6.8,5.3c-1.1,0.4-2.7,1.2-3.5,1.9
		C968.3,464.5,951.3,466.1,941.8,463.5z"
            />
            <path
              className="st2"
              d="M515,267.9c-3-2.3-5.9-4.5-6.4-5c-0.6-0.5,0-3.8,1.4-8.4l2.4-7.6l8.4,0.3l8.5,0.3l1.7,5
		c3.5,10.4,3.7,9.7-3.5,14.8c-3.6,2.6-6.6,4.7-6.8,4.7C520.6,272,518,270.1,515,267.9z"
            />
            {/* <path
              className="st2"
              d="M332,96.5V74h26h26v22.5V119h-26h-26V96.5z"
            />
            <path
              className="st2"
              d="M644,96.5V74h27.5H699v22.5V119h-27.5H644V96.5z"
            /> */}
          </g>
          <g id="layer104">
            <path
              className="st3"
              d="M423.5,1357.3c-2.2-0.2-13.2-1.5-24.5-2.9c-18.7-2.2-29-3.7-55.8-7.9c-5.1-0.8-9.8-1.5-10.3-1.5
		s-0.9-20-0.9-51c0-28,0.3-51,0.8-51c0.4,0,2.1,0.8,3.7,1.8c3.7,2.2,23.2,10.2,33.5,13.7c11,3.7,24.9,7.1,39.6,9.7
		c12.8,2.3,13.6,2.3,107.4,2.3c93.9,0,94.6,0,107.5-2.3c14.4-2.5,23.5-4.8,37-9.4c9.3-3.1,26-10.7,30.7-14c1.4-1,2.9-1.8,3.2-1.8
		s0.6,22.9,0.6,50.9v50.9l-2.7,0.6c-7.5,1.6-35.1,6-54.8,8.8l-22,3.2l-94.5,0.1C470,1357.6,425.7,1357.5,423.5,1357.3z"
            />
            <path
              className="st3"
              d="M112,1350.9c-10.8-1.6-15-5-15-12.2c0-4-0.3-5-2-5.4c-1.1-0.3-2-0.9-2-1.4c0-1.7-4.9-4-14.9-6.8
		c-10.5-2.9-14.4-5.3-16.3-10.1c-0.7-1.6-1.1-21.4-1.2-55.2l-0.1-52.7l12-3.2c6.6-1.7,14.2-4,16.9-5.1c3.6-1.4,5.1-1.6,5.6-0.7
		c0.6,0.8,1,0.7,1.6-0.4c0.5-0.8,5.6-3.9,11.4-6.9c5.8-2.9,13.2-7.1,16.5-9.3c7.7-5.1,19.3-16.2,25-23.7
		c19.1-25.4,20.2-63.5,2.7-93.1c-4.7-7.9-16.4-20.4-25.5-27.2c-4.7-3.5-26.3-15.5-27.8-15.5c-0.5,0-1.3-1-2-2.1
		c-0.7-1.4-1.4-1.8-1.8-1.1c-0.5,0.8-4,0.1-11.1-2.3c-5.8-1.8-13.5-3.9-17.2-4.5l-6.8-1.2v-9c0-8.1,0.2-8.9,1.7-8.3
		c1,0.3,7,2.1,13.4,4c6.3,1.9,12.8,3.9,14.3,4.5c1.5,0.5,4.2,1,6,1c1.9,0,4,0.7,4.7,1.7c0.8,0.9,5.2,3.4,9.9,5.5
		c4.7,2.2,10.8,5.1,13.5,6.5c24.4,12.6,43.7,34.1,51.4,56.9c3,8.7,4.1,11,4.1,8.1c0-1,0.5-1.7,1-1.7c0.6,0,1,0.4,1,0.9
		c0,1.6,8.3,9.2,12.2,11.2c5.7,2.9,11.4,3.3,19.2,1.4c10-2.5,18.3-6.7,33.6-17c34.3-23.2,64-48.2,89.8-75.8c5.5-5.9,8.2-8.2,8.2-7
		c0,3.2-3,25.4-4.5,32.8c-0.7,3.9-1.9,10.1-2.5,14c-1.7,10.2-6.7,30.8-9.7,40c-4,12.2-14.8,35.3-41.3,88.5
		c-13.4,26.7-26.2,52.7-28.6,57.8c-4,8.6-10.4,28.3-10.4,32.1c0,2.1-6.4,31.2-8.5,38.8c-8.2,29-14,41-21.8,44.6
		c-4.3,2.1-10.6,2.2-11.3,0.3c-0.3-0.7,0.4-7.6,1.4-15.2c1.1-7.6,1.9-14,1.8-14.1c-0.2-0.2-15.2-2-41.1-4.8
		c-7.1-0.8-13.1-1.5-13.2-1.5c-0.2,0-0.3-1.1-0.3-2.5s-0.4-2.5-0.8-2.5c-0.5,0-1.3,4.8-2,10.8c-1.4,13.4-3.9,23.4-7.5,29.4
		c-2.4,4.1-3.4,4.9-8.5,6.4C128,1350.7,117.8,1351.7,112,1350.9z M259.2,1197c25.8-43.2,45.3-78.2,49.2-88.7c0.8-2.1,2.6-6.9,4-10.8
		c12.2-32.7,23.6-73.3,23.6-83.7v-4l-21.2,20.2c-38.5,36.7-69.5,68.2-70.3,71.5c-0.4,1.7-0.9,29.6-1.2,62c-0.4,51.6-0.3,58.8,1,57.5
		C245.1,1220.2,251.8,1209.4,259.2,1197z"
            />
            <path
              className="st3"
              d="M248,1156.8c0-26.6,0.3-50.1,0.6-52.3c0.6-3.6,2.6-6,19.9-23c33.7-33.4,60.5-58.8,61.2-58.2
		c0.3,0.4-0.6,5.3-2.2,10.9c-1.5,5.7-3.5,13.2-4.5,16.8c-2.3,8.7-13.2,41.1-17.6,52.3c-2,5-6.4,14.5-9.8,21.1
		c-9.9,19.1-44.8,79-46.7,80.1C248.4,1204.9,248,1186.2,248,1156.8z"
            />
            <path
              className="st3"
              d="M909.5,1351.2c-6.5-0.4-17.8-3.3-19.9-5.1c-4.2-3.7-8.6-16.9-10.1-30.6c-0.9-8.8-1.5-11.5-2.6-11.5
		c-0.5,0-0.9,0.7-0.9,1.5c0,1.6-1.4,1.9-17.5,3.5c-6,0.6-14.1,1.5-18,2c-3.8,0.5-9.6,1.2-12.8,1.5l-5.9,0.7l0.7,6.1
		c0.4,3.4,1.3,10,2.1,14.6c0.8,4.5,1.1,8.7,0.8,9.2c-0.8,1.4-8.2,1.1-11.3-0.5c-4.1-2.2-8.4-7.4-12-14.9
		c-5-10.2-11.3-32.4-16.6-58.7c-6.4-31.1-5.6-29.2-40-98c-37.1-74.3-41-83.2-46.9-107.2c-4.8-19.2-13.4-69.3-12.2-70.6
		c0.2-0.2,8.4,7.7,18.3,17.6c23.9,24,51.2,46.4,81.3,66.8c21.3,14.3,35.9,19.3,47.1,16.1c6.8-2,13.9-7.8,13.9-11.3
		c0-3.8,1.6-6.1,5-7.3c2.2-0.7,3.5-2.1,4.5-4.8c4.5-11.3,13-23.9,23-33.8c6.4-6.3,9.5-8.6,22.5-17.1c3.1-2,17.9-9.2,26.5-12.8
		c5.3-2.3,18.7-6.7,30.3-10.1l11.2-3.2v8.8v8.8l-5.7,1.1c-3.2,0.6-10.3,2.5-15.8,4.2s-11,3.1-12.2,3.2c-1.3,0.1-2.3,0.4-2.3,0.7
		c0,0.4-3.9,2.5-8.6,4.8c-13.5,6.5-25.1,14.6-34.4,24.1c-10.1,10.3-16.6,20.8-21.1,34.1c-3.1,9-3.3,10.1-3.3,25.4
		c-0.1,17.2,0.7,22.1,5.5,33.6c4.1,10.1,9.3,17.6,18.3,26.4c17.4,17,40.6,28.8,72.9,37.1l6.7,1.7l-0.1,52.1
		c0,55.6-0.2,57.2-4.9,60.8c-1.4,1-7.7,3.4-14,5.3c-7.7,2.2-12.1,4.1-13.2,5.5c-1.3,1.6-1.9,1.8-2.2,0.9c-0.2-0.8-0.7-2.1-0.9-2.9
		c-0.3-0.8-0.6,1.8-0.6,5.8c-0.1,4-0.6,8.2-1.1,9.3C930.6,1348.4,919.3,1351.9,909.5,1351.2z M786.5,1105.1l-0.7-6.3l-15.6-15.7
		c-15.3-15.3-60.5-59-70.9-68.5l-5.2-4.8l0.5,5.3c1.5,15.3,15.7,63.8,26.4,90.4c5.3,13.1,22.5,45.4,36.6,68.8
		c1.6,2.6,8.8,14.5,15.9,26.4l13,21.8l0.3-55.5C787,1136.5,786.8,1108.6,786.5,1105.1z"
            />
            <path
              className="st3"
              d="M770.4,1186c-23.2-38.7-37.2-64.4-45.2-83c-5.6-12.9-21.9-65.4-23.7-76l-0.8-4.5L717,1038
		c9,8.5,27,26.1,40.1,39c21.7,21.5,23.8,23.8,24.3,27.5c1,7.2,1.6,72.7,0.8,86.5l-0.7,13.5L770.4,1186z"
            />
            <path
              className="st3"
              d="M420,1267.9c-13.7-1.4-32.4-5.7-49.8-11.5c-16.1-5.4-38.2-14.9-38.2-16.5c0-0.5,1.1-6.6,2.4-13.6
		c1.4-7.1,3.9-20.4,5.6-29.8c1.7-9.3,4-21.5,5-27s3.3-17.6,5-27c1.7-9.3,4-21.5,5-27s3.3-17.6,5-27c1.7-9.3,4.2-22.6,5.5-29.5
		c1.3-6.9,2.6-14.4,3-16.7c0.6-3.7,1-4.2,3.8-4.8c1.8-0.3,7-1.4,11.7-2.5c14.3-3.2,36-6.9,46.9-8c13.2-1.3,157.2-1.3,170.1,0
		c11.5,1.2,28.1,4.2,45.2,8.2c10.9,2.5,12.7,3.2,13.2,5.1c0.3,1.2,1.7,8.5,3.1,16.2c1.4,7.7,4.2,22.6,6.1,33
		c2,10.5,3.9,21.3,4.4,24.2c0.5,2.9,1.9,10.3,3,16.5c3.1,16.4,12.3,65.9,18.6,100.1c2.1,11.6,3.2,10-13.1,18
		c-20.5,10.2-45.8,17.3-68.9,19.6C599.5,1269.2,432.8,1269.2,420,1267.9z M671.8,1182.3c-0.4-24.2-0.8-32.6-2.2-39.3
		c-2.7-13.3-6.4-29.6-9.2-40.5c-4.8-18.7-15.2-56.6-15.6-57.1c-0.2-0.1-9.5-1.9-20.8-4l-20.5-3.8l-84-0.4c-54.1-0.2-87.6,0.1-94,0.7
		c-13.4,1.5-37.6,5.1-39.5,6c-0.8,0.4-2.2,3.7-3.1,7.2c-0.9,3.5-3.6,13.6-5.9,22.4c-5.8,21.9-11.4,45.9-15.2,65
		c-2.9,15.1-3.1,17.6-3.5,43.8c-0.3,15.3-0.2,28.5,0.1,29.3c0.5,1.2,21.9,1.4,157.1,1.4h156.7L671.8,1182.3z"
            />
            <path
              className="st3"
              d="M363.2,1208.1c-1.1-0.7-1.3-6-1-27.2c0.4-28.8,0.5-29.5,8.9-66.9c3.6-16.3,12.1-50,15.4-61.6l1.5-5l13.2-2.2
		c7.3-1.2,17.8-2.7,23.3-3.2c13.5-1.3,166.6-1.3,177.5,0c11.7,1.4,38.3,6.1,39.3,6.9c0.8,0.8,4,11.1,6.2,20.1c0.8,3,3.9,15,6.9,26.5
		c3.1,11.6,7.2,28.9,9.3,38.5l3.7,17.5l0.1,28.5v28.5l-151.5,0.2C432.7,1208.9,363.9,1208.6,363.2,1208.1z"
            />
            <path
              className="st3"
              d="M60.5,1181.6c-14.7-3.4-25.5-9.5-36.5-20.5c-27-27.1-29.2-66.6-5.6-98c13.2-17.6,39.2-29.3,61.6-27.7
		c59.9,4.1,90.7,71.6,54.6,119.4c-5.2,6.7-16.2,15.9-23.7,19.7c-11.4,5.8-18.8,7.7-31.9,8.1C70.6,1182.8,64.5,1182.5,60.5,1181.6z
		 M86.2,1152.9c10.5-2.2,22.9-11.3,28.7-21.1c3.2-5.3,6.1-16.3,6.1-22.9c0-14.2-8.1-29.1-19.9-36.7c-14.7-9.5-30.2-10.2-45.9-2.3
		c-16.2,8.2-26,27.7-23.2,45.8C36.1,1141.7,60.4,1158.3,86.2,1152.9z"
            />
            <path
              className="st3"
              d="M60.7,1148.9c-14.1-5.6-24-17.9-26.9-33.6c-3.1-16.8,7.5-36.9,23.5-44.3c25-11.7,53.4,1.4,60.2,27.7
		c7.1,27.1-13.7,53.4-41.9,53.3C70.1,1151.9,66.7,1151.2,60.7,1148.9z"
            />
            <path
              className="st3"
              d="M939.5,1181.9c-24.5-6-41.9-19.5-52-40.4c-23.1-47.6,9.3-102.5,62.5-106.1c17.1-1.2,37.2,5.5,51.1,16.9
		c22.2,18.4,32.1,50.3,23.8,77.3c-3.8,12.6-9.5,22.1-18.9,31.5c-9.4,9.5-17.1,14.3-29.6,18.5c-6.5,2.1-10.2,2.7-20.4,3
		C949.1,1182.8,941.7,1182.5,939.5,1181.9z M964.6,1152.6c13.1-3.5,24.1-12.5,29.5-24.1c12.5-26.6-2.5-56.3-31.8-63.1
		c-18.3-4.2-39.4,5.9-48.1,23.1c-5.4,10.8-6.5,21.5-3.3,32.7c2.4,8.5,5.8,14.1,11.8,19.9C934.3,1152.2,950,1156.5,964.6,1152.6z"
            />
            <path
              className="st3"
              d="M941.5,1150.1c-8.5-3-13.5-6.1-18.2-10.8c-20.4-21.1-14.2-56.1,12.1-68.4c21.5-10,45.9-1.8,56.4,19.1
		c6.7,13.3,6.6,24.7-0.3,38.7C982.5,1146.9,959.8,1156.6,941.5,1150.1z"
            />
            <path
              className="st3"
              d="M815.5,1089.1c-9.3-2.8-17.3-7.3-35-19.6c-10.2-7.1-32.4-23.8-36-27.2c-1.1-1-8.1-7-15.5-13.4
		c-23.4-20.2-44.1-43-45.4-49.9c-2.3-13.1-3.9-44.7-4.3-89.6l-0.5-49.2l4.9-0.6c5.2-0.6,31.4-2.1,53.8-3.1
		c14.9-0.6,50.5-3.4,51.4-3.9c1.1-0.7,41.6-3.6,61.1-4.5c27.2-1.2,59.5,1.4,101.3,8.1l19.7,3.2v74.7v74.8l-7.2,2.2
		c-4,1.2-12,3.6-17.8,5.4c-7.6,2.4-10.7,3-11.2,2.2s-0.8-0.7-0.8,0.4c0,0.9-1.4,2.2-3.2,2.9c-16.1,6-35.6,16.4-44.6,23.9
		c-3.1,2.6-6.2,5-6.9,5.2c-0.6,0.2-4.1,4-7.8,8.4c-6.2,7.4-12.6,17.3-19.8,30.5C840.9,1089.7,832.6,1094.1,815.5,1089.1z M785,948.6
		V844.2l-3.7,0.4c-4.4,0.5-41.6,2.2-63.7,2.9c-8.3,0.3-18.3,0.8-22.3,1.1l-7.2,0.6l0.3,55.6c0.3,59.8,0.6,63.4,5.8,74
		c4.1,8.5,15,20.4,31.3,34.2c11.3,9.5,36,27,46.2,32.7c2.7,1.4,6.4,3.7,8.3,5c1.9,1.2,3.8,2.3,4.2,2.3
		C784.7,1053,785,1006,785,948.6z"
            />
            <path
              className="st3"
              d="M772,1041.8c-15.7-9.8-38.1-25.7-38.8-27.5c-0.3-1,4.9-1.3,23.7-1.3H781v17c0,9.4-0.1,17-0.3,17
		C780.6,1047,776.6,1044.6,772,1041.8z"
            />
            <path
              className="st3"
              d="M722.5,1005.9c-14.5-12.7-23.9-24.1-27.1-33.1c-2.6-7.6-3.5-26.7-3.2-73.8l0.3-46.5l5.5-0.2
		c30.4-1.3,73.6-3.4,77.8-3.8l5.2-0.5v82v82h-25.8h-25.8L722.5,1005.9z"
            />
            <path
              className="st3"
              d="M195.2,1087.9c-5.5-2.8-9.9-8.2-16.8-21c-7.1-13-12.2-20.7-19.1-28.6c-2.9-3.3-5.3-6.6-5.3-7.3
		c0-0.6-0.4-0.9-0.9-0.6c-0.4,0.3-2.6-1-4.7-2.8c-10-8.5-30.1-19.8-45.8-25.6c-3.2-1.2-5.6-2.8-5.6-3.6c0-1.6-1.7-1.9-2.2-0.4
		c-0.2,0.6-4.4-0.3-10.3-2.4c-5.5-1.9-13.1-4.3-17-5.4l-7-1.9v-73.8v-73.9l3-0.8c1.7-0.4,8-1.5,14-2.3c6.1-0.9,12.4-2.3,14.2-3.2
		c1.9-0.9,4.3-1.3,6-1c1.5,0.3,6,0.2,9.8-0.3c3.9-0.5,14.7-1.6,24-2.6c9.4-0.9,17.5-2.1,18.2-2.6c0.7-0.6,5.6-0.6,12.5,0.1
		c6.2,0.5,18.5,1.3,27.3,1.6c16,0.6,49.7,3.2,52.5,4c3,0.9,25.2,2.5,55,4c42.1,2,50.6,2.6,52.2,3.6c1.1,0.7,1.3,8.9,1.3,44.6
		c0,41.3-0.5,52.9-3.6,84.8l-1.1,11l-5.6,7c-17.4,21.9-58.7,57.8-96.2,83.7C220.9,1088.2,205.7,1093.1,195.2,1087.9z M275,1036.5
		c36-24.1,59.7-47.2,64.6-63c2.6-8.4,3.3-23.8,3.3-75.6l0.1-49.7l-14.7-0.6c-8.2-0.4-27.8-1.4-43.8-2.2c-15.9-0.7-31.4-1.4-34.2-1.4
		H245v105.5v105.4l8.8-5C258.6,1047.1,268.1,1041.1,275,1036.5z"
            />
            <path
              className="st3"
              d="M249,947.4v-99.6l9.2,0.6c5.1,0.3,20.3,1.1,33.8,1.7c13.5,0.6,29.3,1.4,35.3,1.8l10.7,0.6l0.6,44
		c0.5,44.5-0.3,65.4-2.8,75c-0.8,2.8-3.6,8.4-6.3,12.4c-5.3,7.9-22.9,25.3-28.2,27.9c-1.8,0.9-3.3,1.9-3.3,2.3
		c0,2-45.7,32.9-48.6,32.9C249.2,1047,249,1002.2,249,947.4z"
            />
            <path
              className="st3"
              d="M370.4,1024.2c1.1-15.1,2.5-53.1,3.7-100c1.9-74,0.1-158.7-4.5-215.2c-0.7-9.1-1.1-16.8-0.7-17.1
		c0.8-0.8,17.7-3.3,41.6-6.1c18.2-2.2,22.4-2.3,104.5-2.3c76.1,0,87,0.2,99.5,1.8c20.2,2.5,41.8,5.9,43,6.6
		c0.7,0.4,0.5,11.8-0.6,35.1c-3.4,69.8-4.3,120.8-3,175.1c0.6,27.7,1.8,66.2,2.6,85.4c1.9,46.1,1.9,45.4-0.2,45
		c-1-0.2-5.8-1.3-10.8-2.4c-18.9-4.3-36.5-7.1-49.5-8.1c-17.7-1.3-142.6-1.3-160,0c-13,1-33.1,4.1-51,8c-4.7,1-10,2-11.9,2.4
		l-3.3,0.6L370.4,1024.2z M585.5,838.3c6.9-3.6,12.3-8.9,15.7-15.3c2.2-4.4,2.3-5.4,2.6-32.3c0.4-34.5,0-36.1-9.1-45.2
		c-5-4.9-7.5-6.6-12.6-8.3c-6.4-2.2-7.5-2.2-68.6-2.2c-60.5,0-62.3,0.1-68.3,2.1c-7.6,2.6-15.6,9.5-19.2,16.5
		c-2.5,4.8-2.5,5.3-2.8,33.3c-0.3,25.3-0.1,29,1.5,33.4c3.2,8.9,12.9,17.5,23.3,20.8c1.4,0.4,31.5,0.7,67,0.6l64.5-0.2L585.5,838.3z
		"
            />
            <path
              className="st3"
              d="M454.5,840.3c-13.2-1.8-24.5-10-28.1-20.3c-1.7-4.9-1.9-8.5-1.9-31.5c0-30.7,0.6-33.7,8.5-41.6
		c6-6,12.4-8.9,22.2-10.1c4.3-0.5,33.1-0.8,64.5-0.6c56.3,0.3,56.9,0.4,62.4,2.6c7.6,3,13.8,8.7,17.4,15.8l3,5.9v28v28l-3,5.9
		c-3.6,7.2-10.1,12.9-18,15.8c-5.9,2.2-6.7,2.2-65,2.4C484.1,840.7,456.2,840.6,454.5,840.3z"
            />
            <path
              className="st3"
              d="M336,834.9c-5.2-0.4-20.3-1.2-33.5-1.8c-29.3-1.4-50-2.8-58-4.1c-10.6-1.7-44.4-4-67.3-4.7
		c-21.2-0.6-22.4-0.7-23.1-2.6c-0.8-2-0.8-2-1.3,0.1c-0.4,1.4-1.4,2.2-2.6,2.2c-1.2,0-13.2,1.1-26.8,2.5c-13.6,1.4-25.4,2.3-26.2,2
		c-0.9-0.3-1.8-0.1-2.2,0.5c-0.5,0.8-11.2,2.8-30.7,5.7l-4.3,0.6V698V560.7l2.8-2.4c6.2-5.5,31-14.3,32-11.4
		c0.5,1.6,2.2,1.4,2.2-0.3c0-2.8,28.6-6.4,57.6-7.3c22.5-0.7,42.1,1.1,63.4,5.8c12.9,2.8,28.6,7.6,34.1,10.5
		c1.6,0.8,5.3,5.9,9.8,13.6c4,6.8,8.6,14.6,10.3,17.3c6.9,11.1,31.3,54,54.1,94.6c12.2,21.8,15,29,18.1,46.4
		c3.2,17.6,5.6,56.2,5.6,88.3V836l-2.2-0.1C346.5,835.8,341.2,835.4,336,834.9z M344,812.3c0-18.7-1.7-53.8-3.1-66.3
		c-2.8-23.5-5.9-32.8-20.4-61.5c-21.8-42.8-54.6-94.9-70-111.3l-5.4-5.7L245,693.7v126.2l4.3,0.5c2.3,0.3,14.6,1.3,27.2,2.1
		c12.7,0.9,29.8,2.2,38,2.9c8.3,0.8,18.3,1.4,22.3,1.5l7.2,0.1V812.3z"
            />
            <path
              className="st3"
              d="M320.5,821.4c-8.2-0.7-25.1-2-37.5-2.8c-12.4-0.9-25.1-1.9-28.3-2.2l-5.7-0.6V697.9
		c0-65.1,0.4-117.9,0.9-117.9c1.9,0,17.7,22.2,29.1,40.9c2.5,4,5.4,8.7,6.5,10.5c14.2,22.2,40.1,71.4,45.3,86.1c2.5,7,4.7,19,6.1,33
		c1.3,12.6,3.4,70.2,2.6,71.5c-0.3,0.6-1.4,0.9-2.3,0.9C336.3,822.8,328.8,822.2,320.5,821.4z"
            />
            <path
              className="st3"
              d="M680.4,809.4c0.9-36,2.2-56.9,4.7-74.9c3.3-23.5,4.9-27.9,21-56.7c7.8-13.9,15.1-27.1,16.3-29.3
		c18.1-32.8,53.1-91.7,55.3-92.9c3.6-2,18.4-6.8,28.3-9.2c16.6-4,35.1-6.5,53.3-7.1c15.1-0.5,16.7-0.4,16.7,1.1c0,0.9,0.5,1.6,1,1.6
		c0.6,0,1-0.7,1-1.5c0-1.9,0.8-1.9,20.3,0c20.8,2,27.7,3,40.4,6.1c16.3,3.8,23.3,6.7,29.1,11.8l2.2,1.9v137.8v137.7l-3.8-0.9
		c-3.4-0.7-29.3-4.9-30.6-4.9c-0.3,0-0.6-0.8-0.6-1.7c0-1.5-0.2-1.5-0.9-0.4c-0.8,1.2-4.9,1-27.2-1.3c-14.5-1.4-27-2.6-27.6-2.6
		c-0.7,0-1.3-0.9-1.3-2c0-1.1-0.4-2-1-2c-0.5,0-1,0.8-1,1.8c0,1.8-1.5,1.9-22.2,2.5c-20.8,0.6-59.4,3.2-62.8,4.2
		c-3.4,1-24.2,2.6-52,4c-34.7,1.7-45.4,2.3-53.4,3.1l-5.9,0.6L680.4,809.4z M712.7,825.5c9.8-0.8,27.7-2.1,39.8-3
		c12.1-0.8,24.6-1.8,27.8-2.1l5.7-0.6V693.7V567.6l-5.1,4.9c-18.8,18.5-70.6,105.1-84.8,142c-5.4,14.2-8.1,39.4-9.6,91.8l-0.6,20.7
		h4.5C692.9,827,702.9,826.3,712.7,825.5z"
            />
            <path
              className="st3"
              d="M691.2,821.1c-1-2.5,1.7-65.9,3.3-76.6c2.4-16.9,3.5-22.4,5.6-27.8c2.1-5.6,9.6-21.6,13-28.2
		c1.2-2.2,4.1-7.8,6.5-12.5c2.4-4.7,4.9-9.2,5.4-10s5.7-9.8,11.6-20c5.9-10.1,12.8-21.6,15.3-25.5l4.7-7h11.9h12l0.3,101.1
		l0.2,101.2l-6.2,0.6c-3.5,0.3-10.1,0.8-14.8,1.1c-8.2,0.5-58.1,4.2-64.9,4.8C692.9,822.5,691.6,822.1,691.2,821.1z"
            />
            <path
              className="st3"
              d="M758,611.4c0-1.1,12.8-20,18-26.4l5-6.3v16.7V612h-11.5C763.2,612,758,611.7,758,611.4z"
            />
            <path
              className="st3"
              d="M364.3,674.3c-1.8-7-5.3-21.6-7.8-32.3c-5.9-24.9-9.2-38.8-18.4-76.9c-1.7-6.9-2.8-12.7-2.6-13
		c2.2-2.1,58-14,73.4-15.6c10.9-1.1,62.3-0.6,63.8,0.6c0.9,0.8,1.3,0.8,1.3,0.1c0-0.8,10.3-1,35.8-0.6c19.6,0.2,54.2,0.6,76.7,0.8
		c38.8,0.4,41.8,0.5,56.5,3c21.1,3.6,50.7,10.1,52.3,11.6c0.7,0.6-1.9,11-9.8,39.5c-3.9,14.3-11.4,42-14.6,54.5
		c-1.7,6.3-4,15.1-5.3,19.5c-1.3,4.4-3.1,11-4.1,14.8c-1.3,5.1-2.1,6.7-3.5,6.7c-1,0-7.1-0.9-13.6-1.9c-35.8-5.7-33-5.6-129.4-5.6
		c-99,0-90.4-0.4-144,7.2l-3.5,0.5L364.3,674.3z"
            />
            <path
              className="st3"
              d="M58.2,536.8l0.3-18.3l7-0.8c3.9-0.5,10-1.7,13.7-2.8c3.6-1,7.2-1.9,8-1.9c1.8,0,19-7.1,25-10.3
		c18.3-9.9,32.9-24.2,41-40c12.5-24.6,12.4-59.6-0.1-83.3c-4.4-8.2-7.1-11.8-14.9-19.7C122,343.1,97.4,331,69.7,325.9L58,323.8
		l0.2-32.1l0.3-32.1l2.5-1.3c1.4-0.7,9.3-4.4,17.5-8.4c8.3-3.9,15.7-7.4,16.5-7.8c1-0.5,1.8-3.1,2.2-7c0.8-7.1,3.2-11.9,7-14.1
		c2.3-1.2,3.7-1.2,9.7-0.2c3.9,0.7,10.7,1.2,15.1,1.2c10.3,0,17.3,1.6,21.1,4.8l3.1,2.5l-0.3,27.4l-0.3,27.4l12.9,4.4
		c7.2,2.4,16.8,5.8,21.5,7.5c4.7,1.6,8.8,3,9.1,3s0.9-5.3,1.3-11.7c0.4-6.5,1-13.7,1.3-16.1c0.5-3.9,0.8-4.3,3.1-4
		c2.2,0.3,3.2,1.6,6.4,9.3c11.9,27.8,19.6,62.2,23.8,106c0.5,5.5,2.1,24.2,3.5,41.5c5.3,64.4,10.1,99.5,15.9,116
		c0.9,2.5,1.6,6.2,1.6,8.3c0,4.2-1,4.5-6.2,2.3c-16.9-7.4-58.4-14.6-83.8-14.6c-9.7,0-44.3,2.7-51,3.9c-2.5,0.5-7.9,1.4-12,2.1
		c-10.1,1.6-25.7,6.5-32.2,10c-2.9,1.7-6.3,3-7.6,3H58L58.2,536.8z"
            />
            <path
              className="st3"
              d="M963.7,551.4c-7.8-5.1-33.4-11.6-53.2-13.4c-25.5-2.4-40.9-3.2-51.5-2.6c-26.2,1.4-49.8,5.5-69.4,12.1
		c-6.1,2-11.3,3.2-11.7,2.8c-0.5-0.5,0-3.5,1.2-6.8c5-14,10.6-46.9,12.9-75.7c0.6-6.8,1.7-19.4,2.5-28.1c0.8-8.7,2-22.2,2.5-30
		c1.5-21.3,5.7-56.5,8.6-71.7c6.1-32.9,18.4-69.8,23.7-70.8c1.3-0.3,1.7,0.4,1.7,2.9c0,1.8,0.5,9.4,1.1,17l1.2,13.6l9.6-3.4
		c21.1-7.5,26.8-9.5,31.1-10.7l4.5-1.2l-0.4-27.2l-0.4-27.1l3-2.9c3.4-3.5,10.2-5.2,20.1-5.2c3.7,0,10.4-0.5,14.9-1.1
		c7.1-1,8.5-1,10.6,0.4c3.3,2.1,6,8.1,6.5,14.5c0.4,5.2,0.6,5.4,4.6,7.2c2.2,1,10.7,5,18.9,8.9L971,260v31.5
		c0,17.3-0.2,31.5-0.5,31.5c-1.2,0-27.4,6.1-31.2,7.3c-2.3,0.7-4.5,1.6-4.9,2c-0.4,0.4-1.4,0.7-2.1,0.7c-0.8,0-5.8,2.2-11.1,4.8
		c-34.5,17.1-52.1,42.1-53.8,76.4c-1.6,31.3,7,53.9,27.8,73.4c16.5,15.4,41,26.5,67.6,30.5l8.2,1.3v17.3
		C971,556.2,971,556.2,963.7,551.4z"
            />
            <path
              className="st3"
              d="M336.4,544.4c1.4-3.7,1.8-6.4,0.8-6.4c-0.5,0-1.3,1.2-1.6,2.6c-0.5,1.7-1.1,2.3-1.7,1.7
		c-0.5-0.5-0.8-52.5-0.7-137.9l0.3-136.9l16-2.6c8.8-1.4,22.3-3.5,30-4.7c47.6-7.3,53.1-8.3,57.8-10.7c2.6-1.3,5.3-2.2,6.1-1.9
		c0.7,0.3,1.6-0.2,1.9-1c0.6-1.4,4.5-1.6,31.7-1.6c17,0,31,0.4,31,0.9s-0.7,2.8-1.6,5.2c-0.9,2.4-2.2,6.3-3,8.7l-1.3,4.2l8.7,6.5
		c4.7,3.6,9.2,6.5,9.9,6.5c1.9,0,18.3-12.2,18.3-13.6c0-0.6-1.1-4.6-2.5-8.8c-1.4-4.2-2.5-8.1-2.5-8.6c0-0.6,9.7-1,25.5-1h25.6
		l2.5,2.7c1.3,1.4,2.7,2.3,3.1,2c0.3-0.4,1.6,0,2.9,0.8c2.1,1.3,13.9,3.3,40.9,6.9c32.5,4.3,57.3,7.8,59.2,8.3l2.3,0.5l0.3,131.7
		c0.2,72.4,0.5,132.1,0.5,132.6c0.1,0.6-0.2,4.4-0.6,8.5l-0.8,7.5l-1.9-5.2c-1.1-2.9-2.3-5.3-2.7-5.3c-1,0-1,0.1,0.7,5
		c0.8,2.4,1.3,4.5,1.1,4.7c-0.2,0.3-2.3-0.5-4.6-1.7c-2.9-1.5-5.2-2-7.4-1.6c-1.7,0.3-6.8-0.3-11.6-1.5c-14.8-3.5-38.1-7-50.5-7.5
		c-6.6-0.2-53.5-0.9-104.2-1.4c-67.1-0.8-95.4-0.7-104,0.1c-10.4,0.9-32.6,5-52.3,9.4c-3.6,0.8-7.9,1.2-9.6,0.9
		c-2.1-0.4-4.5,0.1-7.2,1.5C336.3,546.4,335.6,546.5,336.4,544.4z"
            />
            <path
              className="st3"
              d="M62,494.9c-18.6-4.9-26.3-9.2-38-20.9c-9.3-9.3-14.1-17.3-18.7-30.7c-2.3-6.7-2.6-9.5-2.7-20.3
		c0-12.7,0.8-17,5.2-28.7c5.5-14.4,17.4-27.9,32.3-36.6c2.6-1.5,9.1-4.2,14.5-5.9c8.8-2.8,11.2-3.2,21.4-3.2
		c16.3,0,28.5,3.7,42,12.7c19.5,13,32,36.7,32,61c0,41.2-33.1,74-74.2,73.6C70.1,495.9,63.9,495.4,62,494.9z M88.1,465.4
		c8.6-2.6,14-5.8,19.9-12.1c6.5-6.8,8.6-10.3,11.1-18.7c6.2-20.3-3.3-42.2-22.4-51.6c-9.7-4.8-18-6.3-27-4.9
		c-29.6,4.7-46.5,36.3-33.8,63.4C44.9,460.8,68,471.3,88.1,465.4z"
            />
            <path
              className="st3"
              d="M65.5,463.6c-15.2-3.8-26.7-15.7-31-32.1c-2-7.8-1.9-11.6,0.5-19.8c3.5-12.5,9-19.9,18.9-25.6
		c14.5-8.4,28-8.7,43.4-0.9c15.7,7.9,25.1,29.6,20.3,47.3C111.4,455.8,88.7,469.3,65.5,463.6z"
            />
            <path
              className="st3"
              d="M934.5,493.6c-32.4-9-54.5-37.9-54.5-71.3c0-24.3,12.5-48,32-61c13.5-9,25.7-12.7,42-12.7
		c10.2,0,12.6,0.4,21.4,3.2c19.2,6.2,33,17.2,42.9,34.3c9.6,16.4,12.1,39.5,6.3,57.2c-6.4,19.5-16.7,32.6-33.7,42.9
		C975.4,495.6,952.5,498.6,934.5,493.6z M966.4,465c18-6.1,28.8-18.6,31.6-36.2c4.5-28.8-21.3-54.9-50.2-50.8
		c-9,1.3-21.5,7.7-26.8,13.8c-13,14.7-15.6,35.7-6.4,52.3c2.8,5.1,12.4,14.8,16.9,17.1C942.8,467.1,956.1,468.6,966.4,465z"
            />
            <path
              className="st3"
              d="M941.5,463.1c-15.2-5.1-25.1-15.5-29.1-30.6c-4.8-17.7,4.6-39.4,20.3-47.3c15.4-7.8,28.9-7.5,43.4,0.9
		c9.9,5.7,15.4,13.1,18.9,25.6c2.4,8.2,2.5,12,0.5,19.8c-2.2,8.3-5.2,14-10.6,19.9C974.4,463,955.9,467.9,941.5,463.1z"
            />
            <path
              className="st3"
              d="M514.5,267.3c-3.3-2.5-6.1-5-6.2-5.6c-0.2-0.7,0.8-4.1,2.1-7.7l2.4-6.5l7.7-0.3c5.6-0.2,8.1,0.1,8.7,1
		c0.8,1.4,4.9,14.1,4.5,14.3c-0.1,0.1-2.7,2-5.7,4.2c-3,2.1-5.9,4.2-6.5,4.5C521,271.5,517.8,269.7,514.5,267.3z"
            />
            {/* <path
              className="st3"
              d="M332,96.5V74h26h26v22.5V119h-26h-26V96.5z"
            />
            <path
              className="st3"
              d="M644,96.5V74h27.5H699v22.5V119h-27.5H644V96.5z"
            /> */}
          </g>
          <g id="layer105">
            <path
              className="st4"
              d="M421.5,1356.9c-15.5-1.3-41-4.8-81.7-11l-7.8-1.2v-50.8c0-28,0.3-50.9,0.8-50.9c0.4,0,2.1,0.8,3.7,1.8
		c8.2,5,34.8,14.7,52.7,19.2c25.7,6.5,24.7,6.5,127.8,6.5c100.9,0,102.4-0.1,124.4-5.6c17.3-4.3,42.2-14.1,50.8-20.1
		c1.4-1,2.9-1.8,3.2-1.8s0.6,23,0.6,51c0,28.1-0.2,51-0.6,51c-0.3,0-8.4,1.4-18,3c-22.2,3.9-49.4,7.6-64.9,8.9
		C598.5,1358.2,435.4,1358.1,421.5,1356.9z"
            />
            <path
              className="st4"
              d="M105,1349c-6.8-3.2-8-4.7-8-9.9c0-4.1-0.5-4.9-3.9-7.8c-2-1.7-5.8-3.6-8.2-4.3c-15.6-4-21-6.8-23.1-12
		c-0.7-1.6-1.1-22.1-1.2-55.2l-0.1-52.7l10-2.5c5.5-1.4,13.1-3.6,17-5c4.5-1.6,7.2-2.1,7.6-1.4c0.4,0.6,1,0.4,1.6-0.5
		c0.4-0.9,5.3-3.8,10.8-6.5c41.2-20.2,61.2-52.6,56.6-91.4c-3.9-32.2-22.5-56.4-57.1-74.1c-5.2-2.7-9.9-5.6-10.4-6.4
		c-0.5-1-1.1-1.2-1.5-0.5c-0.5,0.8-4.1,0-11.1-2.3c-5.8-1.8-13.5-3.9-17.2-4.5l-6.8-1.2v-8.4c0-6.7,0.3-8.4,1.5-8.4
		c2,0,21.4,5.6,25.9,7.5c1.9,0.8,5.3,1.5,7.4,1.5c2.5,0,4.5,0.6,5.3,1.7c0.8,0.9,6.9,4.2,13.7,7.4c32.9,15.6,52.3,35.3,61.5,62.7
		c2.6,7.6,3.7,9.7,3.7,6.9c0-2.6,1.3-2,3.5,1.4c3.2,5,10.1,9.7,16.1,11c14.1,3.2,32.3-5.4,68.4-32.4c26-19.5,55.6-45.7,69.1-61.2
		c4.2-4.8,7.5-7.9,7.7-7.1c0.9,3.9-7,50.6-11.8,70.1c-5.8,23.5-10.3,33.7-50.5,114.4c-12.8,25.7-24.6,49.8-26.3,53.6
		c-3.4,7.9-6.6,19.9-11.2,42c-4.9,23.2-10.7,43.6-15.5,54.1c-2.8,6-8.5,12.8-12.6,15c-3.6,1.8-9.8,1.8-10.5,0
		c-0.3-0.8,0.2-6.3,1-12.3c2.8-18.9,2.9-17.2-0.7-17.7c-3.7-0.6-49.8-5.6-50.9-5.6c-0.5,0-0.8-1.1-0.8-2.5s-0.4-2.5-1-2.5
		c-0.5,0-1,0.8-1,1.8c-0.1,12.5-4.3,31.6-8.4,38.6c-2.2,3.7-3.4,4.7-7.8,6.1c-3,1-9.9,1.9-15.8,2.1
		C110.9,1351,108.9,1350.8,105,1349z M258.7,1198c41.2-69.1,48.2-83,59.7-117.3c10.8-32.1,17.6-58.1,17.6-66.9v-4l-17.2,16.3
		c-9.5,9-30,29-45.6,44.4l-28.3,28l-0.9,9.5c-1.2,12.1-1.3,115.7-0.1,114.5C244.3,1221.9,251,1210.9,258.7,1198z"
            />
            <path
              className="st4"
              d="M248,1158.5c0-25.9,0.3-49.5,0.7-52.5l0.6-5.5l14.2-14c32-31.7,65.6-63.8,66.1-63.2c0.7,0.7-0.5,6.1-4.2,19.2
		c-3.4,11.6-14,45-15.8,49.5c-0.8,1.9-2.9,7.3-4.7,11.9c-3.9,10.2-10.6,23.3-22.4,44.1c-12,21.2-31.5,54.2-33.2,56
		C248.2,1205.2,248,1197.7,248,1158.5z"
            />
            <path
              className="st4"
              d="M897.3,1349.1c-3.4-1-7-2.4-7.8-3.1c-4-3.4-8.5-17.1-10-30.5c-0.9-8.8-1.5-11.5-2.6-11.5
		c-0.5,0-0.9,0.7-0.9,1.5c0,0.8-0.3,1.5-0.7,1.5c-3.9,0.1-52.6,6-53.1,6.5c-0.3,0.3,0.2,6.3,1.2,13.3c2.7,17.8,2.8,16.6-1.8,17
		c-12.2,1-20-11.2-29.4-45.8c-2-7.4-8.3-35.5-9.7-43.5c-2-11.6-8-25.2-34.8-79.1c-42.6-85.7-44.4-89.9-51.1-120.2
		c-4.1-18.7-11-61.1-10.1-62c0.3-0.3,6.6,5.9,14.2,13.8c29,30.1,78.2,68.8,104.1,81.9c12,6.1,24.7,7.4,32.6,3.4
		c5-2.5,9.6-7.4,9.6-10.2c0-3.5,1.3-5.2,5.1-7c2.3-1.1,3.8-2.8,4.8-5.6c2.1-5.7,9.6-17.9,15.4-25.2c15.8-19.8,43.9-35.3,86.5-47.7
		l11.2-3.3v8.7v8.7l-6.2,1.2c-3.5,0.7-11.2,2.8-17.1,4.7c-6,1.9-11.3,3.2-11.7,2.9c-0.5-0.3-1.2,0-1.7,0.7
		c-0.4,0.7-5.2,3.5-10.6,6.1c-16.4,8.2-28.6,17.6-38.1,29.6c-7.1,8.9-10.9,15.8-14.7,27.1c-3.2,9.3-3.3,9.9-3.4,27
		c0,17.3,0,17.6,3.2,26.4c4.7,13,10.4,21.9,20.2,31.6c17.7,17.5,40.5,29.2,73.4,37.6l6.7,1.7l-0.1,52.1c0,55.6-0.2,57.2-4.9,60.8
		c-1.4,1-7.6,3.4-13.8,5.2s-12.1,4.1-13.1,5c-2.4,2.2-3.1,2-3.1-0.6c0-1.4-0.3-1.9-1-1.2c-0.5,0.5-1,4.5-1.2,8.9l-0.3,8l-4.5,2.5
		C921.9,1351.3,906.7,1351.9,897.3,1349.1z M787,1130.4l-0.5-30.1l-4.9-5.7c-4.5-5.3-75.3-74.1-83.9-81.6l-3.8-3.3l0.6,5.4
		c1,8.5,2.5,15.7,5.2,25.4c4.3,15.6,17.3,55,21.4,65.2c7.1,17.3,20.4,41.5,49.2,89.8l16.2,27l0.5-31
		C787.3,1174.4,787.3,1147,787,1130.4z"
            />
            <path
              className="st4"
              d="M769.7,1184.8c-27.7-46.5-37.5-64.7-45-83.8c-7.7-19.3-21.2-62.8-23.3-74.5c-0.7-3.9-0.4-3.7,20.6,16.5
		c11.8,11.3,29.8,28.8,40.1,39c15.7,15.6,18.8,19.1,19.3,22.1c0.7,4.1,1,98.9,0.3,99.6C781.4,1203.9,776.1,1195.4,769.7,1184.8z"
            />
            <path
              className="st4"
              d="M417.5,1267.4c-24.2-2.9-52.9-11.3-76.8-22.6l-8.7-4.1l0.6-3.6c0.3-2,1.6-9.2,2.9-16.1c1.3-6.9,3.5-19,5-27
		s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.7-20.1,5-27c1.3-6.9,2.7-14.3,3-16.6l0.6-4l9.7-2.2
		c17.4-3.9,36.4-7.2,50.2-8.7c19.1-2.1,154.4-2.1,173.5-0.1c11.8,1.3,42.6,7,51.7,9.6c4.5,1.3,5.2,2.4,6.7,11.5
		c0.7,3.9,2.3,12.6,3.6,19.5s3.5,19,5,27s3.7,20.1,5,27s3.5,19,5,27s3.7,20.1,5,27s3.8,20.2,5.5,29.5c1.7,9.4,3.8,20.3,4.6,24.4
		c0.8,4,1.4,8.1,1.4,9.1c0,1.4-3.7,3.7-14.2,8.9c-22.8,11.2-42.7,17-66.8,19.6C596.4,1269.5,434.3,1269.5,417.5,1267.4z
		 M671.8,1182.3c-0.4-32.4-0.2-30.4-6.4-58.8c-3.2-14.6-14.7-58.7-20-76.6c-0.5-1.9-0.4-1.9-27.2-6.4l-20.3-3.5h-83.7
		c-65.3,0.1-85.9,0.4-93.7,1.4c-27.2,3.8-34.1,4.9-35.2,6c-1.5,1.4-12.6,44-19.8,75.8c-6.2,28-7.5,39.2-7.5,67v25.8h157.1h157.1
		L671.8,1182.3z"
            />
            <path
              className="st4"
              d="M363.3,1208.3c-1.6-0.6-1.8-40.4-0.2-52c1.2-9.5,5.2-30.6,8-42.8c4.2-17.8,16.5-65.5,17.1-65.9
		c0.8-0.6,16-2.9,30.8-4.7c15.5-1.9,21.1-2,100.5-1.6c90.6,0.3,86.4,0.1,113,5.8c2.8,0.5,6,1.2,7.2,1.5c2.3,0.4,2.8,1.7,7.8,20.7
		c7.7,28.8,13.7,53.1,16.6,67.2c3.3,15.8,3.3,16.3,3.4,44v28l-151.5,0.2C432.7,1208.8,363.9,1208.6,363.3,1208.3z"
            />
            <path
              className="st4"
              d="M62.9,1182c-19.4-3.1-40.7-18.1-50.5-35.5c-28.1-50.3,6.6-110.7,63.6-110.8c29.3,0,54.2,15.7,67.1,42.3
		c6.7,13.9,8.6,31.9,4.9,47.6c-3.7,16-11.6,29.1-24,39.7c-7.5,6.5-14.1,10.2-24.6,13.9c-7.2,2.5-10.6,3-19.8,3.3
		C73.5,1182.7,66,1182.5,62.9,1182z M88.1,1152.6c7.6-2.3,14.4-6.2,19.2-11.1c21.3-21.2,17-55.9-8.7-71c-22.2-13-51.7-4.1-62.4,18.9
		c-6.5,13.8-6.6,25.8-0.3,39.1c5.3,11.4,16.4,20.7,28.5,24C71.1,1154.3,82.3,1154.3,88.1,1152.6z"
            />
            <path
              className="st4"
              d="M62.9,1149.6c-15.6-5.5-25.8-17.3-28.9-33.6c-2.4-12.4,2.8-27.9,12.6-37.4c8.6-8.4,19-12.1,32.1-11.4
		c14.8,0.7,26.6,7.6,33.8,20c8,13.6,8.4,28.2,1.1,42.6c-2.8,5.4-11.5,14.1-17.2,17C85.3,1152.4,73.6,1153.4,62.9,1149.6z"
            />
            <path
              className="st4"
              d="M940.4,1182c-7.5-1.4-20.2-6.5-26.6-10.8c-16.2-10.8-26.7-25.4-31.3-43.7c-5.6-21.9-1.6-42.8,11.5-61.2
		c28.4-39.9,87.7-41,118.1-2.3c22.1,28,20.2,69.3-4.3,95.5c-9.3,10-19.9,16.4-34.8,21.1C967.4,1182.4,947.3,1183.2,940.4,1182z
		 M965.2,1152.5c21.7-5.6,36.7-28.1,33-49.6c-4.6-26.8-29.8-43.8-54.9-37.1c-20.6,5.6-34.2,22.7-34.3,43.3
		C908.9,1138.4,936.7,1159.9,965.2,1152.5z"
            />
            <path
              className="st4"
              d="M942,1150.2c-8.2-2.7-11.8-4.9-17.8-10.6c-6-5.6-9.5-11.6-11.7-20.3c-2.8-10.9-1.2-21.6,5-32.1
		c4.4-7.5,10-12.6,18.4-16.6c6.2-2.9,7.3-3.1,18.1-3.1c11.2,0,11.7,0.1,18.3,3.5c14,7.2,22.2,19.1,24.2,35.3
		c1.4,11.1-4.9,26.3-14.3,34.7C971.5,1150.6,954.6,1154.4,942,1150.2z"
            />
            <path
              className="st4"
              d="M813.5,1088.1c-12-4.2-28.3-14.5-52.5-33c-27.5-21.1-59.2-50.3-71.4-65.9l-5.7-7.3l-1.5-16.7
		c-3-35.5-3.4-45-3.4-84.3v-40.6l3.8-0.6c2-0.4,14.7-1.1,28.2-1.7c27.6-1.2,63.2-3.6,76-5.1c24.2-2.8,41.1-4,67-4.5
		c26.5-0.6,30.2-0.5,52.5,2c24.7,2.7,32.5,3.7,45.6,6.2c4.2,0.8,8.5,1.4,9.5,1.4s3.6,0.5,5.7,1.1l3.7,1v74.4v74.4l-5.7,1.7
		c-3.2,0.9-11.2,3.3-17.8,5.4c-8.6,2.7-12.2,3.5-12.7,2.7s-0.8-0.6-0.8,0.5s-1.1,2-2.7,2.4c-6.5,1.5-35.1,16.6-43.3,22.8
		c-4.7,3.6-9.1,6.6-9.7,6.6c-0.7,0-1.3,0.4-1.3,1c0,0.5-3,4.6-6.7,9c-7.2,8.7-8,9.9-17.5,26.9C840.3,1090.4,832,1094.7,813.5,1088.1
		z M785,948.5V844.1l-2.7,0.4c-2.8,0.4-36.7,1.9-69.8,3c-9.3,0.3-18.7,0.8-20.8,1.1l-3.9,0.6l0.5,55.7c0.5,69.3,0.4,68.9,14.3,86.1
		c12.3,15.3,41.3,38,71.4,56.2c5.2,3.1,9.8,5.7,10.3,5.8C784.7,1053,785,1006,785,948.5z"
            />
            <path
              className="st4"
              d="M769.8,1040.3c-13.2-8.2-36-24.5-36.6-26.1c-0.3-0.9,5.8-1.2,23.7-1.2H781v17c0,9.4-0.1,17-0.2,17
		C780.6,1047,775.7,1044,769.8,1040.3z"
            />
            <path
              className="st4"
              d="M720.9,1004.3c-11.5-10.5-20.1-20.3-23.2-26.6c-4.9-10.2-5.1-12.5-5.3-70c-0.2-48.9,0-53.8,1.5-54.6
		c0.9-0.5,10.2-1.2,20.6-1.5c10.5-0.4,29.7-1.3,42.8-1.9l23.7-1.2v81.7v81.8h-25.8h-25.7L720.9,1004.3z"
            />
            <path
              className="st4"
              d="M197,1088.7c-5.4-1.7-11-8.2-17.9-20.7c-8-14.4-13.6-22.9-20.1-30.2c-2.7-3.1-5-6.2-5-6.9s-0.3-1-0.6-0.6
		c-0.3,0.3-4.1-2-8.3-5.2c-4.2-3.1-9.8-7.1-12.6-8.9c-5.7-3.5-26.1-13.2-31.7-15.1c-2.1-0.7-3.8-1.9-3.8-2.7s-0.4-1.4-1-1.4
		c-0.5,0-1,0.4-1,0.9s-4.6-0.5-10.2-2.3c-5.7-1.8-13.6-4.3-17.5-5.5l-7.3-2.2v-73.4c0-40.4,0.3-73.6,0.7-73.8
		c0.5-0.3,6.9-1.5,14.3-2.7c7.4-1.1,15.2-2.8,17.2-3.7c2-0.9,4.7-1.3,6-1c3,0.8,48.7-4,51.1-5.4c1.3-0.7,4.8-0.7,11,0
		c5.1,0.5,17.3,1.3,27.2,1.6c17.5,0.6,50.7,3.1,53.3,4c2.2,0.8,38.3,3.4,62.2,4.5c36.1,1.6,44.8,2.2,46.2,3.1
		c1,0.7,1.3,9.3,1.3,45.1c-0.1,37.8-0.4,48-2.4,69.7l-2.3,25.4l-6,7.6c-18.1,22.5-62.7,61.1-97.1,84.1c-13.5,9-19.8,12.3-28.1,14.9
		C207.2,1090.2,202.4,1090.4,197,1088.7z M267.3,1041.6c33.7-21.4,61.8-46.2,69.7-61.5c5.2-10.3,5.3-11.5,5.7-73.7l0.5-58.2
		l-10.4-0.6c-18.5-1-77.2-3.6-82.5-3.6H245v105.6v105.6l4.8-2.8C252.4,1050.9,260.3,1046,267.3,1041.6z"
            />
            <path
              className="st4"
              d="M249,947.4v-99.7l7.7,0.6c4.3,0.3,24.3,1.4,44.4,2.3l36.6,1.8l0.5,40.5c0.6,43.7-0.2,70.6-2.4,78.6
		c-0.8,2.8-3.6,8.4-6.3,12.4c-5.5,8.1-23.2,25.5-28.2,27.7c-1.8,0.8-3.3,1.8-3.3,2.2c0,1-18.2,14.4-29,21.4
		c-10.5,6.7-18.9,11.8-19.5,11.8C249.2,1047,249,1002.2,249,947.4z"
            />
            <path
              className="st4"
              d="M370,1031.8c0-0.7,0.5-8,1-16.3c1.8-26.4,4-117.6,4-162.3c0-44.8-1.9-99-4.8-138.5
		c-1.7-22.7-1.7-22.8,0.3-23.2c6.1-1.4,16.6-2.8,35.7-5c21-2.4,22.4-2.5,108.6-2.5c87.2,0,87.2,0,107.5,2.5
		c11.1,1.4,23.6,3.1,27.7,3.8l7.5,1.3l0.3,4c0.2,2.2-0.4,18.4-1.3,36c-3.2,66.7-4,115.2-2.7,171.3c0.7,28.9,1.9,68.6,2.7,88.1
		c1.8,45.5,1.9,41.9-0.2,41.5c-1-0.2-6.7-1.5-12.8-2.9c-18.8-4.2-32.5-6.6-45-7.6c-15.3-1.2-148-1.3-164.2,0
		c-14.1,1.1-32.3,4.2-62,10.6C370.8,1032.9,370,1032.6,370,1031.8z M585.3,838.6c7.1-3.5,14.9-11.9,17.1-18.2
		c2.3-6.9,2.4-56.8,0-63.7c-1.7-5.2-8.6-13.4-13.8-16.7c-8.1-4.9-8.9-5-74.9-5c-67.5,0-67.7,0-76.3,5.8c-5,3.2-8.4,7.2-11.5,13.2
		c-2.3,4.4-2.4,5.3-2.7,32.9c-0.3,33.1,0,34.9,7.9,43.5c4.5,4.9,10.3,8.6,16.9,10.7c1.4,0.4,31.5,0.7,67,0.6l64.5-0.2L585.3,838.6z"
            />
            <path
              className="st4"
              d="M444.6,837.6c-6.7-2.5-14.2-9.2-17.2-15.2c-1.7-3.6-1.9-6.3-1.9-33.9c0-29.9,0-30,2.5-34.8
		c2.9-5.7,7.1-9.6,14.3-13.5l5.2-2.7h66h66l5.2,2.7c7.2,3.9,11.4,7.8,14.3,13.5c2.5,4.7,2.5,5.2,2.8,33.6c0.3,27,0.2,29-1.7,33.3
		c-3.4,7.6-7.6,12.1-14.9,15.6l-6.7,3.3l-64,0.2l-64,0.2L444.6,837.6z"
            />
            <path
              className="st4"
              d="M345.9,835.6c-0.2-0.2-14.6-1.1-31.9-2c-43.9-2.2-63.6-3.5-70-4.7c-11.1-1.9-53.1-4.8-75.9-5.1
		c-12.4-0.2-13.4-0.3-14.2-2.2l-0.8-2.1l-0.6,2c-0.6,1.9-2.2,2.2-18.8,3.9c-10,1-21.9,2.2-26.5,2.8c-4.5,0.5-9,0.7-9.9,0.4
		c-0.9-0.4-1.9-0.2-2.3,0.4c-0.3,0.5-5.4,1.7-11.3,2.5c-6,0.8-12.7,1.9-15,2.5c-2.3,0.5-5.2,1-6.4,1H60V697.8l0.1-137.3l4.2-3.2
		c5.4-4,11.8-6.8,22-9.4c5.4-1.4,8.3-1.7,8.5-1c0.5,1.6,2.2,1.3,2.2-0.3c0-1.5,4.8-2.5,21.5-4.6c45.5-5.6,88.9-2.3,123.2,9.5
		c11.3,3.9,13,5,15.8,10.3c1.3,2.6,4.7,8.3,7.4,12.7c16.4,26.2,71,123.2,74.3,131.9c5.7,14.9,9.6,51.2,10.5,98.9
		c0.6,30.2,0.6,30.7-1.4,30.7C347.2,836,346.1,835.8,345.9,835.6z M343.7,797.8c-1-45.3-3.7-69.1-9.6-84.4
		c-13.8-35.8-67-124.6-85-141.9l-4.1-3.9v126.1v126.1l3.8,0.6c2,0.3,10.5,1,18.7,1.6c28.2,1.9,63.3,4.7,75.4,5.9
		C344.1,828,344.2,823.5,343.7,797.8z"
            />
            <path
              className="st4"
              d="M309,820.5c-7.4-0.8-21.1-1.8-30.5-2.4c-9.3-0.7-19.8-1.4-23.3-1.7l-6.2-0.6V697.9c0-73.7,0.4-117.9,1-117.9
		c1.6,0,16.8,21.3,27.5,38.6c3.7,6,7.8,12.5,9,14.4c1.3,1.9,4.4,7.3,7.1,12c2.6,4.7,6.6,11.7,8.9,15.5c6.1,10.1,21.5,40.5,25.9,51
		c2.1,5.1,4.6,13.5,5.7,19.5c2.1,11,4.3,41.9,5.3,72.8L340,822l-8.7-0.1C326.4,821.8,316.4,821.2,309,820.5z"
            />
            <path
              className="st4"
              d="M680,826.4c0-31.3,3-79.5,6.1-97.9c3.1-19.3,4.8-23.6,20.1-50.8c7.7-13.9,15.2-27.2,16.6-29.7
		c17.6-31.4,51-88.3,53.5-91.1c1.6-1.8,18.4-7.6,31.5-10.9c13.3-3.3,34.4-6,52-6.7c14.6-0.5,16.2-0.4,16.2,1.1c0,0.9,0.5,1.6,1,1.6
		c0.6,0,1-0.7,1-1.5c0-1.8,0.1-1.8,19.3,0c21.5,2.1,28.4,3.1,41.7,6.2c13.5,3.1,20.3,5.7,26.5,10.1l4.5,3.2v137.9v137.9l-6.7-1.5
		c-5.3-1-26.2-4.3-28-4.3c-0.2,0-0.3-0.8-0.3-1.7c0-1.5-0.2-1.6-1-0.3c-0.7,1.2-2.3,1.2-10.7,0.3c-5.4-0.7-17.8-2-27.5-2.9
		c-17.6-1.8-17.8-1.8-17.8-4.1c0-1.4-0.4-2.1-1-1.8c-0.5,0.3-1,1.4-1,2.4c0,1.6-1.9,1.8-23.2,2.4c-24,0.7-56.1,2.9-65.8,4.6
		c-6.4,1.1-27.4,2.5-69,4.6c-16.2,0.9-31.4,1.8-33.7,2.1l-4.3,0.6V826.4z M720,825.1c14.6-1.1,33.5-2.5,42-3.1
		c8.5-0.6,17.4-1.3,19.8-1.7l4.2-0.5V693.7V567.6l-5.1,4.9c-18.5,18.1-69.1,102.3-84.1,140.1c-6.1,15.1-9.1,41.4-10.3,89.6
		c-0.4,13.1-0.4,24.2-0.1,24.7c0.4,0.5,2.1,0.8,3.9,0.5C692,827.2,705.4,826.1,720,825.1z"
            />
            <path
              className="st4"
              d="M691,813.8c0-16.6,2.1-57.3,3.5-68.7c2.2-16.8,3.3-22.4,5.6-28.3c6.6-16.8,30.1-61.1,47.2-88.8l8.3-13.5
		l12.7-0.3l12.7-0.3V715c0,83.8-0.2,101-1.3,101c-2.8,0-45.8,3.1-62.2,4.5c-9.3,0.8-19.1,1.5-21.7,1.5H691V813.8z"
            />
            <path
              className="st4"
              d="M758,611.4c0-1,16.2-24.3,19.6-28.1l3.3-3.8l0.1,16.3V612h-11.5C763.2,612,758,611.7,758,611.4z"
            />
            <path
              className="st4"
              d="M364.6,675.3c-9.3-38.9-12.9-53.9-15.1-62.8c-1.3-5.5-3.8-15.6-5.4-22.5c-1.7-6.9-4.4-18.1-6-25
		c-2.2-8.8-2.7-12.6-1.9-13.1c3.1-1.9,50-12.2,65.8-14.4c12.6-1.8,67-2.1,70.1-0.5c1.3,0.8,1.9,0.7,1.9,0c0-0.8,6.3-0.9,21.3-0.5
		c11.6,0.3,46,0.7,76.3,1c30.3,0.3,56.4,0.7,58,1c1.6,0.3,8.8,1.4,15.9,2.5c7.2,1.2,20,3.7,28.5,5.7c8.5,1.9,16.7,3.8,18.3,4
		c1.5,0.3,2.9,0.8,3.1,1.2c0.5,0.7-1.6,9-7.9,32.1c-2,7.4-4.5,16.7-5.5,20.5c-1,3.9-3.5,12.9-5.4,20c-1.9,7.2-4.5,16.6-5.7,21
		c-1.2,4.4-3.4,12.5-4.9,18s-3.5,13-4.5,16.8c-0.9,3.7-2.2,6.7-2.9,6.7c-1,0-25-3.5-42.1-6.1c-10.8-1.7-174-2.5-190.5-1
		c-21,2-38.4,4-47,5.6c-4.7,0.8-9.2,1.5-10,1.5C367.8,687,366.7,684,364.6,675.3z"
            />
            <path
              className="st4"
              d="M58.2,536.8l0.3-18.3l7-0.8c3.9-0.5,10-1.7,13.7-2.8c3.6-1,7.2-1.9,8-1.9c1.9,0,19.8-7.4,25.3-10.4
		c14.8-8.3,25.1-17,33.3-28.1c19.5-26.5,22.5-65.1,7.4-95.1c-13.1-25.9-44.9-46.3-83.1-53.4L58,323.7l0.2-32.1l0.3-32l2.5-1.3
		c1.4-0.7,9.3-4.4,17.5-8.3c8.3-3.9,15.7-7.5,16.5-7.9c0.9-0.5,1.8-3.1,2.2-6.9c1.2-11,5.4-15.8,13-14.9c2.4,0.4,10.6,1.1,18.3,1.7
		c16.1,1.2,19.7,2.1,22.6,5.8c2.1,2.6,2.1,3.4,1.8,29.6l-0.4,26.8l8.5,2.8c4.7,1.5,13,4.5,18.5,6.5c10.4,3.8,15.5,5.5,16.6,5.5
		c0.4,0,1-4.6,1.3-10.2c0.4-5.7,0.9-12.9,1.2-16.1c0.6-5.5,0.7-5.8,3.2-5.5c2.2,0.3,3.2,1.6,6.5,9.3c2.1,5,4.3,10.4,4.7,12
		c0.4,1.7,1.7,5.7,2.8,9c4.5,13.1,9.2,33.4,11.7,50.4c3.2,21.6,5.3,42.1,10,100.6c3.2,40.1,7.8,71,13.1,89.4
		c1.3,4.6,2.4,9.7,2.4,11.3c0,3.5-0.4,3.5-10,0c-12.6-4.6-32.3-9.1-48.6-11.1c-41.7-5.2-105,1.7-126.8,13.9
		C57.7,557.5,57.9,557.9,58.2,536.8z"
            />
            <path
              className="st4"
              d="M964.7,551.9c-5.3-4-20.8-8.7-39.2-11.9c-17.3-3-49.9-5.3-65.5-4.6c-28.6,1.2-59,6.9-76.8,14.2
		c-1.8,0.8-3.7,1.4-4.2,1.4c-1.5,0-1.2-3.9,0.6-9c4.3-12,10.9-52.1,12.9-77.5c0.3-4.4,1.4-17.7,2.5-29.5c1-11.8,2.4-28,3-36
		c0.6-8,1.3-15.6,1.5-17c0.3-1.4,1.2-8.8,2-16.5c1.9-16.5,5.6-37.3,9.1-50.5c3-11.5,8.4-29.1,9.4-30.5c0.4-0.5,1.5-3.2,2.5-6
		c2.5-6.8,5.5-11.7,6.9-11.2c0.6,0.2,1.4,4.6,1.9,10.8c0.4,5.7,1,13.1,1.3,16.5l0.5,6.1l8.2-2.8c4.5-1.6,12.7-4.5,18.2-6.4
		c5.5-2,12-4.2,14.5-4.9l4.5-1.2v-27.8v-27.8l2.7-2.3c3.3-2.8,10.6-4.5,19.8-4.5c3.8,0,10.3-0.5,14.5-1.1c9-1.4,11.6-0.6,14.2,4.3
		c0.9,1.8,2.2,6.2,2.8,9.7c0.6,3.7,1.7,6.7,2.5,7.2c0.8,0.3,9.2,4.3,18.5,8.8l17,8l0.3,31.6c0.1,17.3,0,31.5-0.3,31.5
		c-1,0-27,6-31.5,7.3c-8.2,2.3-27.3,11.6-33.3,16.1c-9.2,7-18.3,15.7-22.5,21.5c-6.4,8.8-8.8,13.7-12.5,25.1
		c-3,9.1-3.1,10.2-3.1,27.5c-0.1,17,0.1,18.5,2.8,27.3c4.8,16.1,11.3,26.7,23.3,38.3c9.3,9.1,16.7,14.2,28.8,19.8
		c5,2.3,9.8,4.6,10.7,5.2c1,0.5,2.6,0.9,3.6,0.9s4.4,0.9,7.7,2.1c3.2,1.1,10.5,2.8,16.2,3.7l10.3,1.6v17.3c0,15.8-0.1,17.3-1.7,17.3
		C968.3,554,966.3,553,964.7,551.9z"
            />
            <path
              className="st4"
              d="M336.4,544.4c1.4-3.7,1.8-6.4,0.8-6.4c-0.5,0-1.3,1.2-1.6,2.6c-0.5,1.7-1.1,2.3-1.7,1.7
		c-0.5-0.5-0.8-52.5-0.7-137.9l0.3-136.9l13-2.1c7.2-1.2,21.1-3.4,31-4.9s24.9-3.8,33.3-5.1c8.4-1.3,16.3-2.4,17.6-2.4
		c1.3,0,4.9-1.3,8-3c3.1-1.6,6.3-2.7,7-2.4c0.7,0.3,1.6-0.2,1.9-1c0.6-1.4,4.5-1.6,31.7-1.6c17,0,31,0.3,31,0.6s-1.4,4.6-3.1,9.6
		c-1.7,4.9-3,9-2.8,9.2c0.2,0.1,4.4,3.1,9.3,6.7c4.8,3.5,9.2,6.3,9.7,6.2c2.3-0.7,17.9-12.7,17.9-13.9c0-0.7-1.1-4.8-2.5-9.1
		c-1.4-4.3-2.5-8.1-2.5-8.5c0-0.5,11.5-0.8,25.5-0.8c25.1,0,25.5,0,27.8,2.2c1.2,1.3,2.7,2.3,3.3,2.3c0.6,0,2.6,0.8,4.5,1.7
		c1.9,0.9,12.2,2.7,23.9,4.2c11.3,1.5,28.4,3.8,38,5.1c9.6,1.4,22.2,3.1,27.9,3.9c5.6,0.8,10.5,1.6,10.7,1.8
		c0.5,0.6,0.6,278.9,0.1,279.5c-0.3,0.2-1.3-1.8-2.2-4.6c-0.9-2.8-2.1-5.1-2.6-5.1c-1.2,0-1.2,0,0.6,5c0.8,2.4,1.4,4.5,1.1,4.7
		c-0.2,0.2-2.7-0.8-5.5-2.3c-3.9-1.9-5.5-2.3-6.5-1.5c-1,0.9-4.3,0.5-12.7-1.3c-12.5-2.7-33-6.1-42.4-7
		c-12.9-1.3-204.9-2.7-216.1-1.6c-11,1.1-28,4.1-47.6,8.6c-6,1.3-11.9,2.1-13.6,1.8c-1.9-0.4-4.3,0.1-7,1.5
		C336.3,546.4,335.6,546.5,336.4,544.4z"
            />
            <path
              className="st4"
              d="M55.8,493.1c-46-13.2-67.2-66-43.4-108.1c5.9-10.5,18.6-22.4,29.9-28.2c11.5-5.7,20.9-8,33.7-8
		c20.9,0,37.6,6.9,52.5,21.8c6.9,6.7,8.9,9.6,13.3,18.5c6.6,13.5,8.7,23.4,7.9,37.4C146.8,474.1,101.5,506.2,55.8,493.1z
		 M89.1,465.1c8.8-3,13.8-6,19-11.1c20.4-20.4,15.7-55.9-9.2-70.3c-5.8-3.3-17-6.7-22.3-6.7c-9.3,0-21.1,4.6-30.2,11.8
		c-10.3,8.1-17.1,26.9-14.6,40.2c4.1,22.3,22,37.8,43.8,37.9C81,467,85.5,466.4,89.1,465.1z"
            />
            <path
              className="st4"
              d="M65.3,463.5c-15.6-4.2-26.6-15.9-30.9-32.7c-1.8-6.9-1.3-13.8,1.6-22.2c9.1-26.4,40.1-36.9,63.9-21.6
		c8.6,5.5,14.8,14.3,17.6,24.9C125.5,443,96.3,471.8,65.3,463.5z"
            />
            <path
              className="st4"
              d="M936,493.9c-32-8.3-53.7-34.7-55.7-67.4c-0.8-14,1.3-23.9,7.9-37.4c4.4-8.9,6.4-11.8,13.3-18.5
		c14.9-14.9,31.6-21.8,52.5-21.8c9.4,0,13,0.5,19.6,2.5c15.2,4.7,27.1,12.3,36.8,23.7c23.7,27.7,22.7,70.2-2.2,97.1
		c-10.5,11.4-20.1,17.1-35.2,21.3C961,496.7,947.3,496.9,936,493.9z M967.5,465c20.3-7,33.3-26.8,31-47.5c-1-9.9-7.9-23.2-14.8-28.6
		c-6.4-5.1-13.1-8.5-20.4-10.4c-8-2.1-13-1.9-21.8,0.9c-16.5,5.2-26,14.9-30.9,31.5c-4.3,14.4,0.4,32.2,11.3,43.1
		C933.4,465.5,952.6,470.1,967.5,465z"
            />
            <path
              className="st4"
              d="M942,463.1c-8.5-2.7-13.1-5.5-18.6-11.3c-10.7-11-14.6-25.5-10.9-39.9c2.8-10.6,9-19.4,17.6-24.9
		c23.8-15.3,54.8-4.8,63.9,21.6c4.1,11.8,3.3,21.9-2.5,33.5C982.5,459.7,960.5,469.1,942,463.1z"
            />
            <path
              className="st4"
              d="M514.5,267.3c-3.3-2.5-6.1-4.8-6.3-5.2c-0.1-0.3,0.8-3.8,2.1-7.6l2.4-7l8-0.3l8-0.3l1.5,4.3
		c3.8,10.3,3.8,10.5,1.5,12.5s-8.5,6.6-10.2,7.5C521,271.5,517.8,269.7,514.5,267.3z"
            />
            {/* <path
              className="st4"
              d="M332,96.5V74h26h26v22.5V119h-26h-26V96.5z"
            />
            <path
              className="st4"
              d="M644,96.5V74h27.5H699v22.5V119h-27.5H644V96.5z"
            /> */}
          </g>
          <g id="layer106">
            <path
              className="st5"
              d="M423,1356.9c-13.8-1.1-40.1-4.6-74.9-9.9c-7.3-1.1-14-2-14.7-2c-1.2,0-1.4-8.2-1.4-50.5
		c0-39.7,0.3-50.5,1.3-50.5c0.6,0,2.6,0.7,4.2,1.6c12.4,6.4,39.5,15.9,57.2,19.9c23.4,5.3,28.8,5.5,121.8,5.5
		c67.2,0,88.7-0.3,98.5-1.4c12.6-1.4,31.6-5.4,39.4-8.2c2.2-0.8,6.8-2.4,10.1-3.4c3.3-1.1,11.7-4.9,18.8-8.4l12.7-6.5v50.9v50.8
		l-7.2,1.2c-4,0.6-10.7,1.7-14.8,2.5c-13.9,2.6-50.4,7.4-64.5,8.5C593,1358.2,438.6,1358.1,423,1356.9z"
            />
            <path
              className="st5"
              d="M106.6,1349.5c-7-2.5-9-4.6-9.6-10.2c-0.7-6.9-5-10.6-15.6-13.3c-10.6-2.7-16.5-5.8-18.8-9.8
		c-1.8-3.2-1.9-6.2-2-56.2l-0.1-52.8l11-2.7c6.1-1.6,13-3.7,15.5-4.7c2.5-1.1,5.5-1.7,6.8-1.5c1.2,0.2,2.6-0.1,3-0.8
		c0.4-0.6,5.4-3.5,11.2-6.4c14.4-7.3,23-13.2,32-22.2c15.6-15.6,23.1-31.6,24.5-52.6c2-28.8-9-54.9-31.1-73.6
		c-7.7-6.5-19.8-14.1-29.8-18.8c-3.6-1.7-6.6-3.7-6.6-4.5c0-1.5-1.6-1.9-2.2-0.5c-0.1,0.5-4.3-0.4-9.3-2.1
		c-4.9-1.6-12.3-3.6-16.3-4.4c-4.1-0.8-7.8-1.7-8.3-2c-1.5-0.9-1.1-16.4,0.4-16.4c1.7,0,20.1,5.4,26.9,7.9c3.1,1.1,6.4,1.8,7.3,1.5
		c0.9-0.4,3.2,0.5,5.3,1.9c2,1.4,8.9,5,15.2,8.1c15.7,7.6,25.6,14.2,34.8,23.4c12.7,12.6,22.1,27.7,25.4,40.8
		c1.4,5.6,2.8,7.9,2.8,4.6c0-3.2,1.1-2.7,4.3,1.9c3.5,5.1,10.7,9.6,16.5,10.5c13.4,2,32.5-7,63.7-30.2
		c29.6-21.9,56.9-45.9,73.2-64.3l7.6-8.5l-0.6,4.5c-3.3,25.9-6.9,46.3-11.7,66.2c-3.8,16-6.4,23.9-11.5,35.3
		c-0.8,1.6-2.7,5.9-4.3,9.5c-1.6,3.5-15.3,31.4-30.5,61.9c-15.1,30.5-28.9,58.6-30.6,62.5c-3.3,7.3-6.1,17-9.1,32
		c-10.5,51.8-18.6,73-30.2,79.1c-3.1,1.6-9.4,1.9-10.3,0.4c-0.3-0.5,0.4-7.3,1.5-15.1c1.2-7.8,1.8-14.4,1.5-14.7
		c-0.3-0.3-7.8-1.3-16.8-2.3c-38.7-4.1-37.7-3.9-37.7-6.5c0-2.1-2-3.6-2-1.6c-0.2,6-2.3,22-3.6,27.1c-3.1,12.6-6.1,16.3-15.2,19.1
		C125.6,1351.4,112.5,1351.6,106.6,1349.5z M255.1,1204.4c6.1-10.3,11.9-20.1,12.9-21.8c0.9-1.7,3.5-6,5.7-9.6c2.2-3.6,5.3-9,7-12
		c1.7-3,7.2-12.9,12.2-22c11-19.8,15.2-29,21.9-47.5c6.5-18.2,10.1-29.7,15-47.5c5.4-19.4,6.4-24.7,6-29.8l-0.3-4.3l-30,28.9
		c-41.2,39.6-59.4,57.9-60.8,61c-0.8,1.9-1.2,20.2-1.5,63c-0.2,33.1-0.1,60.2,0.2,60.2C243.7,1223,248.9,1214.6,255.1,1204.4z"
            />
            <path
              className="st5"
              d="M248.2,1154.5c0.2-35.7,0.7-51.6,1.5-53c2.3-4.1,79.1-79,80-78.1c1.7,1.7-18.9,67.9-26.2,84.3
		c-1,2.1-3.4,7.2-5.5,11.3c-5.9,11.7-8,15.7-19.8,36.4c-0.9,1.7-5.7,9.8-10.6,18c-4.9,8.3-9.4,16-10,17.1s-2.4,3.9-3.9,6.2
		c-1.5,2.4-2.7,4.7-2.7,5.2s-0.7,1.5-1.6,2.2C247.9,1205.3,247.8,1201.1,248.2,1154.5z"
            />
            <path
              className="st5"
              d="M897.9,1349.1c-3.6-1-7.1-2.1-7.7-2.5c-4.2-2.6-9.3-17.8-10.7-31.6c-0.3-3.6-0.8-7.5-1.1-8.7
		c-0.5-2.5-2.4-3.2-2.4-1c0,1.3-19.7,4.1-46,6.5c-7.4,0.7-7.5,0.7-7.8,3.7c-0.2,1.7,0.6,8.4,1.6,15c1.1,6.6,1.8,12.3,1.5,12.8
		c-0.9,1.5-8.6,0.7-11.8-1.3c-9.9-6.1-18-26.8-27-68.5c-5-23.5-7.7-34.1-10.2-40c-1.4-3.3-16-33.1-32.4-66.2
		c-16.4-33.1-29.9-60.4-29.9-60.7c0-0.2-1.5-3.7-3.4-7.8c-6.9-14.6-13.4-38.4-18.6-67.5c-2.3-12.7-5.8-38.3-5.3-38.3
		c0.2,0,6.9,6.8,15,15.1c40.2,41.3,96.9,82.5,118.3,86.1c13.4,2.2,25.1-3.4,27.5-13.3c0.9-3.8,1.6-4.6,4.5-5.5c2.8-0.9,3.7-2,5-5.5
		c0.8-2.4,3.7-8.2,6.5-12.9c6.1-10.4,21.7-26.5,32.2-33.3c9.9-6.4,34.6-18.7,37.6-18.7c0.8,0,4.8-1.3,8.8-2.8
		c6.8-2.6,20.1-6.8,25.7-8c2.1-0.4,2.2-0.2,2.2,8v8.5l-6.2,1.1c-3.5,0.7-10.6,2.6-15.8,4.2c-5.2,1.7-10.4,3.1-11.5,3.2
		c-1.1,0.1-2.7,0.7-3.5,1.3c-0.8,0.7-5.6,3.3-10.6,5.7c-11.7,5.8-19.8,11.4-28.4,19.4c-11,10.4-16.6,18.5-22.1,31.8
		c-4.8,11.4-6.2,20.9-5.6,37c0.5,14.7,2.2,21.8,7.9,33c8.8,17.2,26.7,33.4,48.3,43.5c5,2.4,10.1,4.8,11.5,5.6
		c3.2,1.7,19.5,6.8,28.8,9l7.2,1.7v51.5c0,36.6-0.3,52.7-1.2,55.5c-1.5,5.1-4.6,7.2-14.9,10.2c-10.8,3.1-14,4.4-16.1,6.3
		c-1.7,1.5-1.8,1.4-1.8-0.6c0-1.4-0.5-2.1-1.2-1.9c-0.8,0.3-1.4,2.8-1.6,6.9c-0.3,9.8-0.7,10.6-6,13.1
		C920.7,1351.3,907.1,1351.7,897.9,1349.1z M787.4,1149.5c-0.2-22-0.6-42.4-1-45.4c-0.6-5.2-1-5.8-11.8-16.9
		c-6.1-6.3-21.7-21.6-34.6-34c-12.9-12.4-28.3-27.2-34.2-32.9c-5.8-5.7-10.9-10.3-11.3-10.3c-0.4,0-0.4,2.8,0,6.3
		c1.1,10.3,2.6,16.4,10.2,41.7c4.3,14.4,13.5,41.3,15.4,45.2c1.1,2.1,1.9,4.2,1.9,4.9c0,1.8,13.4,27.9,21.7,42.3
		c11,19,27.3,46.7,29.3,49.6c0.9,1.4,4.3,7,7.6,12.5l5.9,10l0.7-16.5C787.5,1196.9,787.7,1171.5,787.4,1149.5z"
            />
            <path
              className="st5"
              d="M780,1201.7c-0.8-1.2-1.7-2.6-2-3.2c-0.4-0.9-4-6.9-8.3-14c-0.7-1.1-2.4-3.9-3.9-6.3c-1.6-2.4-2.8-4.5-2.8-4.7
		c0-0.2-3.4-6.2-7.6-13.2s-8-13.7-8.5-14.8s-2.2-4.2-3.9-7c-7.3-12.5-19.7-39.5-23.4-51c-0.9-2.7-3.8-11.7-6.6-20
		c-2.7-8.2-5.4-16.8-5.9-19c-0.5-2.2-2.2-8.4-3.6-13.9c-1.4-5.4-2.4-10-2.1-10.3c0.5-0.5,44.3,41.4,64.9,62.2l14.5,14.6l0.6,5.8
		c0.7,5.8,1,96,0.4,96.7C781.6,1203.8,780.8,1202.9,780,1201.7z"
            />
            <path
              className="st5"
              d="M427.5,1268.4c-22.4-2.6-36-5.3-52.5-10.5c-12.7-4-27-9.6-35.5-13.9c-8.1-4.1-7.7-2.1-4-22
		c1.3-6.9,3.8-20.1,5.5-29.5c1.7-9.3,4-21.5,5-27s3.3-17.6,5-27c1.7-9.3,4-21.5,5-27s3.3-17.6,5-27c1.7-9.3,4.4-23.5,5.9-31.4
		l2.7-14.5l7.1-1.8c13.9-3.5,45-8.7,58.8-9.8c18.9-1.6,161.6-0.8,172.9,0.9c10.9,1.6,36.8,6.9,43.9,8.9c4,1.1,6.2,2.2,6.8,3.6
		c0.5,1.2,1.7,7.3,2.8,13.6c1.1,6.3,4.5,25.2,7.6,42c3.1,16.8,7.4,40,9.5,51.5c2.1,11.6,5.5,29.6,7.4,40c1.9,10.5,4.7,25.1,6,32.5
		c1.4,7.4,2.8,14.9,3.2,16.7c0.6,2.9,0.3,3.4-3.7,5.9c-18.9,11.9-50.5,22-78.6,24.9c-11.6,1.2-30,1.5-98.5,1.4
		C468.4,1268.8,429.2,1268.5,427.5,1268.4z M671.7,1181.8c-0.3-27.4-0.6-32.7-2.6-42.3c-2.8-13.8-10.4-45.4-13.5-56
		c-1.3-4.4-3.3-11.8-4.6-16.5c-1.2-4.7-3.1-11.5-4.1-15.1l-2-6.6l-5.2-1.1c-2.9-0.7-13.5-2.7-23.7-4.4l-18.5-3.3H514h-83.5l-22,3.3
		c-12.1,1.9-22.5,3.9-23.2,4.5c-1.4,1.4-5.9,17.7-13.6,49.7c-12.7,52-13.7,58.8-13.7,92.4v26.6h157.1h157.1L671.7,1181.8z"
            />
            <path
              className="st5"
              d="M363.1,1208.1c-1.2-0.7-1.3-5.3-0.8-26.7c0.5-22.3,0.9-27.9,3.2-39.9c4.7-24.7,14.9-66.8,22.2-91.7
		c0.3-0.9,1.1-1.9,1.8-2.1c1.3-0.6,23.5-4,35.5-5.5c4.2-0.6,43.1-1.1,88.1-1.1c68.5-0.1,82.3,0.1,91.5,1.4c12,1.8,36.6,6.4,37.2,7
		c0.2,0.2,1.7,5.2,3.2,11.2c1.6,5.9,4.5,16.9,6.5,24.3c6,21.8,10.7,42.6,13.8,60c2,11.4,2.2,14.8,1.7,38l-0.5,25.5l-151,0.2
		C429.3,1208.9,363.9,1208.6,363.1,1208.1z"
            />
            <path
              className="st5"
              d="M70,1182.5c-0.8-0.2-4.8-0.9-8.8-1.5c-3.9-0.7-9-2-11.2-3.1c-2.1-1-4.5-1.9-5.3-1.9s-2.6-0.9-4-2s-2.8-2-3.2-2
		c-0.4,0-3.7-2.5-7.3-5.5c-8.1-6.7-16.5-17.1-19.8-24.5c-1.4-3-2.9-6.2-3.4-7.1c-1.7-3.2-3.9-16.7-4.1-24.5
		c-0.1-11.9,1.6-21.5,5.2-28.6c0.5-1,0.9-2.3,0.9-3c0-2.2,10.9-17.3,16.2-22.4c5.8-5.6,16.7-13.4,18.6-13.4c0.7,0,2.6-0.7,4.1-1.4
		c5.9-3.1,18.5-5.7,27.7-5.7c34.3-0.2,63,21.9,72,55.6c2.8,10.5,2.5,27.3-0.9,38.8c-2.4,8.4-9.4,21.2-15,27.7
		c-2.4,2.7-11.3,10.2-16.4,13.7C105.4,1178.7,80.6,1184.5,70,1182.5z M88.5,1152.6c13.5-4.8,19.9-9.7,26.1-20.2
		c8.6-14.4,8.9-29.1,1.1-44.9c-2.8-5.6-10.2-13.5-15-16.1c-1.8-0.9-4.8-2.5-6.7-3.5c-6.1-3.2-16.9-4.5-25.2-3.1
		c-3.9,0.7-8.2,1.8-9.4,2.5c-1.3,0.6-4.2,2.2-6.6,3.4c-6.6,3.4-12.3,9.9-16.9,19.3c-3.7,7.5-4.3,9.5-4.7,17.1
		c-0.5,10.4,1.7,18.3,7.8,27.7c5,7.8,12.2,13.1,24,17.7C67.7,1154.3,83.4,1154.4,88.5,1152.6z"
            />
            <path
              className="st5"
              d="M66,1150.4c-19.6-5.3-32.1-21.4-32.1-41.4c0-23.4,18.7-41.9,42.1-42c21.4,0,38.2,14.4,42.1,36
		c3.1,17.5-6.7,36.2-23.2,44.3C84.9,1152.1,76,1153.1,66,1150.4z"
            />
            <path
              className="st5"
              d="M941,1181.5c-8.2-1.4-21.3-6.2-26.3-9.8c-5.1-3.5-14-11-16.4-13.7c-5.6-6.5-12.6-19.3-15-27.7
		c-3.4-11.5-3.7-28.3-0.9-38.8c3.3-12.3,10.2-24.8,18.3-33.1c14.6-14.9,33-22.6,53.7-22.5c9.2,0,21.8,2.6,27.7,5.7
		c1.5,0.7,3.4,1.4,4.1,1.4c1.9,0,12.8,7.8,18.6,13.4c5.3,5.1,16.2,20.2,16.2,22.4c0,0.7,0.9,3.1,2,5.5c4.1,8.9,5.3,27.9,2.5,41.1
		c-0.9,4.3-2,8.6-2.5,9.5s-2,4.1-3.4,7.2c-5.3,11.8-20.3,27.1-32.1,32.8c-6.2,3-17,6.2-23.8,7.1
		C954.1,1183.2,950.6,1183.2,941,1181.5z M972.5,1150c9.8-4.9,14.2-8.5,18.6-15.3c6-9.2,8.2-17.2,7.7-27.6
		c-0.4-7.6-0.9-9.6-4.6-17.1c-2.5-5.1-5.9-10.2-8.4-12.7c-10.5-10.3-24.8-14.9-39-12.5c-4,0.7-8.9,2.1-10.8,3.1
		c-1.9,1-4.9,2.6-6.7,3.5c-1.8,0.9-5.3,3.8-7.9,6.4c-10.7,10.8-15.2,28.3-11.1,43.2c3.1,11.3,13,24,21.7,27.8
		c11.2,4.8,12.4,5.1,23,4.9C964.8,1153.5,966,1153.3,972.5,1150z"
            />
            <path
              className="st5"
              d="M944.5,1150.9c-21.4-5.1-36.3-26.9-32.6-47.9c2.5-13.6,9.8-24.3,21.1-30.6c7.7-4.3,14.6-5.8,24.6-5.1
		c6.8,0.4,9.5,1.1,14.6,3.7c23.5,12,31,39.9,16.7,62.2C980,1147,960.8,1154.7,944.5,1150.9z"
            />
            <path
              className="st5"
              d="M821,1090.3c-8.5-1.5-24.9-10-39-20.2c-4.7-3.4-9.6-6.9-11-7.9c-7.9-5.2-32.9-25.3-44.6-35.8
		c-12.7-11.5-32.2-31.3-37.4-38.1l-4.7-6.2l-1.2-12.3c-3.2-32.3-3.9-46.8-4-87l-0.2-42.6l5.3-0.6c2.9-0.3,11.8-0.8,19.8-1.1
		c31.5-1.3,87.4-5,89-6c0.3-0.2,8.6-1.1,18.5-2c22.4-2.1,76.8-2.6,89.5-0.8c4.7,0.7,16.2,2.2,25.5,3.4c15.1,1.8,36,5,42.3,6.4
		l2.2,0.5v74.5v74.4l-4.2,1.2c-2.4,0.6-10.3,3-17.6,5.2c-11.2,3.4-13.5,3.9-14.3,2.6c-0.7-1.1-0.9-0.9-0.9,0.8
		c0,1.6-0.9,2.5-3.2,3.1c-11,3.2-34.8,15.9-45.5,24.3c-3.4,2.7-6.7,4.9-7.2,4.9s-1.2,0.8-1.5,1.8c-0.4,0.9-2.6,3.8-5,6.4
		c-4.1,4.4-10.6,13-10.6,14.2c0,0.3-1.3,2.4-2.9,4.8c-1.5,2.4-4.8,7.9-7.1,12.4C842.5,1086.8,833.8,1092.5,821,1090.3z M784.7,844.4
		c-0.2-0.2-6.8,0.1-14.8,0.6c-7.9,0.5-28.6,1.4-45.9,2c-17.3,0.6-32.5,1.4-33.8,1.7l-2.4,0.6l0.4,55.6c0.5,65.6,0.6,66.2,9.4,79.7
		c11,16.7,44.7,44.2,79.4,64.6l7.5,4.5l0.3-104.5C784.9,891.7,784.9,844.5,784.7,844.4z"
            />
            <path
              className="st5"
              d="M775,1043.4c-8.8-5.2-37.8-25.1-41.4-28.5c-0.6-0.5,9-0.9,23.2-0.9H781v16c0,8.8-0.3,16-0.7,16
		C779.8,1046,777.5,1044.8,775,1043.4z"
            />
            <path
              className="st5"
              d="M723.3,1006.1c-15.1-13.1-24.7-24.8-27.7-33.6c-2.6-7.9-3.7-31.5-3.3-76.9c0.3-38,0.5-41.9,2-42.8
		c1-0.5,2-0.7,2.5-0.5c0.4,0.2,19.5-0.5,42.5-1.7l41.7-2.1l-0.2,81.5l-0.3,81.5l-25.2,0.3l-25.2,0.2L723.3,1006.1z"
            />
            <path
              className="st5"
              d="M196.2,1088c-6.1-2.8-10.3-7.9-18.3-22.2c-6.8-12.5-16.4-26.4-20.7-30.2c-1.2-1.1-2.2-2.5-2.2-3.3
		c0-0.7-0.8-1.7-1.7-2c-1-0.4-5.2-3.2-9.3-6.2c-4.1-3.1-8.8-6.4-10.5-7.4c-4.8-3-28.7-14.3-32.7-15.6c-2.1-0.7-3.8-1.9-3.8-2.7
		s-0.4-1.4-1-1.4c-0.5,0-1,0.4-1,0.9s-4.6-0.5-10.2-2.4c-5.7-1.8-13.6-4.2-17.6-5.4l-7.2-2.2l0.2-73.7l0.3-73.7l15.7-2.6
		c8.7-1.4,16.4-3.2,17.2-3.8c0.9-0.8,2.7-1,4.4-0.6c3.5,0.7,48.4-4.1,52.9-5.7c2.3-0.9,3.8-0.9,5.6-0.1c1.3,0.6,7.3,1.2,13.3,1.2
		c18.4,0.2,64.4,3.2,69.4,4.6c3.2,0.9,40.9,3.5,72,5c17.9,0.8,33.9,1.8,35.6,2.1c3.1,0.6,3.2,0.7,3.6,7.2c0.3,3.7,0.4,23.6,0.3,44.2
		c-0.1,29.6-0.6,42.9-2.4,63l-2.3,25.5l-4,5.4c-15.8,21.1-50.7,52.3-89.3,80c-20.7,14.9-29.5,19.8-40,22.6
		C204.8,1090.5,201.4,1090.4,196.2,1088z M261.7,1045.4c1.7-1.3,3.4-2.4,3.7-2.4c0.9,0,19.5-12.8,29.2-20.1
		c10.3-7.7,26.3-21.7,31-27.1c7.3-8.3,12.3-16.6,14.5-23.8c2.2-7.3,2.3-8.8,2.7-65.7l0.3-58.1l-6.3-0.6c-3.5-0.3-13.5-0.8-22.3-1.1
		c-23.4-0.8-59.3-2.4-64.7-3l-4.8-0.4v106v106.1l6.8-3.7C255.5,1049.4,259.9,1046.7,261.7,1045.4z"
            />
            <path
              className="st5"
              d="M249.3,947.3l0.2-98.8l6,0.2c21.8,0.8,78.4,3.5,80.1,3.8c2.1,0.5,2.1,0.8,2.6,40.2c0.6,43.7-0.3,70.8-2.8,79.3
		c-0.9,3-3.4,8-5.6,11.2c-5.9,8.4-27,28.8-29.8,28.8c-0.7,0-2,1-3,2.3c-2.1,2.6-23.3,18.1-33.2,24.2c-6.7,4.1-12.9,7.5-13.8,7.5
		C249.4,1046,249.1,1012.4,249.3,947.3z"
            />
            <path
              className="st5"
              d="M370.4,1026.3c2.7-31.2,4.1-92.9,4-176.3c0-67.2-0.6-85.4-4-133.8c-0.9-12.8-1.4-23.5-1.1-23.8
		c1-1,7.8-2.2,29.2-5.1l21-2.8H514c93,0,94.8,0,111,2.3c17.1,2.4,26.8,3.9,30.9,4.8l2.4,0.5l-0.7,13.2c-3.7,75.3-4,86.1-4,148.7
		c0,58.9,1.8,132.4,4,168.6l0.7,10.1l-14.9-3.2c-39.3-8.6-30.4-8-119.9-8.3c-79.8-0.3-93.4,0.1-110,3.2c-4.4,0.8-11.8,2.2-16.5,3
		c-9.2,1.6-22.4,4.3-25.3,5.2C370,1033.1,369.9,1032.6,370.4,1026.3z M582.2,840.2c7.9-3.2,13.7-8,17.8-14.8l3.5-5.8v-31.1v-31.1
		l-3.5-5.8c-4.2-6.9-11.7-12.7-19.9-15.3c-5.1-1.6-10.8-1.8-66.6-1.8s-61.5,0.2-66.6,1.8c-10.7,3.4-16.9,8.8-22,19.2
		c-2.4,4.9-2.4,5.4-2.4,33v28l2.6,5.5c5,10.6,15.4,18.2,27.3,20c2.8,0.5,31.9,0.7,64.6,0.6C576.4,842.5,576.5,842.5,582.2,840.2z"
            />
            <path
              className="st5"
              d="M445.5,837.9c-3.2-1.1-7.3-3.2-8.9-4.6c-4.2-3.5-9-10.1-10.4-14.4c-1.7-4.9-1.7-55.9,0-60.8
		c2.3-7,8.5-13.8,15.6-17.3l6.7-3.3h65h65l5.5,2.6c6.1,2.8,13,9.4,15.7,14.9c1.6,3,1.8,7.2,2.1,31.2c0.2,17.2-0.1,29.1-0.7,31.6
		c-0.6,2.1-2.9,6.4-5.1,9.5c-3.2,4.4-5.4,6.3-10.7,8.9l-6.8,3.3l-63.5,0.2C453.2,840,451.3,839.9,445.5,837.9z"
            />
            <path
              className="st5"
              d="M346.9,835.6c-0.4-0.3-26.1-1.9-49.9-3.1c-29.9-1.5-47.5-2.7-55.5-4c-14.1-2.2-81.7-6.1-84.8-4.9
		c-0.9,0.3-1.7-0.3-2-1.6c-0.6-2.2-2.7-1.9-2.7,0.4c0,0.9-6.6,1.9-23.7,3.6c-13.1,1.3-25.9,2.4-28.5,2.4c-2.7,0.1-4.8,0.4-4.8,0.7
		c0,0.4-2.4,1-5.2,1.4c-2.9,0.3-10.3,1.5-16.5,2.6c-6.2,1-11.7,1.9-12.3,1.9c-0.7,0-1-42.2-1-136.9V561.2l3.6-3.2
		c4.5-3.9,9.8-6.2,21.7-9.6c7.2-2,9.2-2.3,9.8-1.2c0.7,1,1.1,0.9,2.1-0.4c2.8-3.6,35.1-7.2,64.8-7.2c30.3,0,53.7,3.5,78.5,11.6
		c13.2,4.4,13.8,4.8,18.5,13.5c2.4,4.3,6,10.4,8.1,13.6c2.2,3.2,3.9,6.1,3.9,6.3c0,0.3,1.6,3,3.5,6s3.5,5.7,3.5,5.9
		c0,0.3,1.2,2.4,2.7,4.8c3.1,4.9,12.3,20.8,12.3,21.3c0,0.2,3.1,5.6,6.8,12.1c14.7,25.3,38.3,68.2,39.7,72.4c1.5,4,4.5,18.5,6,28.4
		c1.7,11.9,3.6,43.6,4.2,70.3c0.5,26.4,0.4,30.2-0.9,30.2C348,836,347.1,835.8,346.9,835.6z M344,807.3c0-39.8-3.6-77.8-8.7-91.2
		c-7.6-20.3-39-78.3-57.3-105.6c-2.6-3.8-5.5-8.3-6.5-10c-3.7-6.1-18.4-25.1-22.4-29l-4.1-3.9v126.1v126.2l4.3,0.5
		c5.2,0.7,23,2.2,44.7,3.7c9.1,0.6,23,1.6,31,2.4c8,0.7,15.5,1.3,16.8,1.4l2.2,0.1V807.3z"
            />
            <path
              className="st5"
              d="M324,821.4c-1.4-0.2-15.1-1.2-30.5-2.4s-31.6-2.4-36-2.8l-8-0.7l-0.2-117.7c-0.2-71.7,0.1-117.8,0.7-117.8
		c0.9,0,16,20.7,22.5,30.8c5.3,8.4,15,24,18.6,30.2c11.9,20.6,14.8,25.7,19.2,34c16.7,31.8,20.5,40.8,23.5,55.7
		c2.1,10.2,4.5,42,5.6,75.1L340,822l-6.7-0.1C329.5,821.8,325.4,821.6,324,821.4z"
            />
            <path
              className="st5"
              d="M680,829.3c0-15.5,2.1-62.9,3.5-78.3c2-22.4,7-47.3,10.4-51.4c0.5-0.6,2.1-3.2,3.5-5.9
		c3.2-5.9,6.5-11.8,9.9-17.8c1.4-2.5,3.7-6.6,5-9c1.3-2.4,3.3-6,4.4-7.9c1.1-1.9,3.4-6,5-9c3.7-6.5,8.1-14.2,15.2-26.3
		c2.8-4.9,5.1-9,5.1-9.2c0-0.3,2.6-4.8,5.8-10.2c15-25.3,18.8-31.6,20.4-34.1c1-1.5,3.1-5.2,4.7-8.3c2-3.8,3.9-6,5.8-6.7
		c24.4-9.3,52.2-14.7,81.6-15.9c14.2-0.5,15.7-0.4,15.7,1c0,1,0.5,1.7,1,1.7c0.6,0,1-0.7,1-1.5s0.3-1.5,0.8-1.5
		c3.1,0,26.1,2.3,36.7,3.6c13.5,1.6,32.5,5.9,40.7,9.1c2.6,1.1,6.8,3.3,9.3,5.1l4.5,3.2v137.5c0,95.1-0.3,137.5-1,137.5
		c-0.6,0-6.1-0.9-12.3-1.9c-6.2-1.1-13.3-2.2-15.8-2.6c-3.7-0.5-4.8-1.1-5.3-2.8c-0.6-2.1-0.7-2.1-2.1-0.3c-1.3,1.7-2,1.8-9.2,0.8
		c-4.3-0.6-16.5-1.9-27-2.8c-19-1.7-19.3-1.8-19.3-4.1c0-1.3-0.4-2.3-1-2.3c-0.5,0-1,1-1,2.3c0,2.2-0.2,2.2-13.8,2.5
		c-20.6,0.4-62.5,3.1-72.7,4.7c-9,1.4-21.6,2.2-74,5c-15.4,0.8-29.7,1.8-31.7,2.1l-3.8,0.6V829.3z M708.5,826c6.6-0.5,25.1-1.9,41-3
		c16-1.1,30.7-2.3,32.8-2.6l3.7-0.6V693.9c0-77.5-0.4-125.9-0.9-125.9c-1.1,0-10.6,10.6-14.3,15.8c-29.1,41.3-60.5,95.7-73.3,127
		c-7.1,17.5-9.9,39.7-11.1,89.5l-0.6,27.9l5.3-0.6C694.1,827.3,701.9,826.6,708.5,826z"
            />
            <path
              className="st5"
              d="M691.5,799.8c0.3-12.3,0.8-24.8,1-27.8s0.6-10,1-15.5c1.1-16.5,4.5-34.8,8.2-43.5c5.7-13.4,29.7-59,37.3-71
		c0.5-0.8,2.4-4,4.2-7c1.7-3,5.4-9,8.1-13.2l5-7.8h12.3H781v100.9v100.8l-10.7,0.7c-6,0.4-13.3,0.9-16.3,1.2
		c-20.2,1.6-57.8,4.4-60.3,4.4h-2.9L691.5,799.8z"
            />
            <path
              className="st5"
              d="M758,611.6c0-1.3,21.6-31.6,22.5-31.6c0.3,0,0.5,7.2,0.5,16v16h-11.5C763.2,612,758,611.8,758,611.6z"
            />
            <path
              className="st5"
              d="M367.8,686.3c-0.5-0.8-3-10.7-7.3-28.8c-1.4-6-3.7-15.3-5-20.5c-2.6-10.1-14.2-58.9-17.9-75.3l-2.3-9.7
		l4.1-1.1c16.2-4.4,54.1-12.2,67.2-13.8c13.1-1.6,62.8-1.5,65.5,0.2c1.5,0.8,2.3,0.9,2.6,0.1c0.2-0.7,4-1,10.6-0.8
		c5.6,0.2,39,0.5,74.2,0.8c71.9,0.6,75.1,0.9,109,8.2c20.3,4.5,27.7,6.6,27.2,7.8c-0.3,0.7-1.2,4.1-2.1,7.7c-1,3.5-2.1,7.8-2.6,9.4
		c-0.5,1.7-2,7.3-3.4,12.5c-3.6,13.8-5.4,20.4-8.1,30c-1.3,4.7-3.6,13-5,18.5c-1.5,5.5-3.7,13.8-5,18.5c-2.3,8.3-6.1,22.6-8.6,32.3
		c-0.6,2.6-1.7,4.7-2.3,4.7c-0.6,0-6.3-0.9-12.6-2c-6.3-1.1-20.3-2.9-31-4c-18.5-2-24-2.1-106.5-1.7c-73,0.3-89.3,0.6-101,2
		c-12.6,1.5-29.5,4-36.7,5.3C369.4,686.9,368,686.8,367.8,686.3z"
            />
            <path
              className="st5"
              d="M59,537v-17.9l3.8-1c2-0.6,5.1-1.1,6.7-1.1c4.1,0,20.2-4.4,28.4-7.6c42.4-16.8,64.9-47.6,64.9-89.1
		c0-15.6-3-27.9-10.1-41.8c-8.6-16.6-24.9-31.1-45.3-40.6c-12.2-5.6-23.8-9.4-37.1-12L59,323.7v-32.2v-32.2l2.3-1.1
		c1.2-0.6,9-4.3,17.2-8.1c8.3-3.9,15.7-7.5,16.5-8c0.9-0.5,1.8-3.1,2.2-7c0.8-7.3,3.3-12.1,7.3-14c2.4-1.2,4.2-1.2,10.2-0.2
		c3.9,0.7,11.4,1.4,16.6,1.6c11.2,0.4,16.7,1.7,19.3,4.6c1.8,2,1.9,4,1.9,29.6v27.5l9.5,3.3c5.2,1.8,15,5.3,21.7,7.6
		c6.7,2.4,12.5,4.1,12.8,3.7c0.3-0.3,0.8-3.4,1-6.9c1.3-21.7,1.7-24.9,3.4-24.9c0.9,0,2.2,0.4,2.8,0.8c2.2,1.4,12.6,28.6,14.8,38.7
		c0.7,3.3,2,7.9,2.8,10.2c0.9,2.2,1.4,4.3,1.2,4.5c-0.3,0.2,0.2,2.8,1,5.8c1.8,6.6,6,33.6,7.4,47.5c1,10.3,1.3,13.3,3.1,34
		c0.6,6.6,1.5,17,2,23c0.5,6.1,1.2,14.4,1.5,18.5c0.8,12.3,5.5,53,7,60.5c0.7,3.9,1.7,9,2,11.5c0.4,2.5,2,9.1,3.6,14.6
		c4.3,15.1,3.8,17.5-2.9,14c-8.2-4.2-46.7-12.8-61.7-13.7c-10.1-0.7-40.4-0.4-51.5,0.3c-25.6,1.8-54.9,8.3-66.5,14.8
		C58.6,556.9,59,557.6,59,537z"
            />
            <path
              className="st5"
              d="M963.4,550.9c-4.9-2.7-23.5-8.9-26.9-8.9c-0.8,0-1.5-0.8-1.5-1.7c0-1.5-0.2-1.5-0.9-0.4c-0.7,1-2,1.2-4.7,0.7
		c-15.5-2.7-17.8-3-39.9-4.7c-36.3-2.7-76.3,2.3-105,13.2c-2.8,1-5.4,1.9-5.8,1.9c-1.2,0-0.8-3.3,1.2-9.6c3.2-10,6.9-28.2,9.1-44.4
		c2.1-15.9,7.2-70.9,9.5-103c0.4-4.7,1.3-13.7,2.1-20c0.7-6.3,1.6-13.5,1.9-16c2.1-17.3,8.8-48.4,13-60c1.3-3.6,2.6-7.6,3-9
		c0.6-2.5,1-3.5,6.1-14.7c2.5-5.7,4.7-8.2,5.8-6.5c0.5,1,2.1,27.1,1.8,30.6c-0.3,3.3-1,3.4,11.8-1.4c4.7-1.7,9.9-3.5,11.5-4
		c1.7-0.5,7.5-2.4,13-4.3l10-3.4v-27.8v-27.7l2.9-2.3c3.5-2.8,5.6-3.2,21.8-4.5c6.9-0.5,14.3-1.2,16.5-1.6
		c7.3-1.1,10.4,2.5,12.6,14.3c0.7,3.8,1.8,6.9,2.7,7.4c0.8,0.5,7.4,3.6,14.5,6.9c7.2,3.4,14.9,7.1,17.3,8.3l4.2,2.1v31.3
		c0,17.2-0.2,31.3-0.4,31.3c-1.9,0-22.5,4.5-27.5,6.1c-8,2.4-7.9,2.4-8.4-0.8c-0.4-2.8-0.4-2.8-0.6,0.3c-0.1,2.8-0.8,3.3-9.8,7.7
		c-12.9,6.1-20.2,10.6-27.6,16.9c-12.7,11.1-20.4,22.6-26,39.3c-2.8,8.3-3,10.2-3.3,25.5c-0.2,11.5,0.1,18.3,1,22.5
		c7.2,30.9,24.8,52.1,54.5,65.7c4.7,2.2,9.5,4.3,10.6,4.8c1.1,0.6,3.8,1.4,6,1.9s7.1,1.8,10.8,3c3.7,1.1,9.9,2.3,13.8,2.7l6.9,0.7
		v17.3c0,13.3-0.3,17.4-1.2,17.3C969.1,553.8,966.2,552.5,963.4,550.9z"
            />
            <path
              className="st5"
              d="M336.5,544.3c1.1-2.6,1.8-7.3,1.1-7.3c-0.3,0-1.2,1.2-2,2.8c-1.4,2.4-1.5-12.3-1.6-134.9V267.3l4.3-0.6
		c11.8-1.7,39.4-5.9,56.7-8.7c10.7-1.7,23.3-3.6,28-4.2c5.8-0.7,10.2-1.9,13.8-3.9c2.9-1.5,5.9-2.6,6.6-2.3c0.8,0.3,1.6-0.2,1.9-1
		c0.6-1.4,4.5-1.6,31.2-1.6H507v2.3c0,1.2-1.2,5.5-2.6,9.5c-1.5,4-2.5,7.4-2.3,7.5c0.2,0.2,4.5,3.3,9.6,7.1l9.2,6.7l7.3-5.2
		c4-2.9,8.3-6.1,9.5-7.2l2.1-1.9l-2.9-8.6c-1.6-4.7-2.9-8.9-2.9-9.4c0-0.4,11.5-0.8,25.5-0.8H585l2.2,2.5c1.2,1.4,2.8,2.3,3.4,2.1
		c0.7-0.3,2.3,0.3,3.6,1.3c1.3,1.1,5,2.1,8.8,2.5c3.6,0.4,11.2,1.4,17,2.2c10.6,1.5,27,3.8,54.5,7.4c8.2,1.1,16.4,2.3,18.2,2.6
		l3.3,0.6l0.2,132.7c0.2,72.9,0.1,136-0.2,140.1l-0.6,7.5L694,542c-1.4-4.8-2.7-7-4.1-7c-0.4,0,0.1,2.5,1.1,5.5
		c1.7,5,1.8,5.4,0.2,4.6c-6.8-3.5-9.3-4.3-10.5-3.3s-3.6,0.7-21.7-3.1c-23.1-4.9-31.7-5.6-75-6.2c-114.4-1.5-168.8-1.7-177-0.5
		c-11.3,1.5-31.9,5.4-45.5,8.5c-8.5,2-11.5,2.3-13,1.5c-1.7-0.9-3-0.6-6.5,1.4C336.7,546.4,335.5,546.6,336.5,544.3z"
            />
            <path
              className="st5"
              d="M65,495.3c-3.9-0.7-16.1-4.3-20-6c-4.3-1.8-13.8-8.5-20.3-14.4c-7.1-6.2-12.8-15.2-17.8-28
		c-6.5-16.7-4.8-43,3.6-57.9c0.8-1.4,2.1-3.8,2.9-5.5c0.8-1.6,4.8-6.6,8.9-11c14.3-15.4,33.3-23.7,54.2-23.6
		c29,0,54.9,16.9,66.7,43.6c5.1,11.6,6.3,17.1,6.2,30c0,10-0.5,13.4-2.7,20.7c-7.8,25.6-27.4,43.9-54.2,50.8
		C85.2,495.9,72.1,496.5,65,495.3z M85.5,466.5c13.7-3.5,22.9-10.2,29.5-21.4c10.4-17.7,7.5-40.4-7.1-54.8c-2.9-2.9-5.8-5.3-6.5-5.3
		c-0.6,0-1.7-0.6-2.3-1.4c-1.9-2.3-17.1-6.6-23.2-6.6c-15.4,0-33.1,10.7-38.9,23.6c-8.1,17.8-8.1,28.5,0,44.3
		c2.3,4.5,12.2,15.1,14.1,15.1c0.6,0,2.3,0.8,3.7,1.9c1.5,1,5.4,2.6,8.7,3.6c3.3,0.9,6.5,1.9,7,2C73.1,468.3,80.2,467.9,85.5,466.5z
		"
            />
            <path
              className="st5"
              d="M69.5,464.5c-0.5-0.1-3-0.9-5.5-1.6c-18.2-5.4-30.1-21.6-30.1-40.9c0.1-33.9,37.8-53.6,66.3-34.7
		c13.4,8.9,20.7,26.1,17.8,42c-3,17.1-14.8,29.7-31.8,34.1C80.9,464.8,72.3,465.4,69.5,464.5z"
            />
            <path
              className="st5"
              d="M937.1,494c-26.8-7.2-46-25.4-53.8-50.8c-3.4-11.2-3.9-29.1-1-38.7c8.8-29.2,28.8-48.1,57.5-54.6
		c6.2-1.4,21.4-1.3,27.7,0.1c16.3,3.6,29.5,10.9,40.2,22.5c4.1,4.4,8.1,9.4,8.9,11c0.8,1.7,2.1,4.1,2.8,5.5c8.9,16,10.4,40.2,3.6,58
		c-4.5,11.7-6.7,15.7-13.4,23.7c-4.1,4.8-18.2,15.7-23.6,18.1C970.8,495.7,951.1,497.8,937.1,494z M967,465.5c3-1,6.7-2.6,8.2-3.7
		c1.4-1,3.1-1.8,3.7-1.8c2.1,0,11.9-10.7,14.4-15.6c4.6-9.2,5.9-14.9,5.5-23.7c-0.7-16.1-10.5-31.5-24.2-38.1
		c-8.9-4.3-13.7-5.6-20.5-5.6c-6.1,0-21.3,4.3-23.2,6.6c-0.6,0.8-1.7,1.4-2.3,1.4c-2.4,0-11.6,10.4-14.4,16.4
		c-5.7,11.7-6.6,17.8-4.5,29.1C914.5,457.1,941.6,473.7,967,465.5z"
            />
            <path
              className="st5"
              d="M942.5,463.2c-8-2.4-12-4.7-18.3-10.7c-9.7-9.2-14.6-23.6-12.3-36.4c2.3-12.7,8.3-22.4,17.9-28.8
		c19.9-13.1,45.9-8.2,59.3,11.4c13.3,19.3,7,48.3-13,59.6c-8.1,4.6-11.7,5.7-20.1,6.2C950.6,464.9,946.8,464.5,942.5,463.2z"
            />
            <path
              className="st5"
              d="M514,266.8c-6.2-4.5-6.4-5.1-3-14l2.1-5.8h7.8h7.8l1.6,4.3c0.9,2.3,1.9,5.8,2.2,7.8c0.7,3.5,0.5,3.7-5.2,7.8
		c-3.2,2.2-6.2,4.1-6.8,4C520,270.9,517,269,514,266.8z"
            />
            {/* <path
              className="st5"
              d="M332.2,96.8l0.3-22.3l25.8-0.3L384,74v22.5V119h-26h-26L332.2,96.8z"
            />
            <path
              className="st5"
              d="M644.7,118.3c-0.4-0.3-0.7-10.5-0.7-22.5V74h27.5H699v22.5V119h-26.8C657.4,119,645,118.7,644.7,118.3z"
            /> */}
          </g>
          <g id="layer107">
            <path
              className="st6"
              d="M423,1356.5c-16.2-1.2-38.2-4-63.5-8c-8.2-1.3-17.6-2.7-20.7-3l-5.8-0.7v-50.4c0-27.7,0.3-50.4,0.6-50.4
		s3.5,1.4,7.2,3.1c12.6,5.9,14.7,6.8,26.7,10.9c16.1,5.5,34.4,9.8,49.5,11.5c18.4,2.2,181.7,2.2,200.2,0c13.2-1.5,34.9-6.4,40.1-9
		c1.7-0.8,3.6-1.5,4.4-1.5c2.6,0,23.5-9.5,30.8-14l3.5-2.2v50.9v50.9l-16.7,2.8c-30.7,5.1-56.6,8.4-73.3,9.5
		C583.1,1358.4,443.2,1358.1,423,1356.5z"
            />
            <path
              className="st6"
              d="M106.9,1349.4c-7.2-2.2-9.9-5.3-9.9-11.4c0-3-0.4-5-1.1-5c-0.6,0-2.7-1.3-4.5-3c-1.9-1.6-4.7-3.2-6.2-3.5
		c-6.9-1.5-19.2-5.9-20.6-7.3c-3.5-3.9-3.7-7.1-3.7-51.6c0.1-24.3,0.1-47.8,0.1-52.3v-8.1l8.8-2.1c4.8-1.1,12-3.2,16.1-4.6
		s8.3-2.3,9.3-1.9c1.1,0.3,1.8,0,1.8-0.8c0-0.7,4.4-3.4,9.8-6c5.3-2.6,11.2-5.6,13-6.7c7.5-4.4,18.9-14,25.3-21.4
		c15.2-17.5,20.8-34.4,19.6-58.7c-1.3-24.3-10.7-43.9-29.5-61.1c-7.3-6.7-18.4-13.9-29.3-19.1c-4.9-2.3-8.9-4.8-8.9-5.5
		c0-0.7-0.4-1.3-1-1.3c-0.5,0-1,0.4-1,1c0,0.5-2.1,0.1-4.7-0.9c-2.7-1-10-3.1-16.3-4.6c-6.3-1.6-12.1-3-12.7-3.1
		c-1.4-0.4-1.9-16.4-0.5-16.4c1.4,0,21.7,6,27,8c2.9,1.1,6.8,2,8.7,2c2.3,0,3.8,0.6,4.4,1.9c0.6,1,2.3,2.2,3.8,2.6
		c4.8,1.2,23.5,10.9,31.8,16.6c10.5,7.1,20.7,17.4,27.8,28.2c5.5,8.2,11.7,21.6,11.7,25.2c0,2.2,1.8,5.5,3.1,5.5
		c0.6,0,0.8-0.9,0.4-2.1c-0.4-1.2,2,0.6,5.8,4.5c7,6.9,10.6,8.6,18.7,8.6c8.1,0,16.9-3,30-10.1c3.3-1.8,16.6-10.6,21-13.9
		c1.9-1.5,8-6,13.5-10.1c20-14.9,40.4-32.6,57.9-50.2c15.7-15.7,17.8-17.5,17.2-14.7c-0.3,1.8-1.3,8.5-2.1,14.9
		c-2.8,21.6-8.5,49.3-13.8,66.6c-4.1,13.7-15,37.1-45.1,97.3c-14.1,28.2-26.9,54.5-28.5,58.5c-3.2,7.8-6.2,19.6-11.2,43.2
		c-9.8,46.8-18.9,65.7-32.2,67.2c-2.6,0.3-4.7,0.1-5.1-0.5c-0.3-0.6,0.3-6.7,1.4-13.6c3-18.5,3.3-17.2-5.2-17.9
		c-4-0.4-16.1-1.7-27-2.9l-19.6-2.2l-0.6-3c-1.1-5.2-2.5-1.6-3.7,9.4c-1.4,12.7-5.1,26.3-8.5,30.7c-2.4,3.2-4,3.9-14.4,6.2
		C121.8,1351.3,112.4,1351.1,106.9,1349.4z M250.8,1212.2c1.7-3,3.2-5.6,3.2-5.7c0-0.2,1.8-3.2,4-6.6c3.7-6,9-14.8,11.6-19.4
		c0.6-1.1,6.1-10.5,12.1-21c6.1-10.4,11.9-20.6,12.9-22.6c1.1-2,4.1-7.8,6.8-13c8-15.4,20.1-49.1,29.1-80.9c4.4-15.4,7.2-33,5.3-33
		c-0.5,0-6.8,5.7-14.1,12.8c-7.2,7-19,18.3-26.1,25.2c-24.9,23.9-48.4,47.5-50.2,50.5c-1.8,2.7-1.9,6.3-2.1,64l-0.3,61l2.3-3
		C246.5,1218.9,249,1215.1,250.8,1212.2z"
            />
            <path
              className="st6"
              d="M248.5,1189.4c-0.9-15.7,0.3-84.8,1.5-87.9c1-2.6,35.7-36.8,72.9-72c4.4-4.2,7.1-6.2,6.8-5
		c-0.3,1.1-1.5,5.4-2.5,9.5c-3.6,13.8-8.1,28.6-14.3,46.6c-10.4,30.4-13.7,37.4-36.9,77.9c-8.2,14.3-25.2,42.8-26,43.8
		C249.5,1202.8,248.9,1197,248.5,1189.4z"
            />
            <path
              className="st6"
              d="M901.5,1350c-8.3-2-12-4-14.3-7.6c-2.9-4.5-6.7-19.3-7.7-29.9c-0.8-9.5-1.3-10.4-3.4-7.8
		c-1.4,1.7-4.3,2.3-20.1,4.1c-10.2,1.2-22,2.4-26.3,2.8c-4.2,0.3-7.9,1-8.2,1.3c-0.2,0.4,0.5,6.9,1.7,14.4
		c1.1,7.5,1.8,14.3,1.5,15.1c-1.4,3.6-10.8,0.8-15.8-4.6c-7.4-8-14.6-28.9-21.9-63.8c-4.8-22.8-7.9-34.2-11.4-42.7
		c-1.9-4.3-14.7-30.5-28.6-58.3c-28.6-57.3-39.8-81.2-43.9-94.4c-6.2-19.9-11.9-49.1-15.8-81.1l-0.6-5l6.4,6.9
		c3.5,3.8,6.8,7.5,7.2,8.3c1.2,2,33,30.8,41.8,37.7c4.1,3.3,9.4,7.6,11.9,9.6c6.1,4.9,21.4,16,32.9,23.8
		c24.9,16.7,41.7,20.3,54.3,11.5c4.1-2.8,6.8-6.8,6.8-10.1c0-2.2,2.7-4.8,5.4-5.3c1.3-0.3,2.8-2.4,4.4-6.4
		c3.3-8.2,11.6-20.6,19.4-29c10.7-11.4,24.1-20.1,47.3-30.6c7-3.2,35.2-12.7,42.8-14.5l2.7-0.6v8.6v8.6h-2.9c-3,0-26.1,6.4-29.2,8.1
		c-1.2,0.6-1.9,0.5-2.1-0.2c-0.3-0.8-0.9-0.7-1.8,0.3c-0.8,0.8-6.6,4.1-12.7,7.3c-28.8,15.1-45.2,33.7-52.8,60
		c-3.4,11.7-3.9,31.8-1.1,43.3c1,4,2.2,7.5,2.7,7.8c0.5,0.3,0.9,1.5,0.9,2.7c0,1.2,2.4,6.2,5.3,11.1c10.6,18.1,28.4,32.2,57.2,45.1
		c5.2,2.4,20.7,7.2,28.6,9l7.6,1.7l-0.1,53.3c-0.1,52.6-0.1,53.4-2.2,56.2c-3,4-6.8,5.9-17.3,8.7c-5.7,1.5-10.1,3.2-11.7,4.7
		l-2.4,2.2v-2.6c0-1.9-0.4-2.5-1.5-2.1c-1.2,0.5-1.5,2.4-1.5,8.4c0,8.4-0.4,9.2-7,12.6C921.9,1350.7,907.8,1351.5,901.5,1350z
		 M787.6,1163.8c-0.2-38.7-0.8-60.5-1.5-62.8c-1-3.4-26.6-29.6-62.6-63.9c-7.1-6.9-16.5-15.8-20.8-19.9c-4.2-4.2-8-7.2-8.3-6.9
		c-1.1,1.1,1.6,18.8,4.2,28.2c4.7,16.4,17.6,55.8,21.5,65.8c7.5,18.9,15.8,34,50.9,93c8.5,14.1,15.8,25.7,16.2,25.7
		C787.7,1223,787.9,1196.3,787.6,1163.8z"
            />
            <path
              className="st6"
              d="M771.3,1186.4c-26.7-44.7-41.6-72.5-47.4-88.4c-7.4-20.7-16-47.6-19.9-62.5c-1.1-4.4-2.3-8.9-2.7-10
		c-0.6-2.1,0.1-1.5,30.1,27c18.7,17.8,47.6,46.8,48.8,48.9c1.1,2,2.4,58,1.8,81.1l-0.5,21L771.3,1186.4z"
            />
            <path
              className="st6"
              d="M420.5,1267.4c-26.1-3.1-53.9-11-78.4-22.4l-9.3-4.4l0.6-5c0.4-2.8,1.7-10.7,3-17.6c1.4-6.9,3.6-19,5.1-27
		s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.8-20.1,5.1-26.9c1.3-6.8,2.4-13.5,2.4-14.7
		c0-2.8,1.1-3.2,25-7.9c32.6-6.5,31.8-6.5,122.4-6.5c67,0,84.2,0.3,92.7,1.5c16.5,2.3,47.4,8.9,49.2,10.5c0.4,0.3,1.6,5.6,2.6,11.6
		c1.1,6,2.6,14.5,3.5,18.9c0.8,4.4,2.6,14.1,4,21.5c1.4,7.4,3.6,19.6,5,27c1.4,7.4,3.6,19.6,5,27c1.4,7.4,3.6,19.6,5,27
		c1.4,7.4,3.7,20,5.1,28c1.5,8,3.8,20.1,5.1,27l2.5,12.4l-2.2,1.7c-4.2,3.1-22.4,11.8-32.4,15.3c-12.1,4.4-27.4,8.1-41.5,10.3
		C605.1,1269,439,1269.6,420.5,1267.4z M672,1184.6c0-23.7-0.3-30.3-2-39.8c-3.4-19.6-11-50.7-21.7-89.3l-2.8-10l-5-1.3
		c-2.8-0.6-13.3-2.7-23.5-4.5l-18.5-3.2h-85h-85l-21.5,3.3c-11.8,1.8-21.8,3.6-22.2,4c-0.3,0.4-1.8,5.2-3.3,10.7
		c-5.7,21.3-9.8,37.2-11,42.5c-0.7,3-2,8.4-2.8,12c-8.1,33.5-9.8,45.9-10.4,75.2c-0.3,14.1-0.3,26.4,0,27.2
		c0.6,1.4,16.7,1.6,157.7,1.6h157V1184.6z"
            />
            <path
              className="st6"
              d="M363.4,1207.5c-0.4-0.8-0.4-14-0.1-29.2l0.4-27.8l4.2-19.5c5.2-24.6,6.6-30.6,13.5-57c6.5-25.2,6.7-26,7.1-26
		c0.2,0,3.9-0.7,8.2-1.5c25-4.8,29.2-5,117.3-5c82.3,0,83.7,0,97.5,2.3c7.7,1.2,17.6,3,22,4l7.9,1.7l1.4,4.5
		c7.5,24.7,21,80.6,23.2,96c1.1,7.5,1.4,56.5,0.4,58.1c-0.3,0.5-68.5,0.9-151.5,0.9C382,1209,363.9,1208.8,363.4,1207.5z"
            />
            <path
              className="st6"
              d="M63.5,1149.6c-11-3.6-19.8-11.4-25.2-22.4c-11.8-23.7,1.4-51.9,27.5-58.6c26.6-6.9,52.3,12.9,52.4,40.3
		c0.1,7.8-2,15.2-6.2,22.6c-3.9,6.8-9.6,11.8-18,15.9c-5.8,2.8-7.6,3.1-16.5,3.3C71.3,1150.9,66,1150.5,63.5,1149.6z"
            />
            <path
              className="st6"
              d="M938.7,1148.6c-10.2-4.3-16.2-9.2-20.7-17.1c-10.2-17.7-7.9-37.3,5.9-51.8c10.1-10.6,25.7-14.9,40.3-11.1
		c20,5.1,32.7,22.4,31.6,43c-0.4,7-1,9.4-4,15.6c-4.5,9.1-11.1,15.7-19.7,20c-6,3-7.5,3.3-17.1,3.6
		C945.7,1151,943.8,1150.8,938.7,1148.6z"
            />
            <path
              className="st6"
              d="M198.4,1088.9c-5.8-1.6-11.6-8.1-18.3-20c-8.1-14.6-15.9-26.3-21-31.6c-2.3-2.3-4.1-4.9-4.1-5.8
		c0-0.8-0.7-1.5-1.6-1.5c-0.9,0-3.8-1.8-6.4-4c-9.9-8.3-27.4-17.9-47.7-26.1c-1.3-0.4-2.3-1.5-2.3-2.4c0-1.7-1.7-2-2.2-0.4
		c-0.3,1-11.3-2-29.3-8l-5-1.6l-0.3-73.2L60,841l2.2-0.5c5.6-1.3,30.8-5.7,35.3-6.1c7.7-0.7,43.5-4.4,48.2-5
		c2.4-0.3,4.5-0.9,4.8-1.5c0.8-1.2,5.2-1.2,6,0c0.3,0.5,4.5,1,9.3,1c18.1,0.1,62.4,3,71.2,4.6c5.1,1,38.3,3.4,60,4.5
		c35,1.7,52.1,2.8,52.7,3.3c0.2,0.3,0.5,19.4,0.5,42.4c0,34.5-0.4,46.5-2.2,68.8l-2.2,27l-3.6,5.5c-8.6,13.1-49.8,51.3-77.7,72.1
		c-14.9,11-33.7,23.9-35.1,23.9c-0.3,0-1.9,0.9-3.5,2c-3.3,2.4-18,7-21.8,6.9C202.7,1089.9,200.1,1089.4,198.4,1088.9z
		 M254.9,1049.8c7.1-4.3,19.8-12.5,30.5-19.8c19.1-13,44.4-36.7,50.5-47.3c7.2-12.5,8.5-27.8,7.5-89.5c-0.7-44.9-0.7-45.2-2.8-45.7
		c-1.2-0.2-15.8-0.9-32.6-1.5c-16.8-0.6-37.7-1.5-46.5-2c-12.3-0.7-16.1-0.7-16.7,0.3c-1.3,2-1,210.7,0.3,210.7
		C245.7,1055,250.1,1052.7,254.9,1049.8z"
            />
            <path
              className="st6"
              d="M249.7,1019.8c-0.4-14.5-0.7-58.8-0.7-98.5V849h8.3c9,0,64.5,2.7,74.5,3.6l6.4,0.6l-0.5,55.1
		c-0.5,61.9-0.6,63.2-7.2,73.2c-3.5,5.3-17.8,21.5-19.7,22.3c-0.4,0.2-2.9,2.1-5.5,4.3c-2.6,2.1-5.1,3.9-5.4,3.9
		c-0.4,0-2.4,1.6-4.5,3.6c-2.2,2-5.3,4.6-7,5.8c-1.8,1.1-6.7,4.6-11,7.6c-8.4,5.9-25.8,17-26.6,17
		C250.5,1046,250,1034.2,249.7,1019.8z"
            />
            <path
              className="st6"
              d="M811.5,1087.1c-8.7-3.6-14.8-7.1-24.9-14.1c-4.3-3-8.8-6.2-10-7c-3.7-2.6-16.5-11.9-18.3-13.4
		c-1-0.8-7-5.7-13.3-10.8c-15.4-12.5-33.5-29.3-45.4-42.1c-16.3-17.6-14.9-14.2-17.7-43.2c-2.1-22.3-2.4-29.9-2.4-70.2
		c0.1-24.9,0.3-45.4,0.6-45.7c0.3-0.3,9.5-1,20.4-1.5c55-2.9,76.7-4.5,103-7.6c7.2-0.8,19.1-1.7,26.5-2c7.4-0.2,20.6-0.7,29.2-1.1
		c8.6-0.3,16.1-0.4,16.6,0c0.5,0.3,6.3,0.8,12.8,1c13.5,0.5,53.3,5.4,70.7,8.7l11.7,2.2l-0.2,74.1l-0.3,74.1l-4.5,1.3
		c-2.5,0.8-10.3,3.2-17.4,5.4c-10,3.2-13,3.8-13.6,2.8c-0.6-1-0.9-0.9-1.1,0.4c-0.3,1.2-4.8,3.6-13.2,7.2
		c-15.7,6.7-35.1,18.3-39.6,23.8c-1.9,2.2-3.1,2-3.2-0.6c-0.1-1.7-0.3-1.5-1,1.1c-0.6,1.8-3.3,6.1-6.1,9.5
		c-5.9,7-11.5,15.5-18.1,27.6c-6.5,11.8-9.6,15.9-14.6,19.7c-4,3.1-4.8,3.3-11.9,3.3C820,1089.9,817.1,1089.4,811.5,1087.1z
		 M785,948.9V843.8l-6.2,0.6c-3.5,0.3-13.5,0.8-22.3,1.1c-19.7,0.6-67.9,2.7-68.2,2.9c-0.1,0.1-0.3,22.7-0.4,50.2
		c-0.1,50.5,0.7,67.2,3.7,75.7c3.8,10.7,18.1,27.1,35.2,40.4c4.8,3.7,8.9,7,9.2,7.3c0.8,1.1,26,18.4,31.3,21.6
		c10.3,6.2,17.2,10.3,17.5,10.3C784.9,1054,785,1006.7,785,948.9z"
            />
            <path
              className="st6"
              d="M774.5,1042.8c-18.5-11.8-40.5-27.2-40.5-28.4c0-0.2,10.6-0.4,23.5-0.4H781v16c0,8.8-0.3,16-0.7,16
		C779.8,1046,777.3,1044.5,774.5,1042.8z"
            />
            <path
              className="st6"
              d="M719.7,1002.7c-10.5-9.6-18.3-18.7-22-26.1c-4-7.8-4.7-18.3-5-73.4c-0.3-46.9-0.2-49.4,1.5-50.3
		c1-0.6,2.2-0.8,2.6-0.5c0.8,0.5,75.4-2.9,81.5-3.7l2.7-0.4v81.4v81.3h-26h-26.1L719.7,1002.7z"
            />
            <path
              className="st6"
              d="M370.5,1027.6c1.2-11.8,2.5-42.9,3-68.1c0.3-14.8,0.8-29,1-31.5c1-8.9,0.6-126.1-0.5-152
		c-0.6-14.6-2-38.6-3-53.4c-1.1-14.8-2-27.7-2-28.7c0-2.2,3.4-2.9,32-6.6l21.5-2.8H515h92.5l20,2.8c11,1.6,22.2,3.3,24.9,3.8
		s5.1,0.9,5.4,0.9c0.2,0,0.2,4.2-0.2,9.3c-2,28-4.6,113.2-4.6,150.7c0,39.7,1.9,116.9,3.9,160.5c0.5,10.5,0.8,19.2,0.6,19.4
		c-0.3,0.2-6.9-1-14.7-2.7c-39.2-8.4-27.6-7.7-126.8-7.7h-88.5l-18,3.3c-9.9,1.8-22.8,4.3-28.7,5.6l-10.8,2.3L370.5,1027.6z
		 M582.5,840.2c8-2.9,15.3-9.4,19-16.8l3-5.9v-29v-29l-2.8-5.5c-5.5-10.7-14.3-17-26.7-19c-8.8-1.3-114.4-1.3-123,0.1
		c-8.6,1.4-14.4,4.3-20.5,10.4c-8.5,8.5-9,11.1-9,43.5v27.5l2.9,6.3c4.7,10.1,13.4,16.5,26.1,19.2c2.2,0.4,31.2,0.7,64.5,0.6
		C576,842.5,576.5,842.4,582.5,840.2z"
            />
            <path
              className="st6"
              d="M445.8,837.7c-8.3-3.2-14.5-8.8-18-16.2l-2.9-6.3l0.3-27.8c0.3-26.9,0.4-28.1,2.6-32.4
		c4.5-8.7,11.1-14.1,20.3-16.6c7.8-2,122.9-2.1,130.6,0c9.1,2.4,16,8,20.5,16.6c2.3,4.4,2.3,5.1,2.3,33.5c0,28.9,0,29-2.5,33.9
		c-3.5,6.8-10.4,12.7-18.1,15.4c-6.4,2.2-6.6,2.2-67.9,2.2C452.1,839.9,451.4,839.9,445.8,837.7z"
            />
            <path
              className="st6"
              d="M349,835.7c-0.6-0.5-28.6-2.3-76-4.7c-11.8-0.6-25.3-1.7-30-2.5c-10.7-1.8-67.2-5.5-84.7-5.5
		c-2.3,0-3.3-0.5-3.3-1.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.8-1.5,1.8c0,1.6-2.2,2-20.7,3.6c-11.5,1-23.2,2.2-26.2,2.8
		c-2.9,0.5-6.4,0.7-7.7,0.4c-1.3-0.4-2.4-0.2-2.4,0.3s-3,1.3-6.8,1.6c-3.7,0.4-10.9,1.6-16.1,2.6c-5.1,1-9.7,1.9-10.2,1.9
		S61,777.2,61,697.6V560.1l3.3-2.5c4.5-3.4,13.3-7.2,20.9-9c3.5-0.8,7.1-1.8,8-2.1c1.3-0.5,1.8-0.2,1.8,0.9c0,0.9,0.5,1.6,1,1.6
		c0.6,0,1-0.6,1-1.4c0-0.8,0.4-1.7,0.8-2c1.4-0.8,30-4.5,42.2-5.5c17.8-1.3,41.5-0.6,58.5,1.9c26,3.9,54.4,12.1,56.7,16.4
		c0.6,1.2,7.2,12.3,14.7,24.8s14.2,24,15,25.5c0.7,1.5,3.5,6.4,6.1,10.8c7.9,13.4,39,69.4,44.2,79.5c8.1,15.8,11.3,36.4,13.8,88
		C350.1,808.4,350.1,836.7,349,835.7z M344.2,803.5c-0.6-43.1-3.7-73.7-9-88c-2.7-7.1-7.2-16.8-17.3-37
		C306.7,656.3,280,612,265.1,591c-6.9-9.9-18.6-23-20.3-23c-0.4,0-0.8,56.7-0.8,125.9c0,119.1,0.1,126,1.8,126.5
		c0.9,0.2,12.3,1.2,25.2,2.1c12.9,1,33,2.5,44.5,3.5c11.6,1,22.8,1.7,25,1.6l4-0.1L344.2,803.5z M203,806c2.4-1.5,0.7-1.9-2-0.5
		c-1.5,0.8-1.9,1.4-1,1.4C200.8,807,202.2,806.6,203,806z M95.7,675.3c-0.3-1-0.5-0.2-0.5,1.7c0,1.9,0.2,2.7,0.5,1.8
		C95.9,677.8,95.9,676.2,95.7,675.3z"
            />
            <path
              className="st6"
              d="M326.5,821.3c-3.8-0.2-20.3-1.5-36.5-2.8c-16.2-1.4-31.9-2.5-34.7-2.5H250l-0.2-103.2
		c-0.2-56.8-0.1-109.9,0.2-117.9l0.5-14.7l3.1,4.2c1.7,2.2,5.1,6.8,7.5,10.1c3.7,5,11.4,16.9,22.4,34.5
		c9.9,15.9,18.5,31.1,31.9,56.5c7.8,14.7,14.8,31.2,17.1,40.5c3.2,12.5,5.4,37.6,6.2,70.3l0.6,25.7l-2.9-0.2
		C334.8,821.7,330.4,821.5,326.5,821.3z"
            />
            <path
              className="st6"
              d="M680,833.3c0.1-15.4,2.4-67,3.5-80.3c2.1-24.1,5.6-42,9.8-50.7c2.4-4.9,4.6-9,17.2-31.3
		c2.3-4.1,5.8-10.6,7.9-14.3c2-3.7,4.5-8.2,5.5-10s5.6-9.7,10.1-17.7c15.1-26.4,19-33.2,31.3-53.5c5.3-8.8,9.7-16.4,9.7-17
		c0-2.1,11.1-6.3,30-11.4c15.1-4,46.3-8.1,62.7-8.1c5.8,0,7.4,0.3,8.2,1.8c0.9,1.4,1.2,1.5,2,0.3c1.3-2,11.1-1.6,34.6,1.4
		c27.9,3.6,45.8,8.7,54.2,15.4l3.3,2.6v137.3c0,75.4-0.3,137.2-0.7,137.2c-0.3,0-5.4-0.9-11.2-1.9c-5.8-1.1-13.2-2.3-16.3-2.6
		c-4.8-0.5-5.8-1-5.8-2.6c0-2.3-1.6-2.5-2.8-0.3c-0.7,1.3-1.9,1.4-9.3,0.4c-4.6-0.7-16.7-1.9-26.9-2.8c-17.8-1.6-18.5-1.8-18.8-3.9
		c-0.4-2.8-2.2-3-2.2-0.3c0,1.6-0.7,2-3.2,2c-17.3,0-73.3,3.6-85,5.4c-5.1,0.8-19,2-30.8,2.6c-11.8,0.6-32.1,1.8-45,2.5
		C681,835.4,680,835.4,680,833.3z M705,826.6c9.1-0.8,20.8-1.7,26-2.1c23.1-1.5,50.7-3.6,52.8-4.1l2.2-0.4V693.2l-0.1-126.7
		l-5.9,6.2c-16.7,17.7-49.8,70.8-73.2,117.5C695,713.8,692.4,721.6,690,741c-3.7,29.5-5.5,87-2.7,87
		C687.9,828,695.9,827.4,705,826.6z"
            />
            <path
              className="st6"
              d="M691.4,806.8c0.4-8.4,0.9-20.7,1.1-27.3c1.2-32.9,4.2-53.1,9.7-66.5c7.2-17.6,23.8-48.7,43.1-80.7l10.9-18.3
		h12.4H781l-0.2,100.8l-0.3,100.7l-11.5,0.8c-6.3,0.4-12.2,0.8-13,0.9c-0.8,0-8.7,0.6-17.5,1.3c-8.8,0.8-20.7,1.6-26.5,2
		c-5.8,0.3-12.9,0.8-15.8,1.1l-5.4,0.6L691.4,806.8z"
            />
            <path
              className="st6"
              d="M759,610.4c0-0.7,15.9-23.4,19.5-27.9l2.5-3v15.8V611h-11C764,611,759,610.7,759,610.4z"
            />
            <path
              className="st6"
              d="M367.7,685.3c-0.4-0.8-1.2-3.9-6.1-24.3c-2.4-10-4.4-18-13.6-56.5c-2.2-9.3-5.1-21.5-6.5-27
		c-5.7-23.5-5.9-24.7-4.4-25.6c0.8-0.4,3.6-1.3,6.4-1.9c2.7-0.6,9.5-2.2,15-3.5c36.1-8.7,50.8-10.5,84.9-10.5
		c24,0,27.1,0.2,28.8,1.7c1.5,1.3,2.1,1.4,2.7,0.4c0.6-0.9,5.9-1.2,22.7-1.1c48,0.2,93.5,1,94.4,1.5c0.5,0.3,1.8,0.2,2.8-0.4
		c2.9-1.5,35.8,0.6,52.2,3.5c13.6,2.3,28.3,5.4,42.7,9l6.1,1.6l-1,3.1c-0.5,1.8-2.3,8.4-4,14.7c-1.7,6.3-3.8,14.4-4.8,18
		c-1.9,6.7-7,25.7-10.1,37c-5.3,20-8.4,31.4-10.5,39c-1.3,4.7-3.1,11.5-4,15.3l-1.6,6.7h-3.5c-2,0-8.8-0.9-15.2-2
		c-26.8-4.5-38.8-5-126.1-5c-87.2,0-101.4,0.6-128.8,5C373.1,686.1,368.4,686.5,367.7,685.3z"
            />
            <path
              className="st7"
              d="M59,537v-18h2.9c1.7,0,3.3-0.5,3.6-1.1c0.4-0.6,1.3-0.8,2-0.5c0.7,0.2,6.4-0.8,12.7-2.4
		c28.5-7.2,51.2-20.8,65-39c6.2-8.1,12.5-21.1,15-31c3.1-11.7,3.4-33.8,0.7-45.3c-6.1-25.8-23-46.5-48.4-59.4
		c-10.4-5.3-18.9-9-21.5-9.5c-1.4-0.3-5.9-1.5-10-2.6c-4.1-1.2-10.8-2.6-14.7-3.2l-7.3-1.2v-32.4c0-20.3,0.4-32.4,1-32.4
		c0.5,0,7.8-3.4,16.1-7.5c8.4-4.1,15.9-7.5,16.6-7.5c2.6,0,3.8-2.4,5-9.3c1.2-7.4,3-10.8,6.9-13.3c2.3-1.5,3.2-1.6,9.7-0.3
		c4,0.7,9.2,1.3,11.7,1.2c6.2-0.2,18.9,1.7,22.2,3.3c4.3,2.2,4.8,5.7,4.3,30.9c-0.3,12.7-0.7,24-0.8,25.3c-0.2,2.1,0.9,2.7,11.3,6.3
		c6.3,2.2,14.7,5.1,18.5,6.5c3.9,1.4,8.9,3.1,11.2,3.9l4.2,1.4l0.5-3.2c0.2-1.8,0.4-4.3,0.4-5.7s0.4-7.2,0.9-13
		c0.7-9.6,1-10.5,2.8-10.5c1.5,0,2.8,1.6,4.9,6c7.1,14.6,16.9,48.5,19.6,67.6c0.6,4.1,1.7,11.2,2.5,15.9c1.2,7.3,2.1,15.1,3.9,37
		c0.3,2.5,0.9,9.5,1.5,15.5c1,9.5,1.7,17.7,3.5,42.6c1.8,24,7.9,68.8,10.6,77.9c2.6,8.7,5,18.1,5,19.6c0,2-4,1.6-12-1.4
		c-11.6-4.3-31.5-8.5-52.5-11.3c-4.9-0.6-50.4-0.4-58,0.3c-13.1,1.3-34.4,4.8-44.1,7.4c-9.2,2.5-21.8,7.7-23,9.5
		c-0.3,0.5-1.4,0.9-2.5,0.9C59.1,555,59,554.2,59,537z"
            />
            <path
              className="st6"
              d="M962.3,550.4c-3.4-1.9-10.8-4.8-16.4-6.4c-5.6-1.6-10.6-3.4-10.9-4.1c-0.6-0.8-0.9-0.8-1.2,0.1
		c-0.3,1-3.1,0.8-12.3-0.8c-6.6-1.1-12.7-2.1-13.5-2.1s-6.7-0.5-13-1c-38-3.2-73.1,0.5-106.3,11.1c-5.3,1.7-10,2.9-10.3,2.5
		c-0.3-0.3,0.6-4.3,2-8.9c3.2-10.5,7.2-30.5,8.6-42.5c0.6-5.1,1.5-12.5,2-16.5c1.1-7.9,1.5-12.4,3-32.3c0.6-7.1,1.7-19.5,2.4-27.5
		c0.8-8,1.4-15.2,1.4-16c0.1-4.4,3.2-36.8,3.6-38c0.3-0.8,0.8-4,1.1-7c2.6-26,10.5-57.8,20.6-83.1c3.4-8.4,5.5-11.2,6.8-9
		c0.8,1.2,2.3,21,2.3,28.9c-0.1,1.7,0.3,3.2,0.8,3.2c0.4,0,3.9-1.1,7.7-2.4c3.7-1.3,14-4.9,22.7-7.9l15.9-5.6l-0.2-27.3l-0.2-27.3
		l2.3-2.1c3.9-3.5,4.9-3.8,16.8-4.6c6.3-0.3,12.6-0.9,14-1.1c1.4-0.2,4.4-0.7,6.7-1.1c3.2-0.6,4.9-0.3,7.2,1
		c3.7,2.2,4.9,4.8,6.1,13.1c0.5,3.6,1,6.6,1.2,6.7c0.5,0.4,24.6,12,31.5,15.2l6.3,2.9v31.1v31.2l-11.6,2.2c-6.3,1.2-14.1,3-17.1,4.1
		c-7.1,2.4-7.1,2.4-7.6-0.8c-0.4-2.8-0.4-2.8-0.6,0.3c-0.1,2.7-0.7,3.3-5.8,5.4c-6.7,2.6-14.5,6.8-22.3,11.8
		c-5.9,3.8-21.3,18.6-24.9,23.9c-4.4,6.5-9.4,17.9-11.6,26.7c-2.7,11.1-2.9,12.7-2.9,24.1c-0.1,32.3,12.8,57.6,38.4,75.7
		c10.5,7.3,18.7,11.4,34,16.8c5.7,2.1,22.6,6,25.6,6c6.6,0,6.4-0.5,6.4,18.1c0,12.9-0.3,16.9-1.2,16.8
		C969.1,553.8,965.7,552.2,962.3,550.4z"
            />
            <path
              className="st6"
              d="M337.5,542.5c1.9-4.8,0.4-7.1-1.9-2.9c-1.4,2.6-1.5-9.9-1.3-134.6l0.2-137.4l11.5-1.8c36.7-5.7,45-7,59.5-9.2
		c8.8-1.4,18.4-2.8,21.3-3.1c3-0.4,7.2-1.8,9.5-3.1c2.3-1.3,5.2-2.4,6.4-2.4c1.2,0,2.5-0.4,2.8-1c0.8-1.3,61.5-1.4,61.5-0.1
		c0,0.5-1.1,4.2-2.5,8.3c-1.4,4-2.5,7.8-2.5,8.4c0,1,15.8,13,18.3,13.9c0.7,0.3,4.6-2,8.7-5.1c4.1-3.1,8.3-6.2,9.3-6.9
		c1.7-1.2,1.7-1.7-1.1-10.1l-2.9-8.9l25.6-0.3c24.7-0.2,25.7-0.2,27.3,1.8c0.9,1.1,2.5,2,3.5,2s2.7,0.6,3.8,1.4
		c1.1,0.7,4.5,1.7,7.5,2c3,0.4,13.6,1.8,23.5,3.2c34.6,4.8,53.1,7.3,61.7,8.4l8.8,1.2l0.2,132.2c0.2,72.6,0.1,135.7-0.2,140.1
		l-0.5,8l-1.4-4.5c-0.7-2.5-1.8-5.1-2.3-5.7c-2.1-2.6-2.6-1.2-1.2,3.4c0.8,2.5,1.2,4.8,1,5c-0.2,0.2-2.1-0.5-4.2-1.6
		c-4.1-2.2-7.4-2.7-7.4-1.2c0,0.5-6.2-0.4-13.7-2c-36.9-7.8-49.4-8.3-201.8-8.4c-65.9,0-63.3-0.2-100,8.2c-9.5,2.2-15.1,3-15.3,2.4
		c-0.6-1.8-4.2-1.2-8.8,1.5l-4.5,2.7L337.5,542.5z M384,410.7c0-1.8-0.2-1.9-1-0.7c-1.3,2-1.3,4.3,0,3.5
		C383.6,413.2,384,411.9,384,410.7z"
            />
            <path
              className="st6"
              d="M64.2,462.5c-12.8-4.1-20.5-10.8-26.1-22.4c-3-6.3-3.6-9-4-15.5c-0.6-14.8,6-28.8,17.5-36.7
		c5.9-4,17.6-7.9,24-8c10.2-0.2,21.6,4.4,29.5,11.8c20.8,19.5,16.1,55-9,67.7c-6.3,3.2-15.2,5.6-20.6,5.6
		C73.3,464.9,68.2,463.8,64.2,462.5z"
            />
            <path
              className="st6"
              d="M944.3,463.5c-2.9-0.8-7.6-2.6-10.4-4c-25.1-12.8-29.8-48.3-9-67.8c7.9-7.4,19.3-12,29.5-11.8
		c6.4,0.1,18.1,4,24,8c11.5,7.9,18.1,21.9,17.5,36.7c-0.4,6.5-1,9.2-4,15.4c-5.6,11.8-13.4,18.5-26.1,22.5
		C956.9,465.3,951.9,465.5,944.3,463.5z"
            />
            <path
              className="st6"
              d="M514.7,266.9c-3.2-2.3-5.7-4.8-5.7-5.8c0-0.9,0.9-4.5,2.1-7.9l2.1-6.2h7.7h7.7l2.2,6.8
		c1.2,3.8,2.2,7.3,2.2,7.8c0,0.8-11.2,9.4-12.2,9.4C520.6,271,517.9,269.2,514.7,266.9z"
            />
            {/* <path
              className="st6"
              d="M332.2,96.8l0.3-22.3H358h25.5l0.3,22.3L384,119h-26h-26L332.2,96.8z"
            />
            <path
              className="st6"
              d="M649.3,118.3l-5.3-0.4v-22V74h27.5H699v22.5V119l-22.2-0.2C664.5,118.7,652.1,118.5,649.3,118.3z"
            /> */}
          </g>
          <g id="layer108">
            {/* Trunk */}
            <path
              onClick={() => userClick("Trunk")}
              style={{
                fill: this.filterAction("Trunk").Amount > 0 ? "#f73838" : null,
              }}
              className="st8"
              d="M423,1356.5c-16.2-1.2-38.2-4-63.5-8c-8.2-1.3-17.6-2.7-20.7-3l-5.8-0.7v-50.4c0-27.7,0.3-50.4,0.6-50.4
		s3.5,1.4,7.2,3.1c12.6,5.9,14.7,6.8,26.7,10.9c16.1,5.5,34.4,9.8,49.5,11.5c18.4,2.2,181.7,2.2,200.2,0c13.2-1.5,34.9-6.4,40.1-9
		c1.7-0.8,3.6-1.5,4.4-1.5c2.6,0,23.5-9.5,30.8-14l3.5-2.2v50.9v50.9l-16.7,2.8c-30.7,5.1-56.6,8.4-73.3,9.5
		C583.1,1358.4,443.2,1358.1,423,1356.5z"
            />

            {/* LBF */}
            <path
              onClick={() => userClick("LeftBackFender")}
              style={{
                fill:
                  this.filterAction("LeftBackFender").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M106.9,1349.4c-7.2-2.2-9.9-5.3-9.9-11.4c0-3-0.4-5-1.1-5c-0.6,0-2.7-1.3-4.5-3c-1.9-1.6-4.7-3.2-6.2-3.5
		c-6.9-1.5-19.2-5.9-20.6-7.3c-3.5-3.9-3.7-7.1-3.7-51.6c0.1-24.3,0.1-47.8,0.1-52.3v-8.1l8.8-2.1c4.8-1.1,12-3.2,16.1-4.6
		s8.3-2.3,9.3-1.9c1.1,0.3,1.8,0,1.8-0.8c0-0.7,4.4-3.4,9.8-6c5.3-2.6,11.2-5.6,13-6.7c7.5-4.4,18.9-14,25.3-21.4
		c15.2-17.5,20.8-34.4,19.6-58.7c-1.3-24.3-10.7-43.9-29.5-61.1c-7.3-6.7-18.4-13.9-29.3-19.1c-4.9-2.3-8.9-4.8-8.9-5.5
		c0-0.7-0.4-1.3-1-1.3c-0.5,0-1,0.4-1,1c0,0.5-2.1,0.1-4.7-0.9c-2.7-1-10-3.1-16.3-4.6c-6.3-1.6-12.1-3-12.7-3.1
		c-1.4-0.4-1.9-16.4-0.5-16.4c1.4,0,21.7,6,27,8c2.9,1.1,6.8,2,8.7,2c2.3,0,3.8,0.6,4.4,1.9c0.6,1,2.3,2.2,3.8,2.6
		c4.8,1.2,23.5,10.9,31.8,16.6c10.5,7.1,20.7,17.4,27.8,28.2c5.5,8.2,11.7,21.6,11.7,25.2c0,2.2,1.8,5.5,3.1,5.5
		c0.6,0,0.8-0.9,0.4-2.1c-0.4-1.2,2,0.6,5.8,4.5c7,6.9,10.6,8.6,18.7,8.6c8.1,0,16.9-3,30-10.1c3.3-1.8,16.6-10.6,21-13.9
		c1.9-1.5,8-6,13.5-10.1c20-14.9,40.4-32.6,57.9-50.2c15.7-15.7,17.8-17.5,17.2-14.7c-0.3,1.8-1.3,8.5-2.1,14.9
		c-2.8,21.6-8.5,49.3-13.8,66.6c-4.1,13.7-15,37.1-45.1,97.3c-14.1,28.2-26.9,54.5-28.5,58.5c-3.2,7.8-6.2,19.6-11.2,43.2
		c-9.8,46.8-18.9,65.7-32.2,67.2c-2.6,0.3-4.7,0.1-5.1-0.5c-0.3-0.6,0.3-6.7,1.4-13.6c3-18.5,3.3-17.2-5.2-17.9
		c-4-0.4-16.1-1.7-27-2.9l-19.6-2.2l-0.6-3c-1.1-5.2-2.5-1.6-3.7,9.4c-1.4,12.7-5.1,26.3-8.5,30.7c-2.4,3.2-4,3.9-14.4,6.2
		C121.8,1351.3,112.4,1351.1,106.9,1349.4z M250.8,1212.2c1.7-3,3.2-5.6,3.2-5.7c0-0.2,1.8-3.2,4-6.6c3.7-6,9-14.8,11.6-19.4
		c0.6-1.1,6.1-10.5,12.1-21c6.1-10.4,11.9-20.6,12.9-22.6c1.1-2,4.1-7.8,6.8-13c8-15.4,20.1-49.1,29.1-80.9c4.4-15.4,7.2-33,5.3-33
		c-0.5,0-6.8,5.7-14.1,12.8c-7.2,7-19,18.3-26.1,25.2c-24.9,23.9-48.4,47.5-50.2,50.5c-1.8,2.7-1.9,6.3-2.1,64l-0.3,61l2.3-3
		C246.5,1218.9,249,1215.1,250.8,1212.2z"
            />
            <path
              className="st8"
              d="M248.5,1189.4c-0.9-15.7,0.3-84.8,1.5-87.9c1-2.6,35.7-36.8,72.9-72c4.4-4.2,7.1-6.2,6.8-5
		c-0.3,1.1-1.5,5.4-2.5,9.5c-3.6,13.8-8.1,28.6-14.3,46.6c-10.4,30.4-13.7,37.4-36.9,77.9c-8.2,14.3-25.2,42.8-26,43.8
		C249.5,1202.8,248.9,1197,248.5,1189.4z"
            />
            {/* RBF */}
            <path
              onClick={() => userClick("RightBackFender")}
              style={{
                fill:
                  this.filterAction("RightBackFender").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M901.5,1350c-8.3-2-12-4-14.3-7.6c-2.9-4.5-6.7-19.3-7.7-29.9c-0.8-9.5-1.3-10.4-3.4-7.8
		c-1.4,1.7-4.3,2.3-20.1,4.1c-10.2,1.2-22,2.4-26.3,2.8c-4.2,0.3-7.9,1-8.2,1.3c-0.2,0.4,0.5,6.9,1.7,14.4
		c1.1,7.5,1.8,14.3,1.5,15.1c-1.4,3.6-10.8,0.8-15.8-4.6c-7.4-8-14.6-28.9-21.9-63.8c-4.8-22.8-7.9-34.2-11.4-42.7
		c-1.9-4.3-14.7-30.5-28.6-58.3c-28.6-57.3-39.8-81.2-43.9-94.4c-6.2-19.9-11.9-49.1-15.8-81.1l-0.6-5l6.4,6.9
		c3.5,3.8,6.8,7.5,7.2,8.3c1.2,2,33,30.8,41.8,37.7c4.1,3.3,9.4,7.6,11.9,9.6c6.1,4.9,21.4,16,32.9,23.8
		c24.9,16.7,41.7,20.3,54.3,11.5c4.1-2.8,6.8-6.8,6.8-10.1c0-2.2,2.7-4.8,5.4-5.3c1.3-0.3,2.8-2.4,4.4-6.4
		c3.3-8.2,11.6-20.6,19.4-29c10.7-11.4,24.1-20.1,47.3-30.6c7-3.2,35.2-12.7,42.8-14.5l2.7-0.6v8.6v8.6h-2.9c-3,0-26.1,6.4-29.2,8.1
		c-1.2,0.6-1.9,0.5-2.1-0.2c-0.3-0.8-0.9-0.7-1.8,0.3c-0.8,0.8-6.6,4.1-12.7,7.3c-28.8,15.1-45.2,33.7-52.8,60
		c-3.4,11.7-3.9,31.8-1.1,43.3c1,4,2.2,7.5,2.7,7.8c0.5,0.3,0.9,1.5,0.9,2.7c0,1.2,2.4,6.2,5.3,11.1c10.6,18.1,28.4,32.2,57.2,45.1
		c5.2,2.4,20.7,7.2,28.6,9l7.6,1.7l-0.1,53.3c-0.1,52.6-0.1,53.4-2.2,56.2c-3,4-6.8,5.9-17.3,8.7c-5.7,1.5-10.1,3.2-11.7,4.7
		l-2.4,2.2v-2.6c0-1.9-0.4-2.5-1.5-2.1c-1.2,0.5-1.5,2.4-1.5,8.4c0,8.4-0.4,9.2-7,12.6C921.9,1350.7,907.8,1351.5,901.5,1350z
		 M787.6,1163.8c-0.2-38.7-0.8-60.5-1.5-62.8c-1-3.4-26.6-29.6-62.6-63.9c-7.1-6.9-16.5-15.8-20.8-19.9c-4.2-4.2-8-7.2-8.3-6.9
		c-1.1,1.1,1.6,18.8,4.2,28.2c4.7,16.4,17.6,55.8,21.5,65.8c7.5,18.9,15.8,34,50.9,93c8.5,14.1,15.8,25.7,16.2,25.7
		C787.7,1223,787.9,1196.3,787.6,1163.8z"
            />
            <path
              className="st8"
              d="M778.9,1199.2c-2.1-3.5-10.6-17.9-17-28.9c-28.8-49-34.6-61.2-46.4-96.8c-4.8-14.7-11.7-38.2-13.6-46.3
		c-0.8-3.7-2.4-5,22,18.3c5.1,5,13,12.5,17.5,16.7c11.9,11.3,11.8,11.2,26,25.6l13.1,13.4l0.7,19.1c1,24.8,1,75.4,0,78.9l-0.7,2.7
		L778.9,1199.2z"
            />
            {/* TrunkCover */}
            <path
              onClick={() => userClick("TrunkCover")}
              style={{
                fill:
                  this.filterAction("TrunkCover").Amount > 0 ? "#f73838" : null,
              }}
              className="st8"
              d="M420.5,1267.4c-26.1-3.1-53.9-11-78.4-22.4l-9.3-4.4l0.6-5c0.4-2.8,1.7-10.7,3-17.6c1.4-6.9,3.6-19,5.1-27
		s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.7-20.1,5-27c1.3-6.9,3.5-19,5-27s3.8-20.1,5.1-26.9c1.3-6.8,2.4-13.5,2.4-14.7
		c0-2.8,1.1-3.2,25-7.9c32.6-6.5,31.8-6.5,122.4-6.5c67,0,84.2,0.3,92.7,1.5c16.5,2.3,47.4,8.9,49.2,10.5c0.4,0.3,1.6,5.6,2.6,11.6
		c1.1,6,2.6,14.5,3.5,18.9c0.8,4.4,2.6,14.1,4,21.5c1.4,7.4,3.6,19.6,5,27c1.4,7.4,3.6,19.6,5,27c1.4,7.4,3.6,19.6,5,27
		c1.4,7.4,3.7,20,5.1,28c1.5,8,3.8,20.1,5.1,27l2.5,12.4l-2.2,1.7c-4.2,3.1-22.4,11.8-32.4,15.3c-12.1,4.4-27.4,8.1-41.5,10.3
		C605.1,1269,439,1269.6,420.5,1267.4z M672,1184.6c0-23.7-0.3-30.3-2-39.8c-3.4-19.6-11-50.7-21.7-89.3l-2.8-10l-5-1.3
		c-2.8-0.6-13.3-2.7-23.5-4.5l-18.5-3.2h-85h-85l-21.5,3.3c-11.8,1.8-21.8,3.6-22.2,4c-0.3,0.4-1.8,5.2-3.3,10.7
		c-5.7,21.3-9.8,37.2-11,42.5c-0.7,3-2,8.4-2.8,12c-8.1,33.5-9.8,45.9-10.4,75.2c-0.3,14.1-0.3,26.4,0,27.2
		c0.6,1.4,16.7,1.6,157.7,1.6h157V1184.6z"
            />
            <path
              className="st8"
              d="M363.4,1207.5c-0.4-0.8-0.4-14-0.1-29.2l0.4-27.8l4.2-19.5c5.2-24.6,6.6-30.6,13.5-57c6.5-25.2,6.7-26,7.1-26
		c0.2,0,3.9-0.7,8.2-1.5c25-4.8,29.2-5,117.3-5c82.3,0,83.7,0,97.5,2.3c7.7,1.2,17.6,3,22,4l7.9,1.7l1.4,4.5
		c7.5,24.7,21,80.6,23.2,96c1.1,7.5,1.4,56.5,0.4,58.1c-0.3,0.5-68.5,0.9-151.5,0.9C382,1209,363.9,1208.8,363.4,1207.5z"
            />
            <path
              className="st8"
              d="M63.5,1149.6c-11-3.6-19.8-11.4-25.2-22.4c-11.8-23.7,1.4-51.9,27.5-58.6c26.6-6.9,52.3,12.9,52.4,40.3
		c0.1,7.8-2,15.2-6.2,22.6c-3.9,6.8-9.6,11.8-18,15.9c-5.8,2.8-7.6,3.1-16.5,3.3C71.3,1150.9,66,1150.5,63.5,1149.6z"
            />
            <path
              className="st8"
              d="M938.7,1148.6c-10.2-4.3-16.2-9.2-20.7-17.1c-10.2-17.7-7.9-37.3,5.9-51.8c10.1-10.6,25.7-14.9,40.3-11.1
		c20,5.1,32.7,22.4,31.6,43c-0.4,7-1,9.4-4,15.6c-4.5,9.1-11.1,15.7-19.7,20c-6,3-7.5,3.3-17.1,3.6
		C945.7,1151,943.8,1150.8,938.7,1148.6z"
            />
            {/* LBD */}
            <path
              onClick={() => userClick("LeftBackDoor")}
              style={{
                fill:
                  this.filterAction("LeftBackDoor").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M198.4,1088.9c-5.8-1.6-11.6-8.1-18.3-20c-8.1-14.6-15.9-26.3-21-31.6c-2.3-2.3-4.1-4.9-4.1-5.8
		c0-0.8-0.7-1.5-1.6-1.5c-0.9,0-3.8-1.8-6.4-4c-9.9-8.3-27.4-17.9-47.7-26.1c-1.3-0.4-2.3-1.5-2.3-2.4c0-1.7-1.7-2-2.2-0.4
		c-0.3,1-11.3-2-29.3-8l-5-1.6l-0.3-73.2L60,841l2.2-0.5c5.6-1.3,30.8-5.7,35.3-6.1c7.7-0.7,43.5-4.4,48.2-5
		c2.4-0.3,4.5-0.9,4.8-1.5c0.8-1.2,5.2-1.2,6,0c0.3,0.5,4.5,1,9.3,1c18.1,0.1,62.4,3,71.2,4.6c5.1,1,38.3,3.4,60,4.5
		c35,1.7,52.1,2.8,52.7,3.3c0.2,0.3,0.5,19.4,0.5,42.4c0,34.5-0.4,46.5-2.2,68.8l-2.2,27l-3.6,5.5c-8.6,13.1-49.8,51.3-77.7,72.1
		c-14.9,11-33.7,23.9-35.1,23.9c-0.3,0-1.9,0.9-3.5,2c-3.3,2.4-18,7-21.8,6.9C202.7,1089.9,200.1,1089.4,198.4,1088.9z
		 M254.9,1049.8c7.1-4.3,19.8-12.5,30.5-19.8c19.1-13,44.4-36.7,50.5-47.3c7.2-12.5,8.5-27.8,7.5-89.5c-0.7-44.9-0.7-45.2-2.8-45.7
		c-1.2-0.2-15.8-0.9-32.6-1.5c-16.8-0.6-37.7-1.5-46.5-2c-12.3-0.7-16.1-0.7-16.7,0.3c-1.3,2-1,210.7,0.3,210.7
		C245.7,1055,250.1,1052.7,254.9,1049.8z"
            />
            <path
              className="st8"
              d="M249.7,1019.8c-0.4-14.5-0.7-58.8-0.7-98.5V849h8.3c9,0,64.5,2.7,74.5,3.6l6.4,0.6l-0.5,55.1
		c-0.5,61.9-0.6,63.2-7.2,73.2c-3.5,5.3-17.8,21.5-19.7,22.3c-0.4,0.2-2.9,2.1-5.5,4.3c-2.6,2.1-5.1,3.9-5.4,3.9
		c-0.4,0-2.4,1.6-4.5,3.6c-2.2,2-5.3,4.6-7,5.8c-1.8,1.1-6.7,4.6-11,7.6c-8.4,5.9-25.8,17-26.6,17
		C250.5,1046,250,1034.2,249.7,1019.8z"
            />
            {/* RBD */}
            <path
              onClick={() => userClick("RightBackDoor")}
              style={{
                fill:
                  this.filterAction("RightBackDoor").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M811.5,1087.1c-8.7-3.6-14.8-7.1-24.9-14.1c-4.3-3-8.8-6.2-10-7c-3.7-2.6-16.5-11.9-18.3-13.4
		c-1-0.8-7-5.7-13.3-10.8c-15.4-12.5-33.5-29.3-45.4-42.1c-16.3-17.6-14.9-14.2-17.7-43.2c-2.1-22.3-2.4-29.9-2.4-70.2
		c0.1-24.9,0.3-45.4,0.6-45.7c0.3-0.3,9.5-1,20.4-1.5c55-2.9,76.7-4.5,103-7.6c7.2-0.8,19.1-1.7,26.5-2c7.4-0.2,20.6-0.7,29.2-1.1
		c8.6-0.3,16.1-0.4,16.6,0c0.5,0.3,6.3,0.8,12.8,1c13.5,0.5,53.3,5.4,70.7,8.7l11.7,2.2l-0.2,74.1l-0.3,74.1l-4.5,1.3
		c-2.5,0.8-10.3,3.2-17.4,5.4c-10,3.2-13,3.8-13.6,2.8c-0.6-1-0.9-0.9-1.1,0.4c-0.3,1.2-4.8,3.6-13.2,7.2
		c-15.7,6.7-35.1,18.3-39.6,23.8c-1.9,2.2-3.1,2-3.2-0.6c-0.1-1.7-0.3-1.5-1,1.1c-0.6,1.8-3.3,6.1-6.1,9.5
		c-5.9,7-11.5,15.5-18.1,27.6c-6.5,11.8-9.6,15.9-14.6,19.7c-4,3.1-4.8,3.3-11.9,3.3C820,1089.9,817.1,1089.4,811.5,1087.1z
		 M785,948.9V843.8l-6.2,0.6c-3.5,0.3-13.5,0.8-22.3,1.1c-19.7,0.6-67.9,2.7-68.2,2.9c-0.1,0.1-0.3,22.7-0.4,50.2
		c-0.1,50.5,0.7,67.2,3.7,75.7c3.8,10.7,18.1,27.1,35.2,40.4c4.8,3.7,8.9,7,9.2,7.3c0.8,1.1,26,18.4,31.3,21.6
		c10.3,6.2,17.2,10.3,17.5,10.3C784.9,1054,785,1006.7,785,948.9z"
            />
            <path
              className="st8"
              d="M774.5,1042.8c-18.5-11.8-40.5-27.2-40.5-28.4c0-0.2,10.6-0.4,23.5-0.4H781v16c0,8.8-0.3,16-0.7,16
		C779.8,1046,777.3,1044.5,774.5,1042.8z"
            />
            <path
              className="st8"
              d="M719.7,1002.7c-10.5-9.6-18.3-18.7-22-26.1c-4-7.8-4.7-18.3-5-73.4c-0.3-46.9-0.2-49.4,1.5-50.3
		c1-0.6,2.2-0.8,2.6-0.5c0.8,0.5,75.4-2.9,81.5-3.7l2.7-0.4v81.4v81.3h-26h-26.1L719.7,1002.7z"
            />
            {/* Roof */}
            <path
              onClick={() => userClick("Roof")}
              style={{
                fill: this.filterAction("Roof").Amount > 0 ? "#f73838" : null,
              }}
              className="st8"
              d="M370.5,1027.6c1.2-11.8,2.5-42.9,3-68.1c0.3-14.8,0.8-29,1-31.5c1-8.9,0.6-126.1-0.5-152
		c-0.6-14.6-2-38.6-3-53.4c-1.1-14.8-2-27.7-2-28.7c0-2.2,3.4-2.9,32-6.6l21.5-2.8H515h92.5l20,2.8c11,1.6,22.2,3.3,24.9,3.8
		s5.1,0.9,5.4,0.9c0.2,0,0.2,4.2-0.2,9.3c-2,28-4.6,113.2-4.6,150.7c0,39.7,1.9,116.9,3.9,160.5c0.5,10.5,0.8,19.2,0.6,19.4
		c-0.3,0.2-6.9-1-14.7-2.7c-39.2-8.4-27.6-7.7-126.8-7.7h-88.5l-18,3.3c-9.9,1.8-22.8,4.3-28.7,5.6l-10.8,2.3L370.5,1027.6z
		 M582.5,840.2c8-2.9,15.3-9.4,19-16.8l3-5.9v-29v-29l-2.8-5.5c-5.5-10.7-14.3-17-26.7-19c-8.8-1.3-114.4-1.3-123,0.1
		c-8.6,1.4-14.4,4.3-20.5,10.4c-8.5,8.5-9,11.1-9,43.5v27.5l2.9,6.3c4.7,10.1,13.4,16.5,26.1,19.2c2.2,0.4,31.2,0.7,64.5,0.6
		C576,842.5,576.5,842.4,582.5,840.2z"
            />
            <path
              className="st8"
              d="M445.8,837.7c-8.3-3.2-14.5-8.8-18-16.2l-2.9-6.3l0.3-27.8c0.3-26.9,0.4-28.1,2.6-32.4
		c4.5-8.7,11.1-14.1,20.3-16.6c7.8-2,122.9-2.1,130.6,0c9.1,2.4,16,8,20.5,16.6c2.3,4.4,2.3,5.1,2.3,33.5c0,28.9,0,29-2.5,33.9
		c-3.5,6.8-10.4,12.7-18.1,15.4c-6.4,2.2-6.6,2.2-67.9,2.2C452.1,839.9,451.4,839.9,445.8,837.7z"
            />
            {/* LFD */}
            <path
              onClick={() => userClick("LeftFrontDoor")}
              style={{
                fill:
                  this.filterAction("LeftFrontDoor").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M349,835.7c-0.6-0.5-28.6-2.3-76-4.7c-11.8-0.6-25.3-1.7-30-2.5c-10.7-1.8-67.2-5.5-84.7-5.5
		c-2.3,0-3.3-0.5-3.3-1.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.8-1.5,1.8c0,1.6-2.2,2-20.7,3.6c-11.5,1-23.2,2.2-26.2,2.8
		c-2.9,0.5-6.4,0.7-7.7,0.4c-1.3-0.4-2.4-0.2-2.4,0.3s-3,1.3-6.8,1.6c-3.7,0.4-10.9,1.6-16.1,2.6c-5.1,1-9.7,1.9-10.2,1.9
		S61,777.2,61,697.6V560.1l3.3-2.5c4.5-3.4,13.3-7.2,20.9-9c3.5-0.8,7.1-1.8,8-2.1c1.3-0.5,1.8-0.2,1.8,0.9c0,0.9,0.5,1.6,1,1.6
		c0.6,0,1-0.6,1-1.4c0-0.8,0.4-1.7,0.8-2c1.4-0.8,30-4.5,42.2-5.5c17.8-1.3,41.5-0.6,58.5,1.9c26,3.9,54.4,12.1,56.7,16.4
		c0.6,1.2,7.2,12.3,14.7,24.8s14.2,24,15,25.5c0.7,1.5,3.5,6.4,6.1,10.8c7.9,13.4,39,69.4,44.2,79.5c8.1,15.8,11.3,36.4,13.8,88
		C350.1,808.4,350.1,836.7,349,835.7z M344.2,803.5c-0.6-43.1-3.7-73.7-9-88c-2.7-7.1-7.2-16.8-17.3-37
		C306.7,656.3,280,612,265.1,591c-6.9-9.9-18.6-23-20.3-23c-0.4,0-0.8,56.7-0.8,125.9c0,119.1,0.1,126,1.8,126.5
		c0.9,0.2,12.3,1.2,25.2,2.1c12.9,1,33,2.5,44.5,3.5c11.6,1,22.8,1.7,25,1.6l4-0.1L344.2,803.5z M203,806c2.4-1.5,0.7-1.9-2-0.5
		c-1.5,0.8-1.9,1.4-1,1.4C200.8,807,202.2,806.6,203,806z M95.7,675.3c-0.3-1-0.5-0.2-0.5,1.7c0,1.9,0.2,2.7,0.5,1.8
		C95.9,677.8,95.9,676.2,95.7,675.3z"
            />

            <path
              className="st8"
              d="M326.5,821.3c-3.8-0.2-20.3-1.5-36.5-2.8c-16.2-1.4-31.9-2.5-34.7-2.5H250l-0.2-103.2
		c-0.2-56.8-0.1-109.9,0.2-117.9l0.5-14.7l3.1,4.2c1.7,2.2,5.1,6.8,7.5,10.1c3.7,5,11.4,16.9,22.4,34.5
		c9.9,15.9,18.5,31.1,31.9,56.5c7.8,14.7,14.8,31.2,17.1,40.5c3.2,12.5,5.4,37.6,6.2,70.3l0.6,25.7l-2.9-0.2
		C334.8,821.7,330.4,821.5,326.5,821.3z"
            />
            {/* RFD */}
            <path
              onClick={() => userClick("RightFrontDoor")}
              style={{
                fill:
                  this.filterAction("RightFrontDoor").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M680,833.3c0.1-15.4,2.4-67,3.5-80.3c2.1-24.1,5.6-42,9.8-50.7c2.4-4.9,4.6-9,17.2-31.3
		c2.3-4.1,5.8-10.6,7.9-14.3c2-3.7,4.5-8.2,5.5-10s5.6-9.7,10.1-17.7c15.1-26.4,19-33.2,31.3-53.5c5.3-8.8,9.7-16.4,9.7-17
		c0-2.1,11.1-6.3,30-11.4c15.1-4,46.3-8.1,62.7-8.1c5.8,0,7.4,0.3,8.2,1.8c0.9,1.4,1.2,1.5,2,0.3c1.3-2,11.1-1.6,34.6,1.4
		c27.9,3.6,45.8,8.7,54.2,15.4l3.3,2.6v137.3c0,75.4-0.3,137.2-0.7,137.2c-0.3,0-5.4-0.9-11.2-1.9c-5.8-1.1-13.2-2.3-16.3-2.6
		c-4.8-0.5-5.8-1-5.8-2.6c0-2.3-1.6-2.5-2.8-0.3c-0.7,1.3-1.9,1.4-9.3,0.4c-4.6-0.7-16.7-1.9-26.9-2.8c-17.8-1.6-18.5-1.8-18.8-3.9
		c-0.4-2.8-2.2-3-2.2-0.3c0,1.6-0.7,2-3.2,2c-17.3,0-73.3,3.6-85,5.4c-5.1,0.8-19,2-30.8,2.6c-11.8,0.6-32.1,1.8-45,2.5
		C681,835.4,680,835.4,680,833.3z M705,826.6c9.1-0.8,20.8-1.7,26-2.1c23.1-1.5,50.7-3.6,52.8-4.1l2.2-0.4V693.2l-0.1-126.7
		l-5.9,6.2c-16.7,17.7-49.8,70.8-73.2,117.5C695,713.8,692.4,721.6,690,741c-3.7,29.5-5.5,87-2.7,87
		C687.9,828,695.9,827.4,705,826.6z"
            />
            <path
              className="st8"
              d="M691.4,806.8c0.4-8.4,0.9-20.7,1.1-27.3c1.2-32.9,4.2-53.1,9.7-66.5c7.2-17.6,23.8-48.7,43.1-80.7l10.9-18.3
		h12.4H781l-0.2,100.8l-0.3,100.7l-11.5,0.8c-6.3,0.4-12.2,0.8-13,0.9c-0.8,0-8.7,0.6-17.5,1.3c-8.8,0.8-20.7,1.6-26.5,2
		c-5.8,0.3-12.9,0.8-15.8,1.1l-5.4,0.6L691.4,806.8z"
            />
            <path
              className="st8"
              d="M759,610.4c0-0.7,15.9-23.4,19.5-27.9l2.5-3v15.8V611h-11C764,611,759,610.7,759,610.4z"
            />
            <path
              id="text-path"
              className="st8"
              d="M367.7,685.3c-0.4-0.8-1.2-3.9-6.1-24.3c-2.4-10-4.4-18-13.6-56.5c-2.2-9.3-5.1-21.5-6.5-27
		c-5.7-23.5-5.9-24.7-4.4-25.6c0.8-0.4,3.6-1.3,6.4-1.9c2.7-0.6,9.5-2.2,15-3.5c36.1-8.7,50.8-10.5,84.9-10.5
		c24,0,27.1,0.2,28.8,1.7c1.5,1.3,2.1,1.4,2.7,0.4c0.6-0.9,5.9-1.2,22.7-1.1c48,0.2,93.5,1,94.4,1.5c0.5,0.3,1.8,0.2,2.8-0.4
		c2.9-1.5,35.8,0.6,52.2,3.5c13.6,2.3,28.3,5.4,42.7,9l6.1,1.6l-1,3.1c-0.5,1.8-2.3,8.4-4,14.7c-1.7,6.3-3.8,14.4-4.8,18
		c-1.9,6.7-7,25.7-10.1,37c-5.3,20-8.4,31.4-10.5,39c-1.3,4.7-3.1,11.5-4,15.3l-1.6,6.7h-3.5c-2,0-8.8-0.9-15.2-2
		c-26.8-4.5-38.8-5-126.1-5c-87.2,0-101.4,0.6-128.8,5C373.1,686.1,368.4,686.5,367.7,685.3z"
            />
            {/* LFF */}
            <path
              onClick={() => userClick("LeftFrontFender")}
              style={{
                fill:
                  this.filterAction("LeftFrontFender").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M59,537v-18h2.9c1.7,0,3.3-0.5,3.6-1.1c0.4-0.6,1.3-0.8,2-0.5c0.7,0.2,6.4-0.8,12.7-2.4
		c28.5-7.2,51.2-20.8,65-39c6.2-8.1,12.5-21.1,15-31c3.1-11.7,3.4-33.8,0.7-45.3c-6.1-25.8-23-46.5-48.4-59.4
		c-10.4-5.3-18.9-9-21.5-9.5c-1.4-0.3-5.9-1.5-10-2.6c-4.1-1.2-10.8-2.6-14.7-3.2l-7.3-1.2v-32.4c0-20.3,0.4-32.4,1-32.4
		c0.5,0,7.8-3.4,16.1-7.5c8.4-4.1,15.9-7.5,16.6-7.5c2.6,0,3.8-2.4,5-9.3c1.2-7.4,3-10.8,6.9-13.3c2.3-1.5,3.2-1.6,9.7-0.3
		c4,0.7,9.2,1.3,11.7,1.2c6.2-0.2,18.9,1.7,22.2,3.3c4.3,2.2,4.8,5.7,4.3,30.9c-0.3,12.7-0.7,24-0.8,25.3c-0.2,2.1,0.9,2.7,11.3,6.3
		c6.3,2.2,14.7,5.1,18.5,6.5c3.9,1.4,8.9,3.1,11.2,3.9l4.2,1.4l0.5-3.2c0.2-1.8,0.4-4.3,0.4-5.7s0.4-7.2,0.9-13
		c0.7-9.6,1-10.5,2.8-10.5c1.5,0,2.8,1.6,4.9,6c7.1,14.6,16.9,48.5,19.6,67.6c0.6,4.1,1.7,11.2,2.5,15.9c1.2,7.3,2.1,15.1,3.9,37
		c0.3,2.5,0.9,9.5,1.5,15.5c1,9.5,1.7,17.7,3.5,42.6c1.8,24,7.9,68.8,10.6,77.9c2.6,8.7,5,18.1,5,19.6c0,2-4,1.6-12-1.4
		c-11.6-4.3-31.5-8.5-52.5-11.3c-4.9-0.6-50.4-0.4-58,0.3c-13.1,1.3-34.4,4.8-44.1,7.4c-9.2,2.5-21.8,7.7-23,9.5
		c-0.3,0.5-1.4,0.9-2.5,0.9C59.1,555,59,554.2,59,537z"
            />

            <path
              onClick={() => userClick("RightFrontFender")}
              style={{
                fill:
                  this.filterAction("RightFrontFender").Amount > 0
                    ? "#f73838"
                    : null,
              }}
              className="st8"
              d="M962.3,550.4c-3.4-1.9-10.8-4.8-16.4-6.4c-5.6-1.6-10.6-3.4-10.9-4.1c-0.6-0.8-0.9-0.8-1.2,0.1
		c-0.3,1-3.1,0.8-12.3-0.8c-6.6-1.1-12.7-2.1-13.5-2.1s-6.7-0.5-13-1c-38-3.2-73.1,0.5-106.3,11.1c-5.3,1.7-10,2.9-10.3,2.5
		c-0.3-0.3,0.6-4.3,2-8.9c3.2-10.5,7.2-30.5,8.6-42.5c0.6-5.1,1.5-12.5,2-16.5c1.1-7.9,1.5-12.4,3-32.3c0.6-7.1,1.7-19.5,2.4-27.5
		c0.8-8,1.4-15.2,1.4-16c0.1-4.4,3.2-36.8,3.6-38c0.3-0.8,0.8-4,1.1-7c2.6-26,10.5-57.8,20.6-83.1c3.4-8.4,5.5-11.2,6.8-9
		c0.8,1.2,2.3,21,2.3,28.9c-0.1,1.7,0.3,3.2,0.8,3.2c0.4,0,3.9-1.1,7.7-2.4c3.7-1.3,14-4.9,22.7-7.9l15.9-5.6l-0.2-27.3l-0.2-27.3
		l2.3-2.1c3.9-3.5,4.9-3.8,16.8-4.6c6.3-0.3,12.6-0.9,14-1.1c1.4-0.2,4.4-0.7,6.7-1.1c3.2-0.6,4.9-0.3,7.2,1
		c3.7,2.2,4.9,4.8,6.1,13.1c0.5,3.6,1,6.6,1.2,6.7c0.5,0.4,24.6,12,31.5,15.2l6.3,2.9v31.1v31.2l-11.6,2.2c-6.3,1.2-14.1,3-17.1,4.1
		c-7.1,2.4-7.1,2.4-7.6-0.8c-0.4-2.8-0.4-2.8-0.6,0.3c-0.1,2.7-0.7,3.3-5.8,5.4c-6.7,2.6-14.5,6.8-22.3,11.8
		c-5.9,3.8-21.3,18.6-24.9,23.9c-4.4,6.5-9.4,17.9-11.6,26.7c-2.7,11.1-2.9,12.7-2.9,24.1c-0.1,32.3,12.8,57.6,38.4,75.7
		c10.5,7.3,18.7,11.4,34,16.8c5.7,2.1,22.6,6,25.6,6c6.6,0,6.4-0.5,6.4,18.1c0,12.9-0.3,16.9-1.2,16.8
		C969.1,553.8,965.7,552.2,962.3,550.4z"
            />
            {/* Hood */}
            <path
              onClick={() => userClick("Hood")}
              style={{
                fill: this.filterAction("Hood").Amount > 0 ? "#f73838" : null,
              }}
              className="st8"
              d="M337.5,542.5c1.9-4.8,0.4-7.1-1.9-2.9c-1.4,2.6-1.5-9.9-1.3-134.6l0.2-137.4l11.5-1.8c36.7-5.7,45-7,59.5-9.2
		c8.8-1.4,18.4-2.8,21.3-3.1c3-0.4,7.2-1.8,9.5-3.1c2.3-1.3,5.2-2.4,6.4-2.4c1.2,0,2.5-0.4,2.8-1c0.8-1.3,61.5-1.4,61.5-0.1
		c0,0.5-1.1,4.2-2.5,8.3c-1.4,4-2.5,7.8-2.5,8.4c0,1,15.8,13,18.3,13.9c0.7,0.3,4.6-2,8.7-5.1c4.1-3.1,8.3-6.2,9.3-6.9
		c1.7-1.2,1.7-1.7-1.1-10.1l-2.9-8.9l25.6-0.3c24.7-0.2,25.7-0.2,27.3,1.8c0.9,1.1,2.5,2,3.5,2s2.7,0.6,3.8,1.4
		c1.1,0.7,4.5,1.7,7.5,2c3,0.4,13.6,1.8,23.5,3.2c34.6,4.8,53.1,7.3,61.7,8.4l8.8,1.2l0.2,132.2c0.2,72.6,0.1,135.7-0.2,140.1
		l-0.5,8l-1.4-4.5c-0.7-2.5-1.8-5.1-2.3-5.7c-2.1-2.6-2.6-1.2-1.2,3.4c0.8,2.5,1.2,4.8,1,5c-0.2,0.2-2.1-0.5-4.2-1.6
		c-4.1-2.2-7.4-2.7-7.4-1.2c0,0.5-6.2-0.4-13.7-2c-36.9-7.8-49.4-8.3-201.8-8.4c-65.9,0-63.3-0.2-100,8.2c-9.5,2.2-15.1,3-15.3,2.4
		c-0.6-1.8-4.2-1.2-8.8,1.5l-4.5,2.7L337.5,542.5z M384,410.7c0-1.8-0.2-1.9-1-0.7c-1.3,2-1.3,4.3,0,3.5
		C383.6,413.2,384,411.9,384,410.7z"
            />
            <path
              className="st8"
              d="M64.2,462.5c-12.8-4.1-20.5-10.8-26.1-22.4c-3-6.3-3.6-9-4-15.5c-0.6-14.8,6-28.8,17.5-36.7
		c5.9-4,17.6-7.9,24-8c10.2-0.2,21.6,4.4,29.5,11.8c20.8,19.5,16.1,55-9,67.7c-6.3,3.2-15.2,5.6-20.6,5.6
		C73.3,464.9,68.2,463.8,64.2,462.5z"
            />
            <path
              className="st8"
              d="M944.3,463.5c-2.9-0.8-7.6-2.6-10.4-4c-25.1-12.8-29.8-48.3-9-67.8c7.9-7.4,19.3-12,29.5-11.8
		c6.4,0.1,18.1,4,24,8c11.5,7.9,18.1,21.9,17.5,36.7c-0.4,6.5-1,9.2-4,15.4c-5.6,11.8-13.4,18.5-26.1,22.5
		C956.9,465.3,951.9,465.5,944.3,463.5z"
            />
            <path
              className="st8"
              d="M514.7,266.9c-3.2-2.3-5.7-4.8-5.7-5.8c0-0.9,0.9-4.5,2.1-7.9l2.1-6.2h7.7h7.7l2.2,6.8
		c1.2,3.8,2.2,7.3,2.2,7.8c0,0.8-11.2,9.4-12.2,9.4C520.6,271,517.9,269.2,514.7,266.9z"
            />
          </g>
          <g id="name_3_">
            <ellipse className="st9" cx="52" cy="283.2" rx="38.3" ry="37.2" />
            <text transform="matrix(1.0297 0 0 1 27.3122 293.494)">
              <tspan x="0" y="0" className="st10 st11 st12">
                L
              </tspan>
              <tspan x="14.5" y="0" className="st10 st11 st12">
                F
              </tspan>
              <tspan x="30" y="0" className="st10 st11 st12">
                F
              </tspan>
            </text>
          </g>
          <g id="name_6_">
            <ellipse className="st13" cx="526" cy="536" rx="50.5" ry="49" />
            <text
              transform="matrix(1.0297 0 0 1 483.736 546.4252)"
              className="st11 st12"
            >
              HOOD
            </text>
          </g>
          <g id="name_5_">
            <ellipse className="st13" cx="514.9" cy="996.6" rx="50.5" ry="49" />
            <text
              transform="matrix(1.0297 0 0 1 478.6611 1007.1205)"
              className="st11 st12"
            >
              ROOF
            </text>
          </g>
          <g id="name_10_">
            <ellipse className="st13" cx="970" cy="293.5" rx="38.3" ry="37.2" />
            <text
              transform="matrix(1.0297 0 0 1 945.3305 303.7781)"
              className="st11 st12"
            >
              RFF
            </text>
          </g>
          <g id="name_11_">
            <ellipse className="st13" cx="977.9" cy="677" rx="38.3" ry="37.2" />
            <text
              transform="matrix(1.0297 0 0 1 953.1975 687.3022)"
              className="st11 st12"
            >
              RFF
            </text>
          </g>
          <g id="name_13_">
            <ellipse
              className="st13"
              cx="972"
              cy="1259.8"
              rx="38.3"
              ry="37.2"
            />
            <text
              transform="matrix(1.0297 0 0 1 947.3305 1270.084)"
              className="st11 st12"
            >
              RBF
            </text>
          </g>
          <g id="name_12_">
            <ellipse className="st13" cx="976" cy="910" rx="38.3" ry="37.2" />
            <text
              transform="matrix(1.0297 0 0 1 951.3305 920.2977)"
              className="st11 st12"
            >
              RBD
            </text>
          </g>
          <g id="name_8_">
            <ellipse
              className="st13"
              cx="405.5"
              cy="1212"
              rx="38.3"
              ry="37.2"
            />
            <text
              transform="matrix(1.0297 0 0 1 386.8466 1221.2841)"
              className="st11 st12"
            >
              TR
            </text>
          </g>
          <g id="name_9_">
            <ellipse
              className="st13"
              cx="647.5"
              cy="1350.8"
              rx="53.5"
              ry="51.9"
            />
            <text
              transform="matrix(1.0297 0 0 1 602.9887 1362.3158)"
              className="st11 st12"
            >
              TRUNK
            </text>
          </g>
          <g id="name_1_">
            <ellipse className="st13" cx="58" cy="712.1" rx="38.3" ry="37.2" />
            <text
              transform="matrix(1.0297 0 0 1 32.2305 722.3872)"
              className="st11 st12"
            >
              LFD
            </text>
          </g>
          <g id="name_2_">
            <ellipse className="st13" cx="54.9" cy="910" rx="38.3" ry="37.2" />
            <text
              transform="matrix(1.0297 0 0 1 29.2305 920.2977)"
              className="st11 st12"
            >
              LBD
            </text>
          </g>
          <g id="name_4_">
            <ellipse
              className="st13"
              cx="55.6"
              cy="1263.3"
              rx="38.3"
              ry="37.2"
            />
            <text
              transform="matrix(1.0297 0 0 1 30.9305 1273.5977)"
              className="st11 st12"
            >
              LBF
            </text>
          </g>
          {/* LFD */}
          {this.filterAction("LeftFrontDoor").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 108.1937 701.5001)"
              className="st11 st14"
            >
              {this.dentTable("LeftFrontDoor")}
              {/* A:{this.filterAction("LeftFrontDoor").Amount}|B:
              {this.filterAction("LeftFrontDoor").size} */}
            </text>
          ) : null}

          {/* LBD */}
          {this.filterAction("LeftBackDoor").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 118.1935 947.2501)"
              className="st11 st14"
            >
              {this.dentTable("LeftBackDoor")}
              {/* A:{this.filterAction("LeftBackDoor").Amount}|B:
              {this.filterAction("LeftBackDoor").size} */}
            </text>
          ) : null}
          {/* LBF */}
          {this.filterAction("LeftBackFender").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 118.1936 1242.5864)"
              className="st11 st14"
            >
              {this.dentTable("LeftBackFender")}
              {/* A:{this.filterAction("LeftBackFender").Amount}|B:
              {this.filterAction("LeftBackFender").size} */}
            </text>
          ) : null}

          {/* Hood */}
          {this.filterAction("Hood").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 475.3962 396.2372)"
              className="st11 st14"
            >
              {this.dentTable("Hood")}
              {/* A:
              {this.filterAction("Hood").Amount}|B:
              {this.filterAction("Hood").size} */}
            </text>
          ) : null}

          {/* Roof */}
          {this.filterAction("Roof").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 475.3961 920.2976)"
              className="st11 st14"
            >
              {this.dentTable("Roof")}
              {/* A:{this.filterAction("Roof").Amount}|B:
              {this.filterAction("Roof").size} */}
            </text>
          ) : null}

          {/* Trunk */}
          {this.filterAction("Trunk").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 468.8353 1318.3407)"
              className="st11 st14"
            >
              {this.dentTable("Trunk")}
              {/* A:{this.filterAction("Trunk").Amount}|B:
              {this.filterAction("Trunk").size} */}
            </text>
          ) : null}

          {/* TrunkCover */}
          {this.filterAction("TrunkCover").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 468.8352 1252.2363)"
              className="st11 st14"
            >
              {this.dentTable("TrunkCover")}
              {/* A:{this.filterAction("TrunkCover").Amount}|B:
              {this.filterAction("TrunkCover").size} */}
            </text>
          ) : null}

          {/* LFF */}
          {this.filterAction("LeftFrontFender").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 142.4257 512.4841)"
              className="st11 st14"
            >
              {this.dentTable("LeftFrontFender")}
              {/* A:{this.filterAction("LeftFrontFender").Amount}|B:
              {this.filterAction("LeftFrontFender").size} */}
            </text>
          ) : null}

          {this.filterAction("RightFrontFender").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 798.5252 512.4843)"
              className="st11 st14"
            >
              {this.dentTable("RightFrontFender")}
              {/* A:{this.filterAction("RightFrontFender").Amount}|B:
              {this.filterAction("RightFrontFender").size} */}
            </text>
          ) : null}

          {this.filterAction("RightFrontDoor").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 798.5247 687.674)"
              className="st11 st14"
            >
              {this.dentTable("RightFrontDoor")}
              {/* A:{this.filterAction("RightFrontDoor").Amount}|B:
              {this.filterAction("RightFrontDoor").size} */}
            </text>
          ) : null}

          {this.filterAction("RightBackDoor").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 798.5249 923.2979)"
              className="st11 st14"
            >
              {this.dentTable("RightBackDoor")}
              {/* A:{this.filterAction("RightBackDoor").Amount}|B:
              {this.filterAction("RightBackDoor").size} */}
            </text>
          ) : null}

          {this.filterAction("RightBackFender").size > 0 ? (
            <text
              transform="matrix(1 0 0 1 813.2872 1234.9451)"
              className="st11 st14"
            >
              {this.dentTable("RightBackFender")}
              {/* A:{this.filterAction("RightBackFender").Amount}|B:
              {this.filterAction("RightBackFender").size} */}
            </text>
          ) : null}
        </svg>
      </div>
    );
  }
}

export default Car;
